
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("al79j", function(module, exports) {
$parcel$export(module.exports, "Carousel", function () { return (parcelRequire("4L1BA")).Carousel; });
$parcel$export(module.exports, "VideoCarousel", function () { return (parcelRequire("2kLmv")).VideoCarousel; });
parcelRequire("2drdU");
parcelRequire("4L1BA");
parcelRequire("2kLmv");

});
parcelRegister("2drdU", function(module, exports) {

$parcel$export(module.exports, "ArrowButton", function () { return $ec122054541dc2de$export$15d663f77d176497; });
$parcel$export(module.exports, "PlayPauseButton", function () { return $ec122054541dc2de$export$e0201548afaa4886; });
/* carouselButtons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $aE9vI = parcelRequire("aE9vI");

var $3uZ6C = parcelRequire("3uZ6C");
const $ec122054541dc2de$var$iconButtonStyles = null;
const $ec122054541dc2de$export$15d663f77d176497 = ({ onClick: onClick, icon: icon, "aria-label": ariaLabel })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        "aria-label": ariaLabel,
        className: (0, $esG4f.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _4t3izwfg _1bsbzwfg"
        ]),
        children: icon
    });
};
const $ec122054541dc2de$export$e0201548afaa4886 = ({ onClick: onClick, isRotating: isRotating })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        onClick: onClick,
        className: (0, $esG4f.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _4t3izwfg _1bsbzwfg"
        ]),
        children: isRotating ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aE9vI))), {
            label: intl.formatMessage({
                id: "confluence.paid.lp.carousel.pause",
                defaultMessage: "Pause carousel"
            }),
            size: "small"
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uZ6C))), {
            label: intl.formatMessage({
                id: "confluence.paid.lp.carousel.play",
                defaultMessage: "Play carousel"
            }),
            size: "small"
        })
    });
};

});
parcelRegister("aE9vI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c0504678a6ffb09$var$_react = $7c0504678a6ffb09$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $7c0504678a6ffb09$var$_videoPause = $7c0504678a6ffb09$var$_interopRequireDefault((parcelRequire("2kURI")));
function $7c0504678a6ffb09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7c0504678a6ffb09$var$VidPauseIcon = (props)=>/*#__PURE__*/ $7c0504678a6ffb09$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 4h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m10 0h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $7c0504678a6ffb09$var$_videoPause.default
    }));
$7c0504678a6ffb09$var$VidPauseIcon.displayName = "VidPauseIcon";
var $7c0504678a6ffb09$var$_default = module.exports.default = $7c0504678a6ffb09$var$VidPauseIcon;

});
parcelRegister("2kURI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9dac8ccc4d1b894102a944d61ac4f665>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b398f5450b42256$var$_react = $1b398f5450b42256$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1b398f5450b42256$var$_baseNew = $1b398f5450b42256$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $1b398f5450b42256$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1b398f5450b42256$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $1b398f5450b42256$var$_react.default.createElement($1b398f5450b42256$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$1b398f5450b42256$var$VideoPauseIcon.displayName = "VideoPauseIcon";
var $1b398f5450b42256$var$_default = module.exports.default = $1b398f5450b42256$var$VideoPauseIcon;

});


parcelRegister("3uZ6C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28c392c347bb3244$var$_react = $28c392c347bb3244$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $28c392c347bb3244$var$_videoPlay = $28c392c347bb3244$var$_interopRequireDefault((parcelRequire("4GzQ1")));
function $28c392c347bb3244$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $28c392c347bb3244$var$VidPlayIcon = (props)=>/*#__PURE__*/ $28c392c347bb3244$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.963C6 4.3 7.158 3.635 8.595 4.479l11.083 6.51c.951.559.958 1.46 0 2.023z"/></svg>`
    }, props, {
        newIcon: $28c392c347bb3244$var$_videoPlay.default
    }));
$28c392c347bb3244$var$VidPlayIcon.displayName = "VidPlayIcon";
var $28c392c347bb3244$var$_default = module.exports.default = $28c392c347bb3244$var$VidPlayIcon;

});
parcelRegister("4GzQ1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92409a0bcef1d03143cf6035c99e88da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3696e25833a0c73f$var$_react = $3696e25833a0c73f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3696e25833a0c73f$var$_baseNew = $3696e25833a0c73f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3696e25833a0c73f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3696e25833a0c73f$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $3696e25833a0c73f$var$_react.default.createElement($3696e25833a0c73f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$3696e25833a0c73f$var$VideoPlayIcon.displayName = "VideoPlayIcon";
var $3696e25833a0c73f$var$_default = module.exports.default = $3696e25833a0c73f$var$VideoPlayIcon;

});



parcelRegister("4L1BA", function(module, exports) {

$parcel$export(module.exports, "Carousel", function () { return $4782b203528ec4e1$export$144901db2ea8e967; });
/* carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $d0cJX = parcelRequire("d0cJX");

var $3Bf61 = parcelRequire("3Bf61");

var $cIqek = parcelRequire("cIqek");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $2drdU = parcelRequire("2drdU");
const $4782b203528ec4e1$var$carouselSlideStyle = null;
const $4782b203528ec4e1$var$imageStyle = null;
const $4782b203528ec4e1$var$infoContainerStyle = null;
const $4782b203528ec4e1$var$textContainerStyle = null;
const $4782b203528ec4e1$var$primaryTextStyle = null;
const $4782b203528ec4e1$var$subTextStyle = null;
const $4782b203528ec4e1$var$anchorPrimaryTextStyle = null;
const $4782b203528ec4e1$var$anchorSubTextStyle = null;
const $4782b203528ec4e1$export$cabb5ccfbd60cbd4 = ({ primaryText: primaryText, description: description, imgSrc: imgSrc, imgAltText: imgAltText, id: id, stylingType: stylingType })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        role: "tabpanel",
        id: id,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: [
            stylingType === "anchor" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                image: {
                    src: imgSrc,
                    alt: ""
                },
                className: (0, $esG4f.default)([
                    "_1bsb1osq"
                ])
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $cIqek.Adg4RaisedMedia), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    src: imgSrc,
                    alt: imgAltText,
                    className: (0, $esG4f.default)([
                        "_1bsb1osq"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _195g1tcg _zulp7vkz _1tke53f4"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_k48pni7l",
                                stylingType === "anchor" && "_y3gn1h6o _syaz1hlo _ect41pz4 _1wyb1k8s _k48p1fw0 _vwz4l07h _6rth14y2"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                            },
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_k48p1nn1",
                                stylingType === "anchor" && "_y3gn1h6o _syaz1hlo _1wyb1j6v _vwz41k8s"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            },
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};
const $4782b203528ec4e1$var$carouselTabListStyle = null;
const $4782b203528ec4e1$var$dotStyle = null;
const $4782b203528ec4e1$var$currentDotStyle = null;
const $4782b203528ec4e1$var$carouselStyles = null;
const $4782b203528ec4e1$var$controlsContainerStyles = null;
const $4782b203528ec4e1$var$centeredControlsContainerStyles = null;
const $4782b203528ec4e1$var$rightAlignedControlsContainerStyles = null;
const $4782b203528ec4e1$export$144901db2ea8e967 = ({ "aria-label": ariaLabel, slides: slides, "id": carouselId, showPlayButton: showPlayButton = true, stylingType: stylingType })=>{
    const intl = (0, $f6qj2.default)();
    const cycleTime = 7000;
    const timeoutRef = (0, $iSvIT.useRef)(null);
    const tabsRef = (0, $iSvIT.useRef)({});
    const [visibleSlideIndex, _setVisibleSlideIndex] = (0, $iSvIT.useState)(0);
    const visibleSlide = slides[visibleSlideIndex];
    if (visibleSlide === undefined) throw new Error("Slide index out of bounds.");
    const setVisibleSlideIndex = (newState, moveFocus = false)=>{
        _setVisibleSlideIndex((prevState)=>{
            var _tabsRef_current_calculatedState;
            let calculatedState;
            if (typeof newState === "function") calculatedState = newState(prevState);
            else calculatedState = newState;
            moveFocus && (tabsRef === null || tabsRef === void 0 ? void 0 : (_tabsRef_current_calculatedState = tabsRef.current[calculatedState]) === null || _tabsRef_current_calculatedState === void 0 ? void 0 : _tabsRef_current_calculatedState.focus());
            return calculatedState;
        });
    };
    const moveToPreviousSlide = (moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === 0 ? slides.length - 1 : prev - 1;
        }, moveFocus);
    };
    const moveToNextSlide = (0, $iSvIT.useCallback)((moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === slides.length - 1 ? 0 : prev + 1;
        }, moveFocus);
    }, [
        slides.length
    ]);
    const [isRotating, setIsRotating] = (0, $iSvIT.useState)(true);
    const stopRotating = ()=>{
        (timeoutRef === null || timeoutRef === void 0 ? void 0 : timeoutRef.current) !== null && window.clearInterval(timeoutRef.current);
        setIsRotating(false);
    };
    const startRotating = ()=>{
        timeoutRef.current = window.setInterval(()=>{
            moveToNextSlide();
        }, cycleTime);
        setIsRotating(true);
    };
    const toggleRotating = ()=>{
        isRotating ? stopRotating() : startRotating();
    };
    (0, $iSvIT.useEffect)(startRotating, [
        moveToNextSlide
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                moveToNextSlide(true);
                break;
            case "ArrowLeft":
                moveToPreviousSlide(true);
                break;
            case "Home":
                setVisibleSlideIndex(0, true);
                break;
            case "End":
                setVisibleSlideIndex(slides.length - 1, true);
                break;
            default:
                return;
        }
        stopRotating();
        e.preventDefault();
    };
    const handleTabClick = (index)=>{
        stopRotating();
        setVisibleSlideIndex(index);
    };
    const handlePreviousClick = ()=>{
        stopRotating();
        moveToPreviousSlide();
    };
    const handleNextClick = ()=>{
        stopRotating();
        moveToNextSlide();
    };
    const getSlideId = (suffix)=>`${carouselId}-${suffix}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        "aria-label": ariaLabel,
        "aria-roledescription": "carousel",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "aria-atomic": false,
                "aria-live": isRotating ? "off" : "polite",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($4782b203528ec4e1$export$cabb5ccfbd60cbd4, (0, $6iHNw._)((0, $7Knp0._)({}, visibleSlide), {
                    id: getSlideId(visibleSlideIndex),
                    stylingType: stylingType
                }), visibleSlide.primaryText)
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _1lmceh92 _yv0e1n6q _zulpe2fx"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_nd5l1h6o _1e0c1txw _4cvr1h6o _zulp7vkz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.ArrowButton), {
                                onClick: handlePreviousClick,
                                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                    label: "",
                                    size: "medium"
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.previous.label",
                                    defaultMessage: "Previous slide"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                role: "tablist",
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.tablist.label",
                                    defaultMessage: "Choose a slide to display."
                                }),
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulp1tcg"
                                ]),
                                children: slides.map((slide, index)=>{
                                    const isVisibleTab = visibleSlideIndex === index;
                                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        "aria-controls": getSlideId(index),
                                        "aria-selected": isVisibleTab,
                                        role: "tab",
                                        "aria-label": intl.formatMessage({
                                            id: "confluence.paid.lp.carousel.tab.label",
                                            defaultMessage: `Slide {slideNumber}`
                                        }, {
                                            slideNumber: `${index + 1}`
                                        }),
                                        tabIndex: isVisibleTab ? 0 : -1,
                                        onKeyDown: handleKeyDown,
                                        onClick: ()=>handleTabClick(index),
                                        ref: (node)=>{
                                            if (node) tabsRef.current[index] = node;
                                        },
                                        className: (0, $esG4f.default)([
                                            "_2rko1ssb _80omtlke _1bsb1crf _4t3i1crf _bfhkcd5j",
                                            isVisibleTab && "_bfhkrbzz"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        }
                                    }, `${slide.primaryText}-${index}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.ArrowButton), {
                                onClick: handleNextClick,
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.next.label",
                                    defaultMessage: "Next slide"
                                }),
                                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Bf61))), {
                                    label: "",
                                    size: "medium"
                                })
                            })
                        ]
                    }),
                    showPlayButton && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_nd5lusic"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.PlayPauseButton), {
                            onClick: toggleRotating,
                            isRotating: isRotating
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("2kLmv", function(module, exports) {

$parcel$export(module.exports, "VideoCarousel", function () { return $877c7feef28df468$export$402838bbb52a01c9; });
/* videoCarousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $eDoPe = parcelRequire("eDoPe");

var $f6qj2 = parcelRequire("f6qj2");

var $d0cJX = parcelRequire("d0cJX");

var $3Bf61 = parcelRequire("3Bf61");

var $cIqek = parcelRequire("cIqek");

var $5ohHq = parcelRequire("5ohHq");

var $2drdU = parcelRequire("2drdU");
const $877c7feef28df468$var$carouselSlideStyle = null;
const $877c7feef28df468$var$infoContainerStyle = null;
const $877c7feef28df468$var$textContainerStyle = null;
const $877c7feef28df468$var$primaryTextStyle = null;
const $877c7feef28df468$var$subTextStyle = null;
const $877c7feef28df468$var$videoStyle = null;
const $877c7feef28df468$var$rightAlignedControlsContainerStyles = null;
const $877c7feef28df468$export$542984e3b3a8582e = ({ primaryText: primaryText, description: description, videoSrcMp4: videoSrcMp4, videoSrcWebm: videoSrcWebm, videoPreviewSrc: videoPreviewSrc, id: id, loop: loop, onEnded: onEnded })=>{
    const { ref: containerRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)({
        initialInView: true,
        threshold: 0.3
    });
    const videoRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    (0, $iSvIT.useEffect)(()=>{
        const videoElem = videoRef.current;
        if (!videoElem) return; // Pause the video when it's out of view
        if (!sectionIsVisible && !videoElem.paused) videoElem.pause();
         // Play the video when it's in view
        if (sectionIsVisible && videoElem.paused) {
            videoElem.currentTime = 0;
            videoElem.play().catch(()=>{});
        }
    }, [
        videoRef,
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        role: "tabpanel",
        id: id,
        ref: containerRef,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $cIqek.Adg4RaisedMedia), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
                    width: 1920,
                    height: 1080,
                    playsInline: true,
                    muted: true,
                    preload: "auto",
                    poster: videoPreviewSrc,
                    autoPlay: true,
                    loop: loop,
                    ref: videoRef,
                    onEnded: onEnded,
                    onLoadedMetadata: (videoEvent)=>{
                        try {
                            videoEvent.currentTarget.currentTime = 0; // Set currentTime to workaround Safari not autplaying
                            if (videoEvent.currentTarget.parentElement) videoEvent.currentTarget.play().catch(()=>false); // Call play() as backup to ensure the video is playing
                        } catch (error) {
                            console.log("Error calling play method on video after onCanPlay is invoked.");
                        }
                    },
                    className: (0, $esG4f.default)([
                        "_p12f1osq _4t3i1wug"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoSrcMp4,
                            type: `video/mp4`
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoSrcWebm,
                            type: `video/webm`
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _zulp7vkz _1tke53f4"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                            className: (0, $esG4f.default)([
                                "_k48p53lb _1wyba982 _vwz41i72 _1dyzzyni _6rthi2wt _ect4qlpn _so7dlb34"
                            ]),
                            style: {
                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                            },
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_k48p1nn1 _1wyb7vkz _vwz41tcg"
                            ]),
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};
const $877c7feef28df468$var$carouselTabListStyle = null;
const $877c7feef28df468$var$dotStyle = null;
const $877c7feef28df468$var$currentDotStyle = null;
const $877c7feef28df468$var$carouselStyles = null;
const $877c7feef28df468$var$controlsContainerStyles = null;
const $877c7feef28df468$var$centeredControlsContainerStyles = null;
const $877c7feef28df468$export$402838bbb52a01c9 = ({ "aria-label": ariaLabel, slides: slides, "id": carouselId })=>{
    const intl = (0, $f6qj2.default)();
    const tabsRef = (0, $iSvIT.useRef)({});
    const [visibleSlideIndex, _setVisibleSlideIndex] = (0, $iSvIT.useState)(0);
    const visibleSlide = slides[visibleSlideIndex];
    if (visibleSlide === undefined) throw new Error("Slide index out of bounds.");
    const setVisibleSlideIndex = (newState, moveFocus = false)=>{
        _setVisibleSlideIndex((prevState)=>{
            var _tabsRef_current_calculatedState;
            let calculatedState;
            if (typeof newState === "function") calculatedState = newState(prevState);
            else calculatedState = newState;
            moveFocus && (tabsRef === null || tabsRef === void 0 ? void 0 : (_tabsRef_current_calculatedState = tabsRef.current[calculatedState]) === null || _tabsRef_current_calculatedState === void 0 ? void 0 : _tabsRef_current_calculatedState.focus());
            return calculatedState;
        });
    };
    const moveToPreviousSlide = (moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === 0 ? slides.length - 1 : prev - 1;
        }, moveFocus);
    };
    const moveToNextSlide = (0, $iSvIT.useCallback)((moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === slides.length - 1 ? 0 : prev + 1;
        }, moveFocus);
    }, [
        slides.length
    ]);
    const [isRotating, setIsRotating] = (0, $iSvIT.useState)(true);
    (0, $iSvIT.useEffect)(()=>setIsRotating(true), [
        moveToNextSlide
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                moveToNextSlide(true);
                break;
            case "ArrowLeft":
                moveToPreviousSlide(true);
                break;
            case "Home":
                setVisibleSlideIndex(0, true);
                break;
            case "End":
                setVisibleSlideIndex(slides.length - 1, true);
                break;
            default:
                return;
        }
        setIsRotating(false);
        e.preventDefault();
    };
    const handleTabClick = (index)=>{
        setIsRotating(false);
        setVisibleSlideIndex(index);
    };
    const handlePreviousClick = ()=>{
        setIsRotating(false);
        moveToPreviousSlide();
    };
    const handleNextClick = ()=>{
        setIsRotating(false);
        moveToNextSlide();
    };
    const getSlideId = (suffix)=>`${carouselId}-${suffix}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        "aria-label": ariaLabel,
        "aria-roledescription": "carousel",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "aria-atomic": false,
                "aria-live": isRotating ? "off" : "polite",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($877c7feef28df468$export$542984e3b3a8582e, (0, $6iHNw._)((0, $7Knp0._)({}, visibleSlide), {
                    id: getSlideId(visibleSlideIndex),
                    loop: !isRotating,
                    onEnded: ()=>moveToNextSlide()
                }), visibleSlide.primaryText)
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _1lmceh92 _yv0e1n6q _zulpe2fx _1pfh1crf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_nd5l1h6o _1e0c1txw _4cvr1h6o _zulp7vkz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.ArrowButton), {
                                onClick: handlePreviousClick,
                                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0cJX))), {
                                    label: "",
                                    size: "medium"
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.previous.label",
                                    defaultMessage: "Previous slide"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                role: "tablist",
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.tablist.label",
                                    defaultMessage: "Choose a slide to display."
                                }),
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _zulp1tcg"
                                ]),
                                children: slides.map((slide, index)=>{
                                    const isVisibleTab = visibleSlideIndex === index;
                                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        "aria-controls": getSlideId(index),
                                        "aria-selected": isVisibleTab,
                                        role: "tab",
                                        "aria-label": intl.formatMessage({
                                            id: "confluence.paid.lp.carousel.tab.label",
                                            defaultMessage: `Slide {slideNumber}`
                                        }, {
                                            slideNumber: `${index + 1}`
                                        }),
                                        tabIndex: isVisibleTab ? 0 : -1,
                                        onKeyDown: handleKeyDown,
                                        onClick: ()=>handleTabClick(index),
                                        ref: (node)=>{
                                            if (node) tabsRef.current[index] = node;
                                        },
                                        className: (0, $esG4f.default)([
                                            "_2rko1ssb _80omtlke _1bsb1crf _4t3i1crf _bfhkcd5j",
                                            isVisibleTab && "_bfhkrbzz"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                        }
                                    }, `${slide.primaryText}-${index}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.ArrowButton), {
                                onClick: handleNextClick,
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.next.label",
                                    defaultMessage: "Next slide"
                                }),
                                icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Bf61))), {
                                    label: "",
                                    size: "medium"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_nd5lusic"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2drdU.PlayPauseButton), {
                            onClick: ()=>setIsRotating(!isRotating),
                            isRotating: isRotating
                        })
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("D0EyQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("g8Gdb")).default; });

var $g8Gdb = parcelRequire("g8Gdb");

var $hPglE = parcelRequire("hPglE");

});
parcelRegister("g8Gdb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0cf44a5c63ed9aa$export$2e2bcd8739ae039; });
/* image-checklist-side.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $7L1zQ = parcelRequire("7L1zQ");
parcelRequire("85QdM");
var $fILoL = parcelRequire("fILoL");
parcelRequire("2SXGt");
var $3yfYx = parcelRequire("3yfYx");

var $bhreu = parcelRequire("bhreu");

var $4XrxY = parcelRequire("4XrxY");
// ================================================
// CSS
// ================================================
const $d0cf44a5c63ed9aa$var$checklistWithNoPullQuoteStyle = null;
const $d0cf44a5c63ed9aa$var$titleStyles = null; // ================================================
// Rendering Functions
// ================================================
const $d0cf44a5c63ed9aa$var$HorizontalRuleMobile = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0cglyw _7n83ssan _suga1ule"
            ])
        })
    });
const $d0cf44a5c63ed9aa$var$ChecklistWithImage = ({ title: title, listItems: listItems, rawHtmlContent: rawHtmlContent, imageSrc: imageSrc, imageAlt: imageAlt, isIncludeTestimony: isIncludeTestimony = false, quoteBlurb: quoteBlurb, quoteName: quoteName, quoteCompany: quoteCompany, testimonyImageSrc: testimonyImageSrc, testimonyImageAlt: testimonyImageAlt, isShowTestimonyBorder: isShowTestimonyBorder = true, testimonyIsUsingTextQuotationMarks: testimonyIsUsingTextQuotationMarks = false, isSmallQuote: isSmallQuote = false, isIncludeHorizontalMobileRule: isIncludeHorizontalMobileRule = true })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            !isIncludeTestimony && "_xlt1zwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                layout: "4-8",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                className: (0, $esG4f.default)([
                                    "_1pfhidpf _k48pbfng _syaz1bqd _1dyzidpf _1gw8ahaf"
                                ]),
                                children: title
                            }),
                            listItems && listItems.length && /*#__PURE__*/ (0, $loA2J.jsx)((0, $3yfYx.default), {
                                listItems: listItems
                            }),
                            rawHtmlContent && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "tab-content",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))(rawHtmlContent)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Image), {
                            src: imageSrc,
                            alt: imageAlt
                        })
                    })
                ]
            }),
            isIncludeTestimony && isIncludeHorizontalMobileRule && /*#__PURE__*/ (0, $loA2J.jsx)($d0cf44a5c63ed9aa$var$HorizontalRuleMobile, {}),
            isIncludeTestimony && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    isSmallQuote ? "_1q511wqb" : "_1q517vkz"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fILoL.PullQuote), {
                    logoSrc: testimonyImageSrc,
                    logoAltText: testimonyImageAlt,
                    quoteBlurb: quoteBlurb || "",
                    quoteCompany: quoteCompany || "",
                    quoteName: quoteName || "",
                    isShowBorder: isShowTestimonyBorder,
                    isUsingTextQuotationMarks: testimonyIsUsingTextQuotationMarks,
                    isSmall: isSmallQuote
                })
            })
        ]
    });
};
var $d0cf44a5c63ed9aa$export$2e2bcd8739ae039 = $d0cf44a5c63ed9aa$var$ChecklistWithImage;

});
parcelRegister("85QdM", function(module, exports) {
$parcel$export(module.exports, "PullQuote", function () { return (parcelRequire("fILoL")).PullQuote; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("fILoL")).PullQuote; });

var $fILoL = parcelRequire("fILoL");

});
parcelRegister("fILoL", function(module, exports) {

$parcel$export(module.exports, "PullQuote", function () { return $5fda6378fc4d083a$export$f32a6ca59ed1d5d5; });
/* pull-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");

var $4XrxY = parcelRequire("4XrxY");
const $5fda6378fc4d083a$var$pullQuoteCss = null;
const $5fda6378fc4d083a$var$borderCss = null;
const $5fda6378fc4d083a$var$smallBorderCss = null;
const $5fda6378fc4d083a$var$smallWidthCss = null;
const $5fda6378fc4d083a$var$quoteCss = null;
const $5fda6378fc4d083a$var$quotationMarkStyle = {
    height: "24px"
};
const $5fda6378fc4d083a$var$quoteBlurbCss = null;
const $5fda6378fc4d083a$var$nameAndCompanyContainerCss = null;
const $5fda6378fc4d083a$var$quoteNameCss = null;
const $5fda6378fc4d083a$var$smallQuoteNameCss = null;
const $5fda6378fc4d083a$var$quoteCompanyCss = null;
const $5fda6378fc4d083a$var$smallQuoteCompanyCss = null;
const $5fda6378fc4d083a$var$pullQuoteImgContainerCss = null;
const $5fda6378fc4d083a$var$pullQuoteImgCss = null; /**
                               * @deprecated - Please use @/libraries/design/components/pull-quote instead
                               */ 
const $5fda6378fc4d083a$export$f32a6ca59ed1d5d5 = ({ logoSrc: logoSrc, logoAltText: logoAltText, quoteBlurb: quoteBlurb, quoteName: quoteName, quoteCompany: quoteCompany, isShowBorder: isShowBorder = false, isUsingTextQuotationMarks: isUsingTextQuotationMarks = false, isSmall: isSmall = false })=>{
    const isShowQuoteLogo = !!logoSrc;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "10",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1q51zwfg _85i5zwfg _1e0c1txw _2lx21bp4 _1bah1yb4 _16ng1h6o _ae4v1h6o _1lp7vrvc",
                isShowBorder && !isSmall && "_mqm2136u _179r136u",
                isShowBorder && isSmall && "_mqm21bu1 _179r1bu1",
                isSmall && "_1bsb12it _10fp1h6o"
            ]),
            children: [
                isShowQuoteLogo && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_y3gn1h6o _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _6rthzwfg _12l2idpf _1ob9idpf _1lvazwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: logoSrc || "",
                        alt: logoAltText || "",
                        className: (0, $esG4f.default)([
                            "_5ralzm06 _4t3iuuw1 _1bsb1osq _1xlo1osq _14b5mgvx _glte1wdt"
                        ])
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_y3gn1e5h"
                    ]),
                    children: [
                        !isUsingTextQuotationMarks && /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            style: $5fda6378fc4d083a$var$quotationMarkStyle,
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg",
                                alt: "Quotation mark"
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _4t3i1w8u _1bah1yb4"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                    className: (0, $esG4f.default)([
                                        isSmall ? "_syazl4fm" : "_1wybgktf _vwz41f4h _k48pb4wl _1s181f4h _17gq1ylp",
                                        isSmall ? "body-sm" : ""
                                    ]),
                                    children: [
                                        isUsingTextQuotationMarks ? "\u201C" : "",
                                        quoteBlurb,
                                        "\u201D"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: (0, $esG4f.default)([
                                                isSmall ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p9y44 _1wyb1crf _vwz4qslr _1p1dangw" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p8n31 _1wyb7vkz _vwz41tcg"
                                            ]),
                                            children: quoteName
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: (0, $esG4f.default)([
                                                isSmall ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1crf _vwz4qslr _1p1dangw" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb7vkz _vwz41tcg"
                                            ]),
                                            children: quoteCompany
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("2SXGt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3yfYx")).default; });

var $3yfYx = parcelRequire("3yfYx");

});
parcelRegister("3yfYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $500803e34bc0e53c$export$2e2bcd8739ae039; });
/* checklist.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
const $500803e34bc0e53c$var$listItemStyles = null;
const $500803e34bc0e53c$var$Checklist = ({ listItems: listItems })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_qtt8glyw _lswu1mzw _19bvgktf _19pkidpf _1mswidpf _53os1tcg _f0hdh2mm _2ts0glyw _138k1fm0 _1u82o7ao _s22yzwfg _59281o8l _rus87vkz _1vhestnw _mz937vkz _f1xm7vkz _oonc1y44 _13421l7b _3p611o8l _4fnt7vkz _1exr7vkz _ivf7r3uz _1v9r1j6v _1mmx1k8s"
        ]),
        children: listItems.map((listItem, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
                        name: "checkmarkbasic",
                        color: "#6554c0",
                        size: "xs"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: listItem
                    })
                ]
            }, index))
    });
};
var $500803e34bc0e53c$export$2e2bcd8739ae039 = $500803e34bc0e53c$var$Checklist;

});



parcelRegister("hPglE", function(module, exports) {

var $loA2J = parcelRequire("loA2J");
const $b8801b26a3dceeed$export$9a4e871e025287ef = (props)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            props.strongText ? /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                children: props.strongText
            }) : "",
            props.plainText
        ]
    });

});


parcelRegister("3fquc", function(module, exports) {

$parcel$export(module.exports, "PaidLandingTemplate", function () { return $597627ab39e74502$export$b9ca3a4496ce259; });
/* paid-landing.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $3QHAr = parcelRequire("3QHAr");

var $fovuc = parcelRequire("fovuc");

var $1ppvA = parcelRequire("1ppvA");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $kG61r = parcelRequire("kG61r");

var $kex29 = parcelRequire("kex29");
parcelRequire("8OrlP");
var $fS5dz = parcelRequire("fS5dz");

var $37w71 = parcelRequire("37w71");

var $5wOn9 = parcelRequire("5wOn9");

var $ccYBS = parcelRequire("ccYBS");

var $g8aT4 = parcelRequire("g8aT4");

var $2T8Od = parcelRequire("2T8Od");

var $ktWzt = parcelRequire("ktWzt");

var $1ZfHO = parcelRequire("1ZfHO");

var $f1BdN = parcelRequire("f1BdN");

var $ka2Mp = parcelRequire("ka2Mp");

var $l0hW2 = parcelRequire("l0hW2");
const $597627ab39e74502$var$HorizontalRule = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_179r137p"
            ]),
            style: {
                "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
            }
        })
    }); // eslint-disable-next-line complexity
const $597627ab39e74502$export$b9ca3a4496ce259 = ({ landingType: landingType, pageId: pageId, showHorizontalRule: showHorizontalRule, productNavProps: productNavProps, bannerAlertProps: bannerAlertProps, heroProps: heroProps, bannerProps: bannerProps, tabsProps: tabsProps, customSection: customSection, customHeroSection: customHeroSection, carouselHeroProps: carouselHeroProps, alternatingTextAndImageProps: alternatingTextAndImageProps, ctaProps: ctaProps, ctaWithPolyGonProps: ctaWithPolyGonProps, testimonialProps: testimonialProps, animatedJiraTourProps: animatedJiraTourProps, hideNavigationBar: hideNavigationBar, heroImageSubheader: heroImageSubheader, resultSectionDivider: resultSectionDivider, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, heroBgColor: heroBgColor = "bgWhite", auxiaResponse: auxiaResponse })=>{
    const { isUserLoggedIn: isUserLoggedIn } = (0, $5wOn9.useLoggedInUser)(); // Temporary solution to show animated hero only for logged out users on anchor pages
    // This can be removed once we implement a way to configure this via CMS
    const showAnimatedHero = !isUserLoggedIn && (pageId === "paid-lp-jsw-features" || !!heroProps.useNewHero);
    const showStaticTestimonials = !heroProps.animatedSocialBanner;
    const hasBannerAlert = bannerAlertProps ? true : false;
    const defaultPaidArgs = (0, $6iHNw._)((0, $7Knp0._)({}, heroProps), {
        animatedJiraTourProps: animatedJiraTourProps,
        subheader: heroProps.secondaryText,
        header: heroProps.headerText,
        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
        heroImageSubheader: heroImageSubheader,
        carouselHeroProps: carouselHeroProps,
        hasBannerAlert: hasBannerAlert,
        heroBgColor: heroBgColor,
        auxiaResponse: auxiaResponse
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("main", {
        id: "content",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $ccYBS.ParentScrollTracking), {
            pageId: pageId,
            scrollTrackingEnabled: pageId ? true : false,
            children: [
                !hideNavigationBar && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ppvA.ProductNavBar), (0, $7Knp0._)({}, productNavProps)),
                bannerAlertProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fovuc.default), (0, $6iHNw._)((0, $7Knp0._)({}, bannerAlertProps), {
                    hasProductNavBar: !hideNavigationBar
                })),
                customHeroSection ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $ktWzt.PaidCustomHeroSection), {
                    customHeroSection: customHeroSection
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $ka2Mp.PaidHeroSectionTypes), {
                    darkSolidTheme: heroProps.darkSolidTheme,
                    landingType: landingType,
                    heroComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f1BdN.PaidHeroSectionTemplate), (0, $7Knp0._)({}, defaultPaidArgs)),
                    showAnimatedHero: showAnimatedHero,
                    showNewHero: defaultPaidArgs.useNewHero
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $l0hW2.PaidTabsSection), (0, $7Knp0._)({}, tabsProps)),
                customSection && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ZfHO.PaidCustomSection), {
                    customSection: customSection
                }),
                showHorizontalRule && /*#__PURE__*/ (0, $loA2J.jsx)($597627ab39e74502$var$HorizontalRule, {}),
                bannerProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $37w71.SimpleImageTextSide), (0, $7Knp0._)({}, bannerProps)),
                resultSectionDivider && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_6rth1cg9"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3QHAr.Adg4SectionDivider), {
                        bgColor: resultSectionDivider.color,
                        variation: resultSectionDivider.variation
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8aT4.PaidAlternatingImageText), {
                    landingType: landingType,
                    alternatingImageTextProps: alternatingTextAndImageProps
                }),
                ctaProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $2T8Od.PaidCtaSection), {
                    ctaProps: ctaProps,
                    landingType: landingType
                }),
                ctaWithPolyGonProps && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                resultSectionDivider && "_bfhkyt3g _1pfh1cg9 _4t3iuuw1"
                            ]),
                            style: {
                                "--_1he1i5": (0, $43MIc.default)(resultSectionDivider === null || resultSectionDivider === void 0 ? void 0 : resultSectionDivider.color)
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                resultSectionDivider && "_1pfh1snh"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kG61r.ADG4CtaWithPolygonBackground), (0, $7Knp0._)({}, ctaWithPolyGonProps))
                        })
                    ]
                }),
                showStaticTestimonials && testimonialProps && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fS5dz.PaidSocialProof), (0, $7Knp0._)({}, testimonialProps)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
            ]
        })
    });
};

});
parcelRegister("8OrlP", function(module, exports) {
$parcel$export(module.exports, "PaidSocialProof", function () { return (parcelRequire("fS5dz")).PaidSocialProof; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("fS5dz")).PaidSocialProof; });

var $fS5dz = parcelRequire("fS5dz");

});
parcelRegister("fS5dz", function(module, exports) {

$parcel$export(module.exports, "PaidSocialProof", function () { return $db7309abe43fc140$export$ebcf40293fae7986; });
/* paid-social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $bhreu = parcelRequire("bhreu");
const $db7309abe43fc140$var$customerSectionStyles = null;
const $db7309abe43fc140$var$h3Styles = null;
const $db7309abe43fc140$var$containerStyles = null;
const $db7309abe43fc140$var$imageStyles = null;
const $db7309abe43fc140$var$largeLogoStyles = null;
const $db7309abe43fc140$var$smallLogoStyle = null;
const $db7309abe43fc140$export$ebcf40293fae7986 = ({ headerText: headerText, logos: logos, logoSize: logoSize = "small" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1bah1h6o _4cvr1h6o _y3gn1h6o _ca0q1j6v _u5f3idpf _n3tdviql _19bvidpf _1k9l12bs _1qwm12bs"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_1wyb1tcg _vwz411ph _k48pbfng _syaz1bqd _ca0q1j6v _u5f31j6v _n3tdviql _19bv1j6v _1moun7od _3fcw10xh"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpzb0d _4cvr1h6o _y3gn1h6o _1n261g80 _195g1wug _p12f1fra _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1xf6vrvc _fukk1fhb _e47i1j6v _ldth1j6v _bjh61j6v _1nny1j6v"
                ]),
                children: logos === null || logos === void 0 ? void 0 : logos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i66rk _bna71osq _mezj1wug",
                            logoSize === "small" ? "_1u7oldb6" : "_19rt1w81 _1u7o16xz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            image: (0, $7Knp0._)({}, inlineLogo)
                        })
                    }, index))
            })
        ]
    });
};
$db7309abe43fc140$export$ebcf40293fae7986.displayName = "PaidSocialProof";

});


parcelRegister("g8aT4", function(module, exports) {

$parcel$export(module.exports, "PaidAlternatingImageText", function () { return $aa0dd19b03b4e303$export$45a2817884af97dc; });
/* paid-alternating-image-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6wqcV = parcelRequire("6wqcV");
const $aa0dd19b03b4e303$var$anchorPageStyles = null;
const $aa0dd19b03b4e303$var$confluenceAnchorStyles = null;
const $aa0dd19b03b4e303$export$45a2817884af97dc = ({ alternatingImageTextProps: alternatingImageTextProps, landingType: landingType })=>{
    if (!alternatingImageTextProps) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            landingType === "jira-software-anchor" && "_7e8vgktf",
            landingType === "confluence-rebranded-anchor" && "_vussviql _1b6r1fw0 _p1061k92"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6wqcV.default), (0, $7Knp0._)({}, alternatingImageTextProps))
    });
};
$aa0dd19b03b4e303$export$45a2817884af97dc.displayName = "PaidAlternatingImageText";

});
parcelRegister("6wqcV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54e11afe56605a57$export$2e2bcd8739ae039; });
/* three-alternating-image-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $37w71 = parcelRequire("37w71");
// eslint-disable-next-line complexity
const $54e11afe56605a57$var$ThreeAlternatingImageText = ({ backgroundColor: backgroundColor, backgroundImage: backgroundImage, horizontalRuleColor: horizontalRuleColor, imageWidth: imageWidth, rowHeaderType: rowHeaderType = "h2", rowPropsOdd: rowPropsOdd = "6-6", rowPropsEven: rowPropsEven = "6-6", imageTextSideRowOnePadding: imageTextSideRowOnePadding, imageTextSideRowOnePaddingBelowLargeScreen: imageTextSideRowOnePaddingBelowLargeScreen, rowOneHeader: rowOneHeader, rowOneLozenge: rowOneLozenge, rowOneBody: rowOneBody, rowOneImageLink: rowOneImageLink, rowOneImageAltText: rowOneImageAltText, rowOneImagePosition: rowOneImagePosition = "left", rowOneEyebrowText: rowOneEyebrowText, imageTextSideRowTwoPadding: imageTextSideRowTwoPadding, imageTextSideRowTwoPaddingBelowLargeScreen: imageTextSideRowTwoPaddingBelowLargeScreen, rowTwoHeader: rowTwoHeader, rowTwoLozenge: rowTwoLozenge, rowTwoBody: rowTwoBody, rowTwoImageLink: rowTwoImageLink, rowTwoImageAltText: rowTwoImageAltText, rowTwoImagePosition: rowTwoImagePosition = "right", rowTwoEyebrowText: rowTwoEyebrowText, imageTextSideRowThreePadding: imageTextSideRowThreePadding, imageTextSideRowThreePaddingBelowLargeScreen: imageTextSideRowThreePaddingBelowLargeScreen, rowThreeHeader: rowThreeHeader, rowThreeLozenge: rowThreeLozenge, rowThreeBody: rowThreeBody, rowThreeImageLink: rowThreeImageLink, rowThreeImageAltText: rowThreeImageAltText, rowThreeImagePosition: rowThreeImagePosition = "left", rowThreeEyebrowText: rowThreeEyebrowText, imageTextSideRowFourPadding: imageTextSideRowFourPadding, imageTextSideRowFourPaddingBelowLargeScreen: imageTextSideRowFourPaddingBelowLargeScreen, rowFourHeader: rowFourHeader, rowFourLozenge: rowFourLozenge, rowFourBody: rowFourBody, rowFourImageLink: rowFourImageLink, rowFourImageAltText: rowFourImageAltText = "Alt Text", rowFourImagePosition: rowFourImagePosition, rowFourEyebrowText: rowFourEyebrowText })=>{
    const imageWidthValue = imageWidth !== null && imageWidth !== void 0 ? imageWidth : "550px";
    const imageTextSideRowOnePaddingValue = imageTextSideRowOnePadding !== null && imageTextSideRowOnePadding !== void 0 ? imageTextSideRowOnePadding : "64px 0 16px";
    const imageTextSideRowOnePaddingBelowLargeScreenValue = imageTextSideRowOnePaddingBelowLargeScreen !== null && imageTextSideRowOnePaddingBelowLargeScreen !== void 0 ? imageTextSideRowOnePaddingBelowLargeScreen : "64px 0 16px";
    const imageTextSideRowTwoPaddingValue = imageTextSideRowTwoPadding !== null && imageTextSideRowTwoPadding !== void 0 ? imageTextSideRowTwoPadding : "32px 0";
    const imageTextSideRowTwoPaddingBelowLargeScreenValue = imageTextSideRowTwoPaddingBelowLargeScreen !== null && imageTextSideRowTwoPaddingBelowLargeScreen !== void 0 ? imageTextSideRowTwoPaddingBelowLargeScreen : "16px 0";
    const imageTextSideRowThreePaddingValue = imageTextSideRowThreePadding !== null && imageTextSideRowThreePadding !== void 0 ? imageTextSideRowThreePadding : "16px 0 64px";
    const imageTextSideRowThreePaddingBelowLargeScreenValue = imageTextSideRowThreePaddingBelowLargeScreen !== null && imageTextSideRowThreePaddingBelowLargeScreen !== void 0 ? imageTextSideRowThreePaddingBelowLargeScreen : "16px 0 64px";
    const imageTextSideRowFourPaddingValue = imageTextSideRowFourPadding !== null && imageTextSideRowFourPadding !== void 0 ? imageTextSideRowFourPadding : "16px 0 64px";
    const imageTextSideRowFourPaddingBelowLargeScreenValue = imageTextSideRowFourPaddingBelowLargeScreen !== null && imageTextSideRowFourPaddingBelowLargeScreen !== void 0 ? imageTextSideRowFourPaddingBelowLargeScreen : "16px 0 64px";
    const ThreeAlternatingImageTextStyles = null;
    const isShowHorizontalRule = !!horizontalRuleColor;
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_j2qggma6 _cotpidpf _u5lc1ule _hm0s1wug _ceny1wug _o4bz1oh5 _17xw1bqd _vussviql _i80qidpf _1y3uidpf _vq3z1tcg _1x7sidpf _18m21038 _27c31k8s _e87pidpf _6mt8idpf _vljsdlk8 _1j6nidpf _yza7idpf _1vbdidpf _13r21ylp _dcnaidpf _vbkqidpf _9by51q87 _1of01mpp _5wk3idpf _1fus1j99 _19y1l3tq _1ltr7ip2 _1g391fux _amtq1col _kju2v4do _1djgx7vm _1drv1abn"
        ]),
        style: {
            "--_bwa4xl": (0, $43MIc.default)(imageWidthValue),
            "--_1cdekw0": (0, $43MIc.default)(horizontalRuleColor),
            "--_1o5bebe": (0, $43MIc.default)(imageTextSideRowOnePaddingValue),
            "--_1dlh24j": (0, $43MIc.default)(imageTextSideRowOnePaddingBelowLargeScreenValue),
            "--_1nsshok": (0, $43MIc.default)(imageTextSideRowTwoPaddingValue),
            "--_1e6od0m": (0, $43MIc.default)(imageTextSideRowTwoPaddingBelowLargeScreenValue),
            "--_1u1sozo": (0, $43MIc.default)(imageTextSideRowThreePaddingValue),
            "--_1div133": (0, $43MIc.default)(imageTextSideRowThreePaddingBelowLargeScreenValue),
            "--_1rnt45i": (0, $43MIc.default)(imageTextSideRowFourPaddingValue),
            "--_15kis35": (0, $43MIc.default)(imageTextSideRowFourPaddingBelowLargeScreenValue)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_bfhkaxbu _1itk1u11",
                "background-side-by-side"
            ]),
            style: {
                "--_1ly4823": (0, $43MIc.default)(backgroundColor),
                "--_1jwom28": (0, $43MIc.default)(backgroundImage)
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $37w71.default), {
                    headerType: rowHeaderType,
                    headerText: rowOneHeader,
                    lozenge: rowOneLozenge,
                    bodyText: rowOneBody,
                    imageLink: rowOneImageLink,
                    imageAltText: rowOneImageAltText,
                    imagePosition: rowOneImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-1",
                    eyebrowText: rowOneEyebrowText,
                    rowProps: rowPropsOdd
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $37w71.default), {
                    headerType: rowHeaderType,
                    headerText: rowTwoHeader,
                    lozenge: rowTwoLozenge,
                    bodyText: rowTwoBody,
                    imageLink: rowTwoImageLink,
                    imageAltText: rowTwoImageAltText,
                    horizontalRule: isShowHorizontalRule,
                    imagePosition: rowTwoImagePosition,
                    className: "image-text-side-row-2",
                    eyebrowText: rowTwoEyebrowText,
                    rowProps: rowPropsEven
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $37w71.default), {
                    headerType: rowHeaderType,
                    headerText: rowThreeHeader,
                    lozenge: rowThreeLozenge,
                    bodyText: rowThreeBody,
                    imageLink: rowThreeImageLink,
                    imageAltText: rowThreeImageAltText,
                    imagePosition: rowThreeImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-3",
                    eyebrowText: rowThreeEyebrowText,
                    rowProps: rowPropsOdd
                }),
                rowFourImageLink ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $37w71.default), {
                    headerType: rowHeaderType,
                    headerText: rowFourHeader,
                    lozenge: rowFourLozenge,
                    bodyText: rowFourBody,
                    imageLink: rowFourImageLink,
                    imageAltText: rowFourImageAltText,
                    imagePosition: rowFourImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-4",
                    eyebrowText: rowFourEyebrowText,
                    rowProps: rowPropsEven
                }) : null
            ]
        })
    });
};
$54e11afe56605a57$var$ThreeAlternatingImageText.displayName = "ThreeAlternatingImageText";
var $54e11afe56605a57$export$2e2bcd8739ae039 = $54e11afe56605a57$var$ThreeAlternatingImageText;

});


parcelRegister("2T8Od", function(module, exports) {

$parcel$export(module.exports, "PaidCtaSection", function () { return $7d0f18c817ee6502$export$5e5db24264a78d; });
/* paid-cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("bseXG");
var $oAjmY = parcelRequire("oAjmY");
const $7d0f18c817ee6502$var$ctaStyles = {
    "jira-software": "_syaz1m8h _12vemgnk _ouxl1ssb _1lrw1dfr _1itk14uh _1dhs103n",
    "jira-software-anchor": "_syazr3uz _bfhkoelr _6vsiidpf _t0odidpf _mqkjidpf _xz03idpf",
    "jira-software-rebranded-anchor": "_syazr3uz _bfhkoelr _6vsiidpf _t0odidpf _mqkjidpf _xz03idpf",
    "jira-service-management": "_syazu67f _1itkj4zg _ouxl1ssb _1lrw1dfr _12vemgnk",
    "jira-service-management-anchor": "_syazu67f _1itk1k2f _ouxl1ssb _1lrw1dfr _12vemgnk",
    "confluence-paid": "_syazu67f _1itkuuyn _ouxl1ssb _1lrw1dfr _12vemgnk",
    "confluence-anchor": "_1itk1gd4 _ouxl1ssb _12vemgnk _1lrw1dfr _ol8u1keg _1rmvwbzg _1f9f995e _r2cimgnk _u6yg1f51",
    "confluence-rebranded-anchor": "_1itk1gd4 _ouxl1ssb _12vemgnk _1lrw1dfr _ol8u1keg _1rmvwbzg _1f9f995e _r2cimgnk _u6yg1f51"
};
const $7d0f18c817ee6502$export$5e5db24264a78d = ({ ctaProps: ctaProps, landingType: landingType })=>{
    const { layout: ctaLayout = "10" } = ctaProps, otherCtaProps = (0, $akGnX._)(ctaProps, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            $7d0f18c817ee6502$var$ctaStyles[landingType]
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: ctaLayout,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $oAjmY.PaidCtaPrimary), (0, $7Knp0._)({}, otherCtaProps))
        })
    });
};
$7d0f18c817ee6502$export$5e5db24264a78d.displayName = "PaidCta";

});
parcelRegister("bseXG", function(module, exports) {
$parcel$export(module.exports, "PaidCtaPrimary", function () { return (parcelRequire("oAjmY")).PaidCtaPrimary; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("oAjmY")).PaidCtaPrimary; });

var $oAjmY = parcelRequire("oAjmY");

});
parcelRegister("oAjmY", function(module, exports) {

$parcel$export(module.exports, "PaidCtaPrimary", function () { return $ff0bde82509c25d4$export$a88d1ab51f344f2e; });
/* paid-cta-primary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("ebLO8");
var $hd9uO = parcelRequire("hd9uO");
const $ff0bde82509c25d4$var$ctaSectionBaseStyle = null;
const $ff0bde82509c25d4$export$a88d1ab51f344f2e = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_xgyx1k8s _1xcsahaf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hd9uO.CTAPrimary), (0, $7Knp0._)({
            className: "cta-primary",
            backgroundProperties: {
                /* this is deprecated, but need it temporarily to override current behavior */ textColor: "n0"
            }
        }, props))
    });
};

});
parcelRegister("ebLO8", function(module, exports) {
$parcel$export(module.exports, "CTAPrimary", function () { return (parcelRequire("hd9uO")).CTAPrimary; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("hd9uO")).CTAPrimary; });

var $hd9uO = parcelRequire("hd9uO");

});
parcelRegister("hd9uO", function(module, exports) {

$parcel$export(module.exports, "CTAPrimary", function () { return $7410bb543046794d$export$2803c38b17523474; });
/* cta-primary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $ix9oc = parcelRequire("ix9oc");

var $4XrxY = parcelRequire("4XrxY");
const $7410bb543046794d$var$ctaPrimaryStyle = null;
const $7410bb543046794d$export$2803c38b17523474 = ({ headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, backgroundProperties: backgroundProperties })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), (0, $6iHNw._)((0, $7Knp0._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916oxwj _jti51ul9 _xjyr1wug _2thuidpf _hbr31wug",
                className
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "primary-cta-content",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                        isCentered: true,
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        bodyText: bodyText,
                        ctaProps: ctaProps
                    }),
                    footNoteText ? /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "footnote-text",
                        children: footNoteText
                    }) : null
                ]
            })
        })
    }));
};

});





parcelRegister("ktWzt", function(module, exports) {

$parcel$export(module.exports, "PaidCustomHeroSection", function () { return $f06ef0f0309e1767$export$a51999b742dcc5f1; });

var $loA2J = parcelRequire("loA2J");
const $f06ef0f0309e1767$export$a51999b742dcc5f1 = ({ customHeroSection: // eslint-disable-next-line react/prop-types
customHeroSection })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: customHeroSection
    });
};
$f06ef0f0309e1767$export$a51999b742dcc5f1.displayName = "CustomHero";

});

parcelRegister("1ZfHO", function(module, exports) {

$parcel$export(module.exports, "PaidCustomSection", function () { return $b2614cd9a62213b6$export$4781d68a90c3d141; });

var $loA2J = parcelRequire("loA2J");
const $b2614cd9a62213b6$export$4781d68a90c3d141 = ({ customSection: // eslint-disable-next-line react/prop-types
customSection })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: customSection
    });
};
$b2614cd9a62213b6$export$4781d68a90c3d141.displayName = "Custom";

});

parcelRegister("f1BdN", function(module, exports) {

$parcel$export(module.exports, "PaidHeroSectionTemplate", function () { return $da2112968d5b09bb$export$b2d485e7a33c4d4a; });
/* paid-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $eVwxl = parcelRequire("eVwxl");

var $7L1zQ = parcelRequire("7L1zQ");
parcelRequire("al79j");
var $2kLmv = parcelRequire("2kLmv");
var $4L1BA = parcelRequire("4L1BA");

var $gZ0A3 = parcelRequire("gZ0A3");

var $bhreu = parcelRequire("bhreu");

var $5ohHq = parcelRequire("5ohHq");

var $cQk7Y = parcelRequire("cQk7Y");

var $1syhO = parcelRequire("1syhO");

var $5KXGt = parcelRequire("5KXGt");

var $f2a5L = parcelRequire("f2a5L");
const $da2112968d5b09bb$var$formColumn = null;
const $da2112968d5b09bb$var$formColumnWithEyelash = null;
const $da2112968d5b09bb$var$HeaderEyelashStyle = null;
const $da2112968d5b09bb$var$contentStyle = null;
const $da2112968d5b09bb$var$withAnimation = null;
const $da2112968d5b09bb$var$signupFormContainer = null;
const $da2112968d5b09bb$var$headingBasicStyles = null;
const $da2112968d5b09bb$var$heavyFontWeightStyles = null;
const $da2112968d5b09bb$var$subheaderStyles = null;
const $da2112968d5b09bb$var$whiteFontColor = null;
const $da2112968d5b09bb$var$subheaderStylesWithEyelash = null;
const $da2112968d5b09bb$var$imgContainer = null;
const $da2112968d5b09bb$var$staticImageContainer = null;
const $da2112968d5b09bb$var$animationHeroContainer = null;
const $da2112968d5b09bb$var$carouselContainerStyles = null;
const $da2112968d5b09bb$var$squaresContainer = null;
const $da2112968d5b09bb$var$squareOne = null;
const $da2112968d5b09bb$var$squareTwo = null;
const $da2112968d5b09bb$var$eyelashStyle = null;
const $da2112968d5b09bb$var$underlineStyles = null;
const $da2112968d5b09bb$var$strokeRight = null;
const $da2112968d5b09bb$var$accentImgStyles = null;
const $da2112968d5b09bb$var$AnimatedJiraTourStyles = null;
const $da2112968d5b09bb$var$heroImageSubheaderStyles = null;
const $da2112968d5b09bb$var$Squares = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswstnw _1bsb1osq _4t3i1lk2 _1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _152tidpf _rjxpidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    width: "311",
                    height: "220",
                    viewBox: "0 0 311 220",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M7.34559 1.71298L310.956 0.712733L305.579 218.935L0.637246 219.618L7.34559 1.71298Z",
                        fill: "#FFA900"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _u7coidpf _1e02idpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    width: "252",
                    height: "219",
                    viewBox: "0 0 252 219",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M2.76007 0.226074H251.614V212.007L0.0842285 218.146L2.76007 0.226074Z",
                        fill: "#82B536"
                    })
                })
            })
        ]
    });
};
const $da2112968d5b09bb$var$EyeLash = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        className: (0, $esG4f.default)([
            "_y44vlrv9 _kqswh2mm",
            "_kqswstnw _1e0c1o8l _152t1mi1 _1e02bx3o _1bsb1wpv _4t3ickbl _1s4pd6z3 _1kne1wpv _1rfm1f4h _tnru1u1b",
            "eyelash"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/f0scafs8p034p4uxb1r3f84m05g8s742.svg",
            alt: "",
            width: 99,
            height: 50
        }
    });
};
const $da2112968d5b09bb$var$Scribble = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        className: (0, $esG4f.default)([
            "_y44vlrv9 _kqswh2mm",
            "_4t3i7vkz _1bsbl1r9 _6rth7vkz _dh1a1e5h _ag851e5h",
            "scribble"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4g12qeh147330006huh36yys682jpa05.svg",
            alt: "",
            width: 90,
            height: 16
        }
    });
};
const $da2112968d5b09bb$var$AnimationWrapper = ({ lottieAnimationPromise: lottieAnimationPromise, riveAnimation: RiveAnimation })=>{
    const [lottieAnimationData, setLottieAnimationData] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        (async ()=>{
            if (lottieAnimationPromise && !RiveAnimation) {
                const lottieAnimation = await lottieAnimationPromise;
                setLottieAnimationData(lottieAnimation);
            }
        })();
    }, [
        RiveAnimation,
        lottieAnimationPromise
    ]);
    if (RiveAnimation) return /*#__PURE__*/ (0, $loA2J.jsx)(RiveAnimation, {});
    else if (lottieAnimationData) return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eVwxl))), {
        options: {
            loop: false,
            autoplay: true,
            animationData: lottieAnimationData,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
            }
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "data-testid": "default-animation",
        viewBox: "0 0 600 350",
        width: "600",
        height: "350",
        style: {
            width: "100%"
        }
    });
}; // eslint-disable-next-line complexity
const $da2112968d5b09bb$export$b2d485e7a33c4d4a = ({ header: header, subheader: subheader, image: image, darkSolidTheme: darkSolidTheme, showAnimatedHero: showAnimatedHero, carouselHeroProps: carouselHeroProps, animatedJiraTourProps: animatedJiraTourProps, heroImageSubheader: heroImageSubheader, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, showScribble: showScribble, showEyeLash: showEyeLash, animation: animation, hasBannerAlert: hasBannerAlert = false, heroBgColor: heroBgColor = "bgWhite", showFourSocialButtons: showFourSocialButtons, auxiaResponse: auxiaResponse })=>{
    var _this, _carouselHeroProps_slides;
    // the default behavior is to show the animated hero image based on darkSolidTheme
    // however we can override this behavior if showAnimatedHero is explicitly set
    const showAnimated = showAnimatedHero !== undefined ? showAnimatedHero : !darkSolidTheme;
    (0, $iSvIT.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $1syhO.getLocalStorage)((0, $cQk7Y.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $cQk7Y.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _zulpzwfg _85i5gad4 _1bah1h6o _4cvr1h6o _ogq01wqb _p56c1wqb _na0i1bp4 _v736zwfg _chtuzwfg",
            animation && "_na0i1sxn",
            !hasBannerAlert && "_1q512to5"
        ]),
        style: {
            "--_1grn0ad": (0, $43MIc.default)(darkSolidTheme ? "60px" : "40px")
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _10jxdgin _dh1a1h6o",
                    showEyeLash && "_10jx1kx4",
                    heroBgColor !== "bgWhite" && "_syazcd5j"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            showEyeLash && "_kqswh2mm"
                        ]),
                        children: [
                            showEyeLash && /*#__PURE__*/ (0, $loA2J.jsx)($da2112968d5b09bb$var$EyeLash, {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                className: (0, $esG4f.default)([
                                    "_1dyzidpf _1pfhidpf _6rthidpf _k48pbfng _1wybviql _vwz410nf _y3gn1h6o _uj6k1e5h _1hwfyn4p _cr9zzz36 _1awl7vkz _h60i1wto _s3b91k7u _1qir1tcg",
                                    hasRebrandedSignupFormStyles && "_k48p9y44"
                                ]),
                                children: header
                            })
                        ]
                    }),
                    darkSolidTheme && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_6rth7vkz _y3gn1h6o _uj6k1e5h",
                            heroBgColor !== "bgWhite" && "_syazcd5j"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: subheader
                    }),
                    showScribble && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_syaz1hlo _ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _1mjb1txw _o5kc1e5h"
                                ]),
                                style: {
                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: subheader
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)($da2112968d5b09bb$var$Scribble, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_p12f1feq _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5KXGt.ClientOnly), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f2a5L.PaidAccountCreation), {
                                darkSolidTheme: darkSolidTheme,
                                showFourSocialButtons: showFourSocialButtons,
                                auxiaResponse: auxiaResponse
                            })
                        })
                    })
                ]
            }),
            animation && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($da2112968d5b09bb$var$AnimationWrapper, (0, $7Knp0._)({}, animation))
            }),
            showAnimated && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1h1th1c8 _4t3i1wug _1tket94y _1bsb1osq _1ul91c3h _p12f1c3h _1e0c1txw _4cvr1h6o _1bah1h6o _s6371ogm _1y8o1c3h _1mjbglyw _ca0q1ul9 _u5f31ul9 _n3td1ul9 _19bv1ul9"
                ]),
                children: [
                    (darkSolidTheme || hasRebrandedSignupFormStyles) && /*#__PURE__*/ (0, $loA2J.jsx)($da2112968d5b09bb$var$Squares, {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gZ0A3.AnimatedJiraTour), (0, $6iHNw._)((0, $7Knp0._)({}, animatedJiraTourProps), {
                        className: (0, $esG4f.default)([
                            "_kqswstnw _152t16gx _rjxp9by0 _1e029by0 _u7co16gx _1pbyzo7u"
                        ])
                    }))
                ]
            }),
            carouselHeroProps ? ((_this = (_carouselHeroProps_slides = carouselHeroProps.slides) === null || _carouselHeroProps_slides === void 0 ? void 0 : _carouselHeroProps_slides[0]) === null || _this === void 0 ? void 0 : _this["videoSrcMp4"]) ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2kLmv.VideoCarousel), (0, $7Knp0._)({}, carouselHeroProps))
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4L1BA.Carousel), (0, $7Knp0._)({}, carouselHeroProps))
            }) : (image || heroImageSubheader) && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    showAnimated ? "_1e0cglyw _1mjb1txw _o5kc1h6o _na0i1bp4" : "_1bsbstmo _1wpz1h6o _1mjb1txw _o5kc1h6o _na0i1bp4 _1rfm1wug"
                ]),
                children: [
                    image && /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: image,
                        style: {
                            maxWidth: "100%",
                            height: "auto"
                        }
                    }),
                    heroImageSubheader && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))(heroImageSubheader)
                        },
                        className: (0, $esG4f.default)([
                            "_ca0qidpf _u5f39by0 _n3tdidpf _19bv9by0",
                            heroBgColor !== "bgWhite" && "_syazcd5j"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        }
                    })
                ]
            })
        ]
    });
};
$da2112968d5b09bb$export$b2d485e7a33c4d4a.displayName = "PaidHero";

});
parcelRegister("gZ0A3", function(module, exports) {

$parcel$export(module.exports, "AnimatedJiraTour", function () { return $c0a9533d02a38d35$export$d6ccd257c217bac1; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $el0Oi = parcelRequire("el0Oi");

var $85mql = parcelRequire("85mql");

var $8XM36 = parcelRequire("8XM36");

var $4MTGk = parcelRequire("4MTGk");
const $c0a9533d02a38d35$export$d6ccd257c217bac1 = (props)=>{
    const [{ animationStep: animationStep }, { setMessages: setMessages }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    const isCardTyping = (0, $iSvIT.useMemo)(()=>{
        return animationStep === (0, $85mql.AnimationSteps).CARD_TYPING;
    }, [
        animationStep
    ]);
    const intl = (0, $f6qj2.default)();
    const messages = {
        toDo: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.toDo",
            defaultMessage: "To Do"
        }),
        inProgress: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgress",
            defaultMessage: "In Progress"
        }),
        done: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.done",
            defaultMessage: "Done"
        }),
        todoStaticLabel: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.todoStaticLabel",
            defaultMessage: "Design AI shopping suggestions for homepage"
        }),
        inProgStaticLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgStaticLabel1",
            defaultMessage: "Create AI-generated shopping suggestions for homepage"
        }),
        inProgStaticLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgStaticLabel2",
            defaultMessage: "Add advanced analytics tracking events"
        }),
        doneStaticLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.doneStaticLabel1",
            defaultMessage: "Improve payment checkout time on mobile"
        }),
        doneStaticLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.doneStaticLabel2",
            defaultMessage: "Define requirements to use new AI integrations"
        }),
        animatedCardHeading: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.animatedCardHeading",
            defaultMessage: "Design new billing API"
        }),
        createIssueModalIssueTypeAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel1",
            defaultMessage: "Issue type: Task"
        }),
        createIssueModalIssueTypeAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel2",
            defaultMessage: "Issue type: Story"
        }),
        createIssueModalIssueTypeAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel3",
            defaultMessage: "Issue type: Bug"
        }),
        createIssueModalPriorityAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel1",
            defaultMessage: "Priority: High"
        }),
        createIssueModalPriorityAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel2",
            defaultMessage: "Priority: Critical"
        }),
        createIssueModalPriorityAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel3",
            defaultMessage: "Priority: Blocker"
        }),
        createIssueModalPriorityAssetLabel4: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel4",
            defaultMessage: "Priority: Minor"
        }),
        createIssueModalAssigneeAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel1",
            defaultMessage: "Assignee: Alvin"
        }),
        createIssueModalAssigneeAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel2",
            defaultMessage: "Assignee: Jane"
        }),
        createIssueModalAssigneeAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel3",
            defaultMessage: "Assignee: Blake"
        }),
        epicNameFeatures: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameFeatures",
            defaultMessage: "features"
        }),
        epicNameAnalytics: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameAnalytics",
            defaultMessage: "analytics"
        }),
        epicNamePayments: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNamePayments",
            defaultMessage: "payments"
        }),
        priorityHigh: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityHigh",
            defaultMessage: "high"
        }),
        priorityCritical: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityCritical",
            defaultMessage: "critical"
        }),
        priorityMinor: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityMinor",
            defaultMessage: "minor"
        }),
        priorityBlocker: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityBlocker",
            defaultMessage: "blocker"
        }),
        issueTypeBug: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeBug",
            defaultMessage: "bug"
        }),
        issueTypeStory: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeStory",
            defaultMessage: "story"
        }),
        issueTypeTask: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeTask",
            defaultMessage: "task"
        }),
        epicNameAssets: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameAssets",
            defaultMessage: "assets"
        }),
        epicNameStrategy: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameStrategy",
            defaultMessage: "strategy"
        }),
        epicNameBudget: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameBudget",
            defaultMessage: "budget"
        }),
        epicNameQ1Campaign: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicQ1Campaign",
            defaultMessage: "q1 campaign"
        })
    };
    (0, $iSvIT.useState)(()=>{
        setMessages(messages);
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            isCardTyping && /*#__PURE__*/ (0, $loA2J.jsx)((0, $el0Oi.AnimatedTypingCard), {
                card: props.animatedJiraCardOverride
            }),
            !isCardTyping && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8XM36.JswAnimatedBoard), {
                inProgressCardsOverride: props.inProgressCardsOverride,
                doneCardsOverride: props.doneCardsOverride
            })
        ]
    });
};

});
parcelRegister("el0Oi", function(module, exports) {

$parcel$export(module.exports, "AnimatedTypingCard", function () { return $933ec7858f8ede69$export$6e2fcd8758e3fff8; });
/* animated-typing-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $85mql = parcelRequire("85mql");
parcelRequire("krGYQ");
var $78oyp = parcelRequire("78oyp");
var $LEeB6 = parcelRequire("LEeB6");

var $4MTGk = parcelRequire("4MTGk");
const $933ec7858f8ede69$var$cardStyles = null;
const $933ec7858f8ede69$var$cardTitleWrapper = null;
const $933ec7858f8ede69$var$cardTitle = null;
const $933ec7858f8ede69$var$issueTypeContainer = null;
const $933ec7858f8ede69$var$typePriorityAssigneeRow = null;
const $933ec7858f8ede69$var$animateCard = null;
const $933ec7858f8ede69$export$6e2fcd8758e3fff8 = (props)=>{
    // constants
    const id = (0, $85mql.ANIMATED_CARD_ID);
    const issueType = (0, $85mql.IssueTypeName).STORY;
    const [{ messages: messages }, { animateIssue: animateIssue, nextAnimationStep: nextAnimationStep }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    const cardDetails = (0, $iSvIT.useMemo)(()=>{
        return (0, $6iHNw._)((0, $7Knp0._)({
            summary: messages.animatedCardHeading,
            issueType: issueType,
            epicName: (0, $85mql.EpicName).FEATURES,
            assignee: (0, $85mql.Assignee).ALVIN,
            priority: (0, $85mql.Priority).HIGH
        }, props.card), {
            id: id
        });
    }, [
        id,
        issueType,
        messages.animatedCardHeading,
        props.card
    ]);
    const issueTypeElement = (0, $78oyp.getAssetOptionsForIssueType)(cardDetails.issueType, messages, true);
    (0, $iSvIT.useEffect)(()=>{
        setTimeout(()=>{
            nextAnimationStep();
            animateIssue(cardDetails);
        }, 4200);
    }, [
        animateIssue,
        cardDetails,
        nextAnimationStep
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "aria-describedby": id,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _syaz10fz _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _2rko19bv _11q7cd5j _1bsbdgin _4t3iuuw1 _16qs1ie2 _1reo15vq _18m915vq",
            "_y44vyt1s"
        ]),
        style: {
            "--_1vqiml3": (0, $43MIc.default)((0, $LEeB6.colors).text),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1bsb1ns9"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    id: id,
                    className: (0, $esG4f.default)([
                        "_syaz1765 _1wyb1tcg _zg8l4jg8 _k48pni7l _1bsb1osq _vwz41wqb _1reo15vq _18m915vq _t51zuaqw _o5721q9c _y44vn48t"
                    ]),
                    style: {
                        "--_1jttx64": (0, $43MIc.default)((0, $LEeB6.colors).black),
                        "--_1cyyhae": (0, $43MIc.default)((0, $LEeB6.colors).textSelected)
                    },
                    children: cardDetails.summary
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc",
                    "type-priority-assignee-row"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp14y2",
                        "issue-type-container"
                    ]),
                    children: issueTypeElement
                })
            })
        ]
    });
};

});
parcelRegister("85mql", function(module, exports) {

$parcel$export(module.exports, "AnimationSteps", function () { return $a3bbdd86b7939cd2$export$34f7398b19a809cb; });
$parcel$export(module.exports, "IssueTypeName", function () { return $a3bbdd86b7939cd2$export$41bec0868bbe9664; });
$parcel$export(module.exports, "EpicName", function () { return $a3bbdd86b7939cd2$export$82af5b919cf981f7; });
$parcel$export(module.exports, "Assignee", function () { return $a3bbdd86b7939cd2$export$361f73eba39649ac; });
$parcel$export(module.exports, "Priority", function () { return $a3bbdd86b7939cd2$export$300334f671c43555; });
$parcel$export(module.exports, "stepsLength", function () { return $a3bbdd86b7939cd2$export$33096039fd990cf4; });
$parcel$export(module.exports, "ANIMATED_CARD_ID", function () { return $a3bbdd86b7939cd2$export$a04d920b5f45f5a4; });
var $a3bbdd86b7939cd2$export$34f7398b19a809cb;
(function(AnimationSteps) {
    AnimationSteps[AnimationSteps["CARD_TYPING"] = 0] = "CARD_TYPING";
    AnimationSteps[AnimationSteps["TODO_COL"] = 1] = "TODO_COL";
    AnimationSteps[AnimationSteps["IN_PROG_COL"] = 2] = "IN_PROG_COL";
    AnimationSteps[AnimationSteps["DONE_COL"] = 3] = "DONE_COL";
})($a3bbdd86b7939cd2$export$34f7398b19a809cb || ($a3bbdd86b7939cd2$export$34f7398b19a809cb = {}));
var $a3bbdd86b7939cd2$export$b6032183171af19f;
(function(Project) {
    Project["TeamRocket"] = "team-rocket";
})($a3bbdd86b7939cd2$export$b6032183171af19f || ($a3bbdd86b7939cd2$export$b6032183171af19f = {}));
var $a3bbdd86b7939cd2$export$41bec0868bbe9664;
(function(IssueTypeName) {
    IssueTypeName["TASK"] = "task";
    IssueTypeName["STORY"] = "story";
    IssueTypeName["BUG"] = "bug";
    IssueTypeName["NO_ISSUE"] = "no-issue";
})($a3bbdd86b7939cd2$export$41bec0868bbe9664 || ($a3bbdd86b7939cd2$export$41bec0868bbe9664 = {}));
var $a3bbdd86b7939cd2$export$82af5b919cf981f7;
(function(EpicName) {
    EpicName["FEATURES"] = "features";
    EpicName["ANALYTICS"] = "analytics";
    EpicName["PAYMENTS"] = "payments";
    EpicName["ASSETS"] = "assets";
    EpicName["STRATEGY"] = "strategy";
    EpicName["BUDGET"] = "budget";
    EpicName["Q1_CAMPAIGN"] = "q1 campaign";
})($a3bbdd86b7939cd2$export$82af5b919cf981f7 || ($a3bbdd86b7939cd2$export$82af5b919cf981f7 = {}));
var $a3bbdd86b7939cd2$export$361f73eba39649ac;
(function(Assignee) {
    Assignee["ALVIN"] = "alvin";
    Assignee["JANE"] = "jane";
    Assignee["BLAKE"] = "blake";
})($a3bbdd86b7939cd2$export$361f73eba39649ac || ($a3bbdd86b7939cd2$export$361f73eba39649ac = {}));
var $a3bbdd86b7939cd2$export$300334f671c43555;
(function(Priority) {
    Priority["HIGH"] = "high";
    Priority["CRITICAL"] = "critical";
    Priority["BLOCKER"] = "blocker";
    Priority["MINOR"] = "minor";
})($a3bbdd86b7939cd2$export$300334f671c43555 || ($a3bbdd86b7939cd2$export$300334f671c43555 = {}));
const $a3bbdd86b7939cd2$export$33096039fd990cf4 = Object.keys($a3bbdd86b7939cd2$export$34f7398b19a809cb).length / 2;
const $a3bbdd86b7939cd2$export$22aad1fd6cb58c70 = 255;
const $a3bbdd86b7939cd2$export$938f0a0c059b7000 = 3000;
const $a3bbdd86b7939cd2$export$a04d920b5f45f5a4 = "animated-card";

});

parcelRegister("krGYQ", function(module, exports) {
$parcel$export(module.exports, "colors", function () { return (parcelRequire("LEeB6")).colors; });
$parcel$export(module.exports, "getAssetForEpicLink", function () { return (parcelRequire("78oyp")).getAssetForEpicLink; });
$parcel$export(module.exports, "getAssetOptionsForAssignee", function () { return (parcelRequire("78oyp")).getAssetOptionsForAssignee; });
$parcel$export(module.exports, "getAssetOptionsForIssueType", function () { return (parcelRequire("78oyp")).getAssetOptionsForIssueType; });
$parcel$export(module.exports, "getAssetOptionsForPriority", function () { return (parcelRequire("78oyp")).getAssetOptionsForPriority; });
parcelRequire("LEeB6");
parcelRequire("78oyp");

});
parcelRegister("LEeB6", function(module, exports) {

$parcel$export(module.exports, "colors", function () { return $b5ec46f4b3ddf218$export$8f45430ccf837300; });
/* eslint-disable local/ensure-wac-token-usage */ // custom colors that are not covered by wacToken
const $b5ec46f4b3ddf218$export$8f45430ccf837300 = {
    black: "#000000",
    elevationSurfaceSunken: "#F7F8F9",
    text: "#172B4D",
    textSelected: "#0C66E4",
    textSubtle: "#44546F"
};

});

parcelRegister("78oyp", function(module, exports) {

$parcel$export(module.exports, "getAssetOptionsForIssueType", function () { return $3cc3a7da94a279db$export$d3e272371e479228; });
$parcel$export(module.exports, "getAssetOptionsForPriority", function () { return $3cc3a7da94a279db$export$5aec24a3628dae7c; });
$parcel$export(module.exports, "getAssetOptionsForAssignee", function () { return $3cc3a7da94a279db$export$d910478ee874e351; });
$parcel$export(module.exports, "getAssetForEpicLink", function () { return $3cc3a7da94a279db$export$2eeaca611ab4ba57; });
/* get-asset-options.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $RBncq = parcelRequire("RBncq");

var $h6XJS = parcelRequire("h6XJS");

var $3m6hY = parcelRequire("3m6hY");

var $8xSOc = parcelRequire("8xSOc");
parcelRequire("kbBaE");
var $1qPcY = parcelRequire("1qPcY");
var $iIcC7 = parcelRequire("iIcC7");
var $l9rqd = parcelRequire("l9rqd");
var $aegDZ = parcelRequire("aegDZ");
var $4Juu3 = parcelRequire("4Juu3");
var $lB82X = parcelRequire("lB82X");
var $89lHQ = parcelRequire("89lHQ");

var $85mql = parcelRequire("85mql");
const $3cc3a7da94a279db$var$issueText = null;
const $3cc3a7da94a279db$export$d3e272371e479228 = (value, messages, includeLabel)=>{
    const { createIssueModalIssueTypeAssetLabel1: createIssueModalIssueTypeAssetLabel1, createIssueModalIssueTypeAssetLabel2: createIssueModalIssueTypeAssetLabel2, createIssueModalIssueTypeAssetLabel3: createIssueModalIssueTypeAssetLabel3 } = includeLabel ? messages : {
        createIssueModalIssueTypeAssetLabel1: "",
        createIssueModalIssueTypeAssetLabel2: "",
        createIssueModalIssueTypeAssetLabel3: ""
    };
    switch(value){
        case (0, $85mql.IssueTypeName).TASK:
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3m6hY))), {
                        label: createIssueModalIssueTypeAssetLabel1
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $esG4f.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeTask
                    })
                ]
            });
        case (0, $85mql.IssueTypeName).STORY:
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6XJS))), {
                        label: createIssueModalIssueTypeAssetLabel2
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $esG4f.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeStory
                    })
                ]
            });
        case (0, $85mql.IssueTypeName).BUG:
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($RBncq))), {
                        label: createIssueModalIssueTypeAssetLabel3
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $esG4f.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeBug
                    })
                ]
            });
        case (0, $85mql.IssueTypeName).NO_ISSUE:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
        default:
            console.warn(`Asset for issue type ${value} does not exist.`);
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3m6hY))), {
                label: createIssueModalIssueTypeAssetLabel1
            });
    }
};
const $3cc3a7da94a279db$export$5aec24a3628dae7c = (value, messages, includeLabel)=>{
    const { createIssueModalPriorityAssetLabel1: createIssueModalPriorityAssetLabel1, createIssueModalPriorityAssetLabel2: createIssueModalPriorityAssetLabel2, createIssueModalPriorityAssetLabel3: createIssueModalPriorityAssetLabel3, createIssueModalPriorityAssetLabel4: createIssueModalPriorityAssetLabel4 } = includeLabel ? messages : {
        createIssueModalPriorityAssetLabel1: "",
        createIssueModalPriorityAssetLabel2: "",
        createIssueModalPriorityAssetLabel3: "",
        createIssueModalPriorityAssetLabel4: ""
    };
    switch(value){
        case (0, $85mql.Priority).HIGH:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1qPcY.PriorityHigh16Icon), {
                label: createIssueModalPriorityAssetLabel1
            });
        case (0, $85mql.Priority).CRITICAL:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iIcC7.PriorityCritical24Icon), {
                label: createIssueModalPriorityAssetLabel2
            });
        case (0, $85mql.Priority).BLOCKER:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $l9rqd.PriorityBlocker24Icon), {
                label: createIssueModalPriorityAssetLabel3
            });
        case (0, $85mql.Priority).MINOR:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aegDZ.PriorityMinor24Icon), {
                label: createIssueModalPriorityAssetLabel4
            });
        default:
            console.warn(`Asset for priority ${value} does not exist.`);
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aegDZ.PriorityMinor24Icon), {
                label: createIssueModalPriorityAssetLabel1
            });
    }
};
const $3cc3a7da94a279db$export$d910478ee874e351 = (value, messages, includeLabel)=>{
    const { createIssueModalAssigneeAssetLabel1: createIssueModalAssigneeAssetLabel1, createIssueModalAssigneeAssetLabel2: createIssueModalAssigneeAssetLabel2, createIssueModalAssigneeAssetLabel3: createIssueModalAssigneeAssetLabel3 } = includeLabel ? messages : {
        createIssueModalAssigneeAssetLabel1: "",
        createIssueModalAssigneeAssetLabel2: "",
        createIssueModalAssigneeAssetLabel3: ""
    };
    switch(value){
        case (0, $85mql.Assignee).ALVIN:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Juu3.AssigneeAlvin24Image), {
                alt: createIssueModalAssigneeAssetLabel1
            });
        case (0, $85mql.Assignee).JANE:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lB82X.AssigneeJane24Image), {
                alt: createIssueModalAssigneeAssetLabel2
            });
        case (0, $85mql.Assignee).BLAKE:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $89lHQ.AssigneeBlake24Image), {
                alt: createIssueModalAssigneeAssetLabel3
            });
        default:
            console.warn(`Asset for assignee ${value} does not exist.`);
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Juu3.AssigneeAlvin24Image), {
                alt: createIssueModalAssigneeAssetLabel1
            });
    }
};
const $3cc3a7da94a279db$export$2eeaca611ab4ba57 = (value, messages)=>{
    switch(value){
        case (0, $85mql.EpicName).FEATURES:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameFeatures
            });
        case (0, $85mql.EpicName).ANALYTICS:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "success",
                isBold: true,
                children: messages.epicNameAnalytics
            });
        case (0, $85mql.EpicName).PAYMENTS:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "new",
                isBold: true,
                children: messages.epicNamePayments
            });
        case (0, $85mql.EpicName).ASSETS:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "moved",
                isBold: true,
                children: messages.epicNameAssets
            });
        case (0, $85mql.EpicName).STRATEGY:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameStrategy
            });
        case (0, $85mql.EpicName).BUDGET:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "success",
                isBold: true,
                children: messages.epicNameBudget
            });
        case (0, $85mql.EpicName).Q1_CAMPAIGN:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameQ1Campaign
            });
        default:
            console.warn(`Asset for epic link ${value} does not exist.`);
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                appearance: "inprogress",
                isBold: true,
                children: value
            });
    }
};

});
parcelRegister("RBncq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a11f0e335025ed4$var$_react = $0a11f0e335025ed4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aq08R = parcelRequire("aq08R");
function $0a11f0e335025ed4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0a11f0e335025ed4$var$Bug16Icon = (props)=>/*#__PURE__*/ $0a11f0e335025ed4$var$_react.default.createElement($aq08R.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 12a4 4 0 100-8 4 4 0 000 8z"/></svg>`
    }, props, {
        size: "small"
    }));
$0a11f0e335025ed4$var$Bug16Icon.displayName = "Bug16Icon";
var $0a11f0e335025ed4$var$_default = $0a11f0e335025ed4$var$Bug16Icon;
module.exports.default = $0a11f0e335025ed4$var$_default;

});

parcelRegister("3m6hY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27184e06ef42eb5b$var$_react = $27184e06ef42eb5b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aq08R = parcelRequire("aq08R");
function $27184e06ef42eb5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $27184e06ef42eb5b$var$Task16Icon = (props)=>/*#__PURE__*/ $27184e06ef42eb5b$var$_react.default.createElement($aq08R.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3H4.667zM5 5v6h6V5H5z"/></svg>`
    }, props, {
        size: "small"
    }));
$27184e06ef42eb5b$var$Task16Icon.displayName = "Task16Icon";
var $27184e06ef42eb5b$var$_default = $27184e06ef42eb5b$var$Task16Icon;
module.exports.default = $27184e06ef42eb5b$var$_default;

});

parcelRegister("kbBaE", function(module, exports) {

$parcel$export(module.exports, "PriorityHigh16Icon", function () { return (parcelRequire("1qPcY")).PriorityHigh16Icon; });
$parcel$export(module.exports, "PriorityCritical24Icon", function () { return (parcelRequire("iIcC7")).PriorityCritical24Icon; });
$parcel$export(module.exports, "PriorityBlocker24Icon", function () { return (parcelRequire("l9rqd")).PriorityBlocker24Icon; });
$parcel$export(module.exports, "PriorityMinor24Icon", function () { return (parcelRequire("aegDZ")).PriorityMinor24Icon; });
$parcel$export(module.exports, "AssigneeAlvin24Image", function () { return (parcelRequire("4Juu3")).AssigneeAlvin24Image; });
$parcel$export(module.exports, "AssigneeJane24Image", function () { return (parcelRequire("lB82X")).AssigneeJane24Image; });
$parcel$export(module.exports, "AssigneeBlake24Image", function () { return (parcelRequire("89lHQ")).AssigneeBlake24Image; });

var $1qPcY = parcelRequire("1qPcY");

var $iIcC7 = parcelRequire("iIcC7");

var $l9rqd = parcelRequire("l9rqd");

var $aegDZ = parcelRequire("aegDZ");

var $4Juu3 = parcelRequire("4Juu3");

var $lB82X = parcelRequire("lB82X");

var $89lHQ = parcelRequire("89lHQ");

});
parcelRegister("1qPcY", function(module, exports) {

$parcel$export(module.exports, "PriorityHigh16Icon", function () { return $820f3485f51b6b16$export$dd6325c289ca803; });

var $loA2J = parcelRequire("loA2J");

var $1IjLq = parcelRequire("1IjLq");

var $48zDN = parcelRequire("48zDN");
const $820f3485f51b6b16$var$PriorityHigh16Glyph = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props["data-testid"],
        className: props.className,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M9.34379 4.09779L9.41258 4.14609L12.7459 6.81275C13.0334 7.04276 13.08 7.46229 12.85 7.7498C12.6377 8.01519 12.2639 8.07532 11.9815 7.9021L11.913 7.85391L8.99612 5.52L6.07925 7.85391C5.81386 8.06623 5.43597 8.04284 5.1985 7.81185L5.14221 7.7498C4.92989 7.48441 4.95328 7.10652 5.18427 6.86905L5.24632 6.81275L8.57965 4.14609C8.801 3.96901 9.10705 3.95291 9.34379 4.09779Z",
            fill: (0, $48zDN.R300)
        })
    });
const $820f3485f51b6b16$export$dd6325c289ca803 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IjLq.default), {
        glyph: $820f3485f51b6b16$var$PriorityHigh16Glyph,
        label: label
    });
};

});

parcelRegister("iIcC7", function(module, exports) {

$parcel$export(module.exports, "PriorityCritical24Icon", function () { return $b3de3bdf6b339ece$export$e8c8b58c821b2482; });

var $loA2J = parcelRequire("loA2J");

var $1IjLq = parcelRequire("1IjLq");

var $48zDN = parcelRequire("48zDN");
const $b3de3bdf6b339ece$var$PriorityCritical24Glyph = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props["data-testid"],
        className: props.className,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M11.3753 4.21913L6.3753 8.21913C6.13809 8.4089 6 8.69622 6 9V19L6.00589 19.112C6.08752 19.8788 6.99969 20.2809 7.6247 19.7809L12 16.28L16.3753 19.7809C17.0301 20.3047 18 19.8385 18 19V9C18 8.69622 17.8619 8.4089 17.6247 8.21913L12.6247 4.21913C12.2595 3.92696 11.7405 3.92696 11.3753 4.21913Z",
            fill: (0, $48zDN.R300)
        })
    });
const $b3de3bdf6b339ece$export$e8c8b58c821b2482 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IjLq.default), {
        glyph: $b3de3bdf6b339ece$var$PriorityCritical24Glyph,
        label: label
    });
};

});

parcelRegister("l9rqd", function(module, exports) {

$parcel$export(module.exports, "PriorityBlocker24Icon", function () { return $ab2542cd2d76cb15$export$13dfa89176f2d0ab; });

var $loA2J = parcelRequire("loA2J");

var $1IjLq = parcelRequire("1IjLq");

var $48zDN = parcelRequire("48zDN");
const $ab2542cd2d76cb15$var$PriorityBlocker24Glyph = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props["data-testid"],
        className: props.className,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM7 11L6.88338 11.0067C6.38604 11.0645 6 11.4872 6 12C6 12.5523 6.44772 13 7 13H17L17.1166 12.9933C17.614 12.9355 18 12.5128 18 12C18 11.4477 17.5523 11 17 11H7Z",
            fill: (0, $48zDN.R300)
        })
    });
const $ab2542cd2d76cb15$export$13dfa89176f2d0ab = ({ label: label })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IjLq.default), {
        glyph: $ab2542cd2d76cb15$var$PriorityBlocker24Glyph,
        label: label
    });
};

});

parcelRegister("aegDZ", function(module, exports) {

$parcel$export(module.exports, "PriorityMinor24Icon", function () { return $cbd766515436e751$export$7da8240bfa3b7af4; });

var $loA2J = parcelRequire("loA2J");

var $1IjLq = parcelRequire("1IjLq");
const $cbd766515436e751$var$PriorityMinor24Glyph = (props)=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props["data-testid"],
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.4491 14.975C18.6764 14.8427 18.9468 14.8054 19.2015 14.871C19.4563 14.9367 19.6749 15.1001 19.81 15.3258C19.9451 15.5516 19.9858 15.8214 19.9233 16.077C19.8608 16.3325 19.7001 16.5531 19.4761 16.691L12.5061 20.864C12.3503 20.9571 12.1722 21.0062 11.9908 21.0058C11.8093 21.0055 11.6314 20.9557 11.4761 20.862L4.57005 16.69C4.34303 16.5529 4.17977 16.3312 4.11619 16.0737C4.05262 15.8162 4.09393 15.544 4.23105 15.317C4.36817 15.09 4.58986 14.9267 4.84734 14.8631C5.10483 14.7996 5.37703 14.8409 5.60405 14.978L11.9951 18.84L18.4491 14.976V14.975Z",
                fill: "#388BFF"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.9951 12.837L18.4491 8.97197C18.6764 8.83969 18.9468 8.80233 19.2015 8.868C19.4563 8.93367 19.6749 9.09707 19.81 9.3228C19.9451 9.54853 19.9858 9.8184 19.9233 10.0739C19.8608 10.3295 19.7001 10.5501 19.4761 10.688L12.5061 14.862C12.3503 14.9551 12.1722 15.0041 11.9908 15.0038C11.8093 15.0034 11.6314 14.9537 11.4761 14.86L4.57005 10.686C4.34303 10.5489 4.17977 10.3272 4.11619 10.0697C4.05262 9.81219 4.09393 9.54 4.23105 9.31297C4.36817 9.08595 4.58986 8.92269 4.84734 8.85911C5.10483 8.79554 5.37703 8.83685 5.60405 8.97397L11.9951 12.837Z",
                fill: "#388BFF"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.9951 6.82306L18.4491 2.95806C18.5618 2.88868 18.6872 2.84237 18.8179 2.82182C18.9487 2.80127 19.0822 2.80688 19.2108 2.83833C19.3394 2.86978 19.4604 2.92644 19.5669 3.00503C19.6734 3.08362 19.7633 3.18257 19.8313 3.29615C19.8992 3.40973 19.944 3.53567 19.9629 3.66668C19.9818 3.79768 19.9746 3.93114 19.9415 4.05932C19.9085 4.18749 19.8503 4.30783 19.7704 4.41336C19.6905 4.51889 19.5905 4.6075 19.4761 4.67406L12.5061 8.84806C12.3503 8.9412 12.1722 8.99022 11.9908 8.98987C11.8093 8.98952 11.6314 8.93981 11.4761 8.84606L4.57005 4.67206C4.34303 4.53494 4.17977 4.31326 4.11619 4.05577C4.05262 3.79828 4.09393 3.52609 4.23105 3.29906C4.36817 3.07203 4.58986 2.90878 4.84734 2.8452C5.10483 2.78163 5.37703 2.82294 5.60405 2.96006L11.9951 6.82306Z",
                fill: "#388BFF"
            })
        ]
    });
const $cbd766515436e751$export$7da8240bfa3b7af4 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1IjLq.default), {
        glyph: $cbd766515436e751$var$PriorityMinor24Glyph,
        label: label
    });
};

});

parcelRegister("4Juu3", function(module, exports) {

$parcel$export(module.exports, "AssigneeAlvin24Image", function () { return $4cf00137a25b325f$export$c9d73c94996ebdb; });

var $loA2J = parcelRequire("loA2J");

var $cssyA = parcelRequire("cssyA");
const $4cf00137a25b325f$export$c9d73c94996ebdb = (props)=>{
    const src = (0, $cssyA.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/w3ew83t6fv2xk12878a62ut0qlbr50w8.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});

parcelRegister("lB82X", function(module, exports) {

$parcel$export(module.exports, "AssigneeJane24Image", function () { return $d956d18005e42768$export$ba7e78c878adef6e; });

var $loA2J = parcelRequire("loA2J");

var $cssyA = parcelRequire("cssyA");
const $d956d18005e42768$export$ba7e78c878adef6e = (props)=>{
    const src = (0, $cssyA.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/6smlwl4eifdmx52le043b047ywb2js6v.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});

parcelRegister("89lHQ", function(module, exports) {

$parcel$export(module.exports, "AssigneeBlake24Image", function () { return $86076b615a15e4ba$export$6f4e8d70caa23820; });

var $loA2J = parcelRequire("loA2J");

var $cssyA = parcelRequire("cssyA");
const $86076b615a15e4ba$export$6f4e8d70caa23820 = (props)=>{
    const src = (0, $cssyA.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/gtou8x0538yr0283q5f5ph4a1qtx16c1.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});




parcelRegister("4MTGk", function(module, exports) {

$parcel$export(module.exports, "useMessages", function () { return $b4409b0b7598ec0d$export$4d17e2d9c5348842; });
$parcel$export(module.exports, "useAnimatedJiraBoardStore", function () { return $b4409b0b7598ec0d$export$736729dc5e146045; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $4ejMU = parcelRequire("4ejMU");
var $ij7wO = parcelRequire("ij7wO");

var $fjR4V = parcelRequire("fjR4V");

var $85mql = parcelRequire("85mql");
const $b4409b0b7598ec0d$var$initialState = {
    animationStep: (0, $85mql.AnimationSteps).CARD_TYPING,
    isCreateButtonFocused: false,
    todoCol: [],
    inProgressCol: [],
    doneCol: [],
    messages: (0, $fjR4V.messages)
};
const $b4409b0b7598ec0d$var$genericRestartAction = ()=>({ setState: setState, getState: getState })=>{
        const { messages: messages } = getState();
        setState((0, $6iHNw._)((0, $7Knp0._)({}, $b4409b0b7598ec0d$var$initialState), {
            messages: messages,
            isCreateButtonFocused: true
        }));
    };
const $b4409b0b7598ec0d$var$actions = {
    animateIssue: (animatedCardData)=>({ setState: setState, getState: getState })=>{
            const { todoCol: todoCol } = getState();
            const todoColAppend = todoCol.concat([
                animatedCardData
            ]);
            setState({
                todoCol: todoColAppend
            });
        },
    nextAnimationStep: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { animationStep: animationStep } = getState();
            if (animationStep === (0, $85mql.stepsLength) - 1) {
                dispatch($b4409b0b7598ec0d$var$genericRestartAction());
                return;
            }
            setState({
                animationStep: animationStep + 1
            });
        },
    restartDemo: ()=>({ setState: setState, getState: getState })=>{
            const { messages: messages, inProgressCol: inProgressCol, doneCol: doneCol } = getState();
            setState((0, $6iHNw._)((0, $7Knp0._)({}, $b4409b0b7598ec0d$var$initialState), {
                messages: messages,
                inProgressCol: inProgressCol,
                doneCol: doneCol,
                isCreateButtonFocused: true
            }));
        },
    setTodoCol: (colInfo)=>({ setState: setState })=>{
            setState({
                todoCol: colInfo
            });
        },
    setDoneCol: (colInfo)=>({ setState: setState })=>{
            setState({
                doneCol: colInfo
            });
        },
    setInProgressCol: (colInfo)=>({ setState: setState })=>{
            setState({
                inProgressCol: colInfo
            });
        },
    setMessages: (messages)=>({ setState: setState })=>{
            setState({
                messages: messages
            });
        },
    transitionToInProgress: ()=>({ setState: setState, getState: getState })=>{
            const { todoCol: todoCol, inProgressCol: inProgressCol } = getState();
            const todoColPop = todoCol.pop();
            const todoCopy = todoCol;
            if (todoColPop) {
                const inProgressAppend = inProgressCol.concat([
                    todoColPop
                ]);
                setState({
                    todoCol: todoCopy,
                    inProgressCol: inProgressAppend
                });
            }
        },
    transitionToDone: ()=>({ setState: setState, getState: getState })=>{
            const { inProgressCol: inProgressCol, doneCol: doneCol } = getState();
            const inProgColPop = inProgressCol.pop();
            const inProgCopy = inProgressCol;
            if (inProgColPop) {
                const doneColAppend = doneCol.concat([
                    inProgColPop
                ]);
                setState({
                    inProgressCol: inProgCopy,
                    doneCol: doneColAppend
                });
            }
        }
};
const $b4409b0b7598ec0d$var$InteractiveBoardStore = (0, $ij7wO.createStore)({
    initialState: $b4409b0b7598ec0d$var$initialState,
    actions: $b4409b0b7598ec0d$var$actions,
    name: "jsw-interactive-board-store"
});
const $b4409b0b7598ec0d$var$getMessages = (state)=>state.messages;
const $b4409b0b7598ec0d$export$4d17e2d9c5348842 = (0, $4ejMU.createHook)($b4409b0b7598ec0d$var$InteractiveBoardStore, {
    selector: $b4409b0b7598ec0d$var$getMessages
});
const $b4409b0b7598ec0d$export$736729dc5e146045 = (0, $4ejMU.createHook)($b4409b0b7598ec0d$var$InteractiveBoardStore);

});
parcelRegister("fjR4V", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $a7d8509912833bae$export$defe85febe8b728c; });
const $a7d8509912833bae$export$defe85febe8b728c = {
    toDo: "To Do",
    inProgress: "In Progress",
    done: "Done",
    todoStaticLabel: "Design AI shopping suggestions for homepage",
    inProgStaticLabel1: "Create AI-generated shopping suggestions for homepage",
    inProgStaticLabel2: "Add advanced analytics tracking events",
    doneStaticLabel1: "Improve payment checkout time on mobile",
    doneStaticLabel2: "Define requirements to use new AI integrations",
    animatedCardHeading: "Design new billing API",
    createIssueModalIssueTypeAssetLabel1: "Issue type: Task",
    createIssueModalIssueTypeAssetLabel2: "Issue type: Story",
    createIssueModalIssueTypeAssetLabel3: "Issue type: Bug",
    createIssueModalPriorityAssetLabel1: "Priority: High",
    createIssueModalPriorityAssetLabel2: "Priority: Critical",
    createIssueModalPriorityAssetLabel3: "Priority: Blocker",
    createIssueModalPriorityAssetLabel4: "Priority: Minor",
    createIssueModalAssigneeAssetLabel1: "Assignee: Alvin",
    createIssueModalAssigneeAssetLabel2: "Assignee: Jane",
    createIssueModalAssigneeAssetLabel3: "Assignee: Blake",
    epicNameFeatures: "features",
    epicNameAnalytics: "analytics",
    epicNamePayments: "payments",
    epicNameAssets: "assets",
    epicNameStrategy: "strategy",
    epicNameBudget: "budget",
    epicNameQ1Campaign: "q1 campaign",
    priorityHigh: "high",
    priorityCritical: "critical",
    priorityMinor: "minor",
    priorityBlocker: "blocker",
    issueTypeBug: "bug",
    issueTypeStory: "story",
    issueTypeTask: "task"
};

});



parcelRegister("8XM36", function(module, exports) {

$parcel$export(module.exports, "JswAnimatedBoard", function () { return $47755984e888f8d9$export$d89965761ac203a5; });
/* jsw-animated-board.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $85mql = parcelRequire("85mql");

var $4MTGk = parcelRequire("4MTGk");

var $5ohHq = parcelRequire("5ohHq");

var $75gRE = parcelRequire("75gRE");

var $ij1vr = parcelRequire("ij1vr");
const $47755984e888f8d9$var$rootContainerStyle = null;
const $47755984e888f8d9$var$growBoard = null;
const $47755984e888f8d9$var$shrinkBoard = null;
const $47755984e888f8d9$var$fadeOut = null;
const $47755984e888f8d9$var$fadeIn = null;
const $47755984e888f8d9$var$animationBoardStyles = null;
const $47755984e888f8d9$export$d89965761ac203a5 = (props)=>{
    const [{ messages: messages }, { setInProgressCol: setInProgressCol, setDoneCol: setDoneCol }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    (0, $iSvIT.useState)(()=>{
        var _props_inProgressCardsOverride;
        setInProgressCol((_props_inProgressCardsOverride = props.inProgressCardsOverride) !== null && _props_inProgressCardsOverride !== void 0 ? _props_inProgressCardsOverride : [
            {
                id: "inProg1",
                summary: messages.inProgStaticLabel1,
                issueType: (0, $85mql.IssueTypeName).STORY,
                epicName: (0, $85mql.EpicName).FEATURES,
                assignee: (0, $85mql.Assignee).JANE,
                priority: (0, $85mql.Priority).BLOCKER
            },
            {
                id: "inProg2",
                summary: messages.inProgStaticLabel2,
                issueType: (0, $85mql.IssueTypeName).STORY,
                epicName: (0, $85mql.EpicName).ANALYTICS,
                assignee: (0, $85mql.Assignee).BLAKE,
                priority: (0, $85mql.Priority).HIGH
            }
        ]);
        var _props_doneCardsOverride;
        setDoneCol((_props_doneCardsOverride = props.doneCardsOverride) !== null && _props_doneCardsOverride !== void 0 ? _props_doneCardsOverride : [
            {
                id: "done1",
                summary: messages.doneStaticLabel1,
                issueType: (0, $85mql.IssueTypeName).BUG,
                epicName: (0, $85mql.EpicName).PAYMENTS,
                assignee: (0, $85mql.Assignee).ALVIN,
                priority: (0, $85mql.Priority).MINOR
            },
            {
                id: "done2",
                summary: messages.doneStaticLabel2,
                issueType: (0, $85mql.IssueTypeName).TASK,
                epicName: (0, $85mql.EpicName).FEATURES,
                assignee: (0, $85mql.Assignee).JANE,
                priority: (0, $85mql.Priority).CRITICAL
            }
        ]);
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_c71l1deq _p12f1c3h _1bsb1osq _bfhkcd5j _2rko19bv _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _zulp7vkz _16qs162a _1y8o1ogm",
            "_y44vmxuu"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ij1vr.BoardHeader), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $75gRE.BoardBody), {})
        ]
    });
};
var $47755984e888f8d9$export$2e2bcd8739ae039 = $47755984e888f8d9$export$d89965761ac203a5;

});
parcelRegister("75gRE", function(module, exports) {

$parcel$export(module.exports, "BoardBody", function () { return $92fb490a37279e2f$export$655dea6f92c41d9; });
/* board-body.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6tXZU = parcelRequire("6tXZU");

var $85mql = parcelRequire("85mql");

var $4MTGk = parcelRequire("4MTGk");
const $92fb490a37279e2f$var$boardBodyStyle = null;
const $92fb490a37279e2f$var$columnContainerStyle = null;
const $92fb490a37279e2f$export$655dea6f92c41d9 = ()=>{
    const [{ messages: messages, todoCol: todoCol, inProgressCol: inProgressCol, doneCol: doneCol, animationStep: animationStep }, { transitionToInProgress: transitionToInProgress, transitionToDone: transitionToDone }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    (0, $iSvIT.useEffect)(()=>{
        switch(animationStep){
            case (0, $85mql.AnimationSteps).IN_PROG_COL:
                transitionToInProgress();
                break;
            case (0, $85mql.AnimationSteps).DONE_COL:
                transitionToDone();
                break;
        }
    }, [
        animationStep
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_2rkoftgi _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _zulp1crf"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6tXZU.Column), {
                    title: messages.toDo,
                    cards: todoCol
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6tXZU.Column), {
                    title: messages.inProgress,
                    cards: inProgressCol
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6tXZU.Column), {
                    title: messages.done,
                    cards: doneCol
                })
            ]
        })
    });
};

});
parcelRegister("6tXZU", function(module, exports) {

$parcel$export(module.exports, "Column", function () { return $261e8b2195555046$export$816b5d811295e6bc; });
/* column.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $cEOcu = parcelRequire("cEOcu");
parcelRequire("krGYQ");
var $LEeB6 = parcelRequire("LEeB6");
const $261e8b2195555046$var$columnStyle = null;
const $261e8b2195555046$var$columnTitleStyle = null;
const $261e8b2195555046$var$listStyle = null;
const $261e8b2195555046$export$816b5d811295e6bc = ({ title: title, cards: cards })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_bfhkcnsw _2rkoftgi _16jlkb7n _1o9zkb7n _i0dlf1ug _bozg14y2 _y4ti14y2 _1tkeitct"
        ]),
        style: {
            "--_1li0dij": (0, $43MIc.default)((0, $LEeB6.colors).elevationSurfaceSunken)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_bfhkcnsw _syaz1h2j _1e0c1ule _1wyb1crf _k48pni7l _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1p1dangw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz411ph"
                ]),
                style: {
                    "--_1li0dij": (0, $43MIc.default)((0, $LEeB6.colors).elevationSurfaceSunken),
                    "--_3qpi7d": (0, $43MIc.default)((0, $LEeB6.colors).textSubtle)
                },
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                role: "list",
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21sxn"
                ]),
                children: cards.map((card, i)=>{
                    return card.id && /*#__PURE__*/ (0, $loA2J.jsx)((0, $cEOcu.Card), {
                        role: "listitem",
                        priority: card.priority,
                        epicName: card.epicName,
                        assignee: card.assignee,
                        issueType: card.issueType,
                        summary: card.summary,
                        id: card.id
                    }, i);
                })
            })
        ]
    });
};

});
parcelRegister("cEOcu", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $1e4bd18a89a08b02$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $85mql = parcelRequire("85mql");
parcelRequire("krGYQ");
var $78oyp = parcelRequire("78oyp");
var $LEeB6 = parcelRequire("LEeB6");

var $4MTGk = parcelRequire("4MTGk");
const $1e4bd18a89a08b02$export$60332b2344f7fe41 = ({ summary: summary, epicName: epicName, issueType: issueType, priority: priority, assignee: assignee, id: id, role: role })=>{
    const [isAnimatedCardId, setIsAnimatedCardId] = (0, $iSvIT.useState)(false);
    const [messages] = (0, $4MTGk.useMessages)();
    const [, { nextAnimationStep: nextAnimationStep }] = (0, $4MTGk.useAnimatedJiraBoardStore)();
    const epicLinkElement = (0, $78oyp.getAssetForEpicLink)(epicName, messages);
    const issueTypeElement = (0, $78oyp.getAssetOptionsForIssueType)(issueType, messages, true);
    (0, $iSvIT.useEffect)(()=>{
        if (id === (0, $85mql.ANIMATED_CARD_ID)) {
            setIsAnimatedCardId(true);
            setTimeout(()=>{
                nextAnimationStep();
            }, 4250);
        }
    }, [
        id,
        nextAnimationStep
    ]);
    const priorityElement = (0, $78oyp.getAssetOptionsForPriority)(priority, messages, true);
    const assigneeElement = (0, $78oyp.getAssetOptionsForAssignee)(assignee, messages, true);
    const cardStyles = null;
    const labelContainer = null;
    const epicLinkRow = null;
    const issueTypeContainer = null;
    const typePriorityAssigneeRow = null;
    const priorityAssigneeContainer = null;
    const animateCardonRender = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "aria-describedby": id,
        role: role,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _syaz10fz _19pk14y2 _2hwxidpf _otyr14y2 _18u0idpf _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _2rko1y44 _11q7cd5j _16qs1drn _zulpftgi",
            isAnimatedCardId && "_c71lidpf _1reo15vq _18m915vq _o5721q9c _y44v4ib8 _ca0qidpf _u5f31crf _n3tdidpf _19bv1crf _16qs1trb"
        ]),
        style: {
            "--_1vqiml3": (0, $43MIc.default)((0, $LEeB6.colors).text),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1cyyhae": (0, $43MIc.default)((0, $LEeB6.colors).textSelected)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                id: id,
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4iio8 _1bsb1vuk"
                ]),
                children: summary
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc"
                ]),
                children: epicLinkElement
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp14y2"
                        ]),
                        children: issueTypeElement
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx2vrvc _zulpftgi _ahbq1wug"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: priorityElement
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: assigneeElement
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("ij1vr", function(module, exports) {

$parcel$export(module.exports, "BoardHeader", function () { return $efad6805288f285f$export$67b80e16fd3c69b6; });
/* board-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $FFB2A = parcelRequire("FFB2A");
var $cvaTj = parcelRequire("cvaTj");
var $3BXVF = parcelRequire("3BXVF");
var $8jNT4 = parcelRequire("8jNT4");
var $eLIbZ = parcelRequire("eLIbZ");
var $7IMRw = parcelRequire("7IMRw");
var $60YlP = parcelRequire("60YlP");
var $7sRIl = parcelRequire("7sRIl");

var $objBZ = parcelRequire("objBZ");

var $8zMNO = parcelRequire("8zMNO");
var $bLpA6 = parcelRequire("bLpA6");
const $efad6805288f285f$var$AtlassianProductHome = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $eLIbZ.default), {
        icon: (0, $8zMNO.JiraIcon),
        logo: (0, $bLpA6.JiraLogo)
    });
const $efad6805288f285f$var$greyLine = null;
const $efad6805288f285f$var$lineContainer = null;
const $efad6805288f285f$var$lineContainerWithBlueBackground = null;
const $efad6805288f285f$var$blueBackground = null;
const $efad6805288f285f$var$overlay = null;
const $efad6805288f285f$var$fakeProfile = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7IMRw.Profile), {
        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $objBZ.default), {
            size: "small"
        }),
        onClick: ()=>null,
        tooltip: "Your profile and settings"
    });
const $efad6805288f285f$var$fakeSearch = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $60YlP.Search), {
        onClick: ()=>null,
        placeholder: "Search...",
        tooltip: "Search",
        label: "Search",
        value: ""
    });
};
const $efad6805288f285f$var$fakeSettings = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7sRIl.Settings), {
        tooltip: "Product settings"
    });
const $efad6805288f285f$var$fakeNotifications = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $8jNT4.Notifications), {
        badge: ()=>null,
        tooltip: "Notifications"
    });
const $efad6805288f285f$var$fakeAppSwitcher = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $FFB2A.AppSwitcher), {
        tooltip: "Switch between apps"
    });
const $efad6805288f285f$var$fakeHelp = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3BXVF.Help), {
        tooltip: "Get help"
    });
const $efad6805288f285f$export$67b80e16fd3c69b6 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvaTj.AtlassianNavigation), {
            label: "site",
            renderProductHome: $efad6805288f285f$var$AtlassianProductHome,
            primaryItems: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake1"),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake2"),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake3"),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o",
                        "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_2rkomt0u _11q73wju _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                            ])
                        })
                    })
                }, "fake4")
            ],
            renderSearch: $efad6805288f285f$var$fakeSearch,
            renderProfile: $efad6805288f285f$var$fakeProfile,
            renderSettings: $efad6805288f285f$var$fakeSettings,
            renderNotifications: $efad6805288f285f$var$fakeNotifications,
            renderAppSwitcher: $efad6805288f285f$var$fakeAppSwitcher,
            renderHelp: $efad6805288f285f$var$fakeHelp
        })
    });
};

});
parcelRegister("FFB2A", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", function () { return $07d418a26c73ef13$export$9923361bd43fa030; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $9UTJR = parcelRequire("9UTJR");

var $2okzL = parcelRequire("2okzL");
var $07d418a26c73ef13$var$_excluded = [
    "tooltip"
];
var $07d418a26c73ef13$export$9923361bd43fa030 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var tooltip = props.tooltip, iconButtonProps = (0, $gmKOS.default)(props, $07d418a26c73ef13$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9UTJR))), {
            label: typeof tooltip === "string" ? tooltip : "Appswitcher Icon"
        }),
        tooltip: tooltip,
        ref: ref
    }, iconButtonProps));
});
var // exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop
$07d418a26c73ef13$export$2e2bcd8739ae039 = function(props) {};

});
parcelRegister("djxp7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b16f61a30940340$export$2e2bcd8739ae039; });
function $9b16f61a30940340$export$2e2bcd8739ae039() {
    return $9b16f61a30940340$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9b16f61a30940340$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("gmKOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bea304d60c1d1a20$export$2e2bcd8739ae039; });

var $cfzV9 = parcelRequire("cfzV9");
function $bea304d60c1d1a20$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $cfzV9.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("cfzV9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $024d34a4a453de47$export$2e2bcd8739ae039; });
function $024d34a4a453de47$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("9UTJR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7384948d85569f8d$var$_react = $7384948d85569f8d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $7384948d85569f8d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7384948d85569f8d$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $7384948d85569f8d$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z"/></svg>`
    }, props));
$7384948d85569f8d$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $7384948d85569f8d$var$_default = $7384948d85569f8d$var$AppSwitcherIcon;
module.exports.default = $7384948d85569f8d$var$_default;

});
parcelRegister("fWDTK", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $b9bb38bfa81f64b1$export$f04a61298a47a40f; });

var $djxp7 = parcelRequire("djxp7");

var $lrtwL = parcelRequire("lrtwL");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $1EafC = parcelRequire("1EafC");

var $kwxY8 = parcelRequire("kwxY8");
function $b9bb38bfa81f64b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9bb38bfa81f64b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9bb38bfa81f64b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9bb38bfa81f64b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $b9bb38bfa81f64b1$var$iconStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $b9bb38bfa81f64b1$var$_objectSpread($b9bb38bfa81f64b1$var$_objectSpread({}, (0, $kwxY8.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $b9bb38bfa81f64b1$var$baseHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $b9bb38bfa81f64b1$var$primaryEqualsSecondaryHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $b9bb38bfa81f64b1$var$secondaryTransparentHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $b9bb38bfa81f64b1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $2ZUkg.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $kwxY8.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $2ZUkg.jsx)("span", (0, $djxp7.default)({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $1EafC.getBackground)()
        }
    }, glyphProps, {
        css: [
            $b9bb38bfa81f64b1$var$iconStyles,
            $b9bb38bfa81f64b1$var$baseHcmStyles,
            primaryColor === secondaryColor && $b9bb38bfa81f64b1$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $b9bb38bfa81f64b1$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $2ZUkg.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $b9bb38bfa81f64b1$export$2e2bcd8739ae039 = $b9bb38bfa81f64b1$export$f04a61298a47a40f;

});
parcelRegister("lrtwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9c3061e2f1bc19d$export$2e2bcd8739ae039; });

var $bevLx = parcelRequire("bevLx");
function $f9c3061e2f1bc19d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bevLx.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("bevLx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82d9a4822534b70e$export$2e2bcd8739ae039; });

var $1Ior6 = parcelRequire("1Ior6");

var $hHECZ = parcelRequire("hHECZ");
function $82d9a4822534b70e$export$2e2bcd8739ae039(t) {
    var i = (0, $hHECZ.default)(t, "string");
    return "symbol" == (0, $1Ior6.default)(i) ? i : i + "";
}

});
parcelRegister("1Ior6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13fcdb04453c9a08$export$2e2bcd8739ae039; });
function $13fcdb04453c9a08$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $13fcdb04453c9a08$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $13fcdb04453c9a08$export$2e2bcd8739ae039(o);
}

});

parcelRegister("hHECZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce35f7aa3d6a63e5$export$2e2bcd8739ae039; });

var $1Ior6 = parcelRequire("1Ior6");
function $ce35f7aa3d6a63e5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1Ior6.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1Ior6.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("1EafC", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $13317a7cd8421b96$export$18cb9425622d4e06; });
var $13317a7cd8421b96$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});

parcelRegister("kwxY8", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $ef11254e14da4401$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $ef11254e14da4401$export$3eb7d6130acfda37; });

var $i7Odp = parcelRequire("i7Odp");

var $2ZUkg = parcelRequire("2ZUkg");
var $ef11254e14da4401$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $ef11254e14da4401$var$smallStyles = (0, $2ZUkg.css)((0, $i7Odp.dimensions).small);
var $ef11254e14da4401$var$mediumStyles = (0, $2ZUkg.css)((0, $i7Odp.dimensions).medium);
var $ef11254e14da4401$var$largeStyles = (0, $2ZUkg.css)((0, $i7Odp.dimensions).large);
var $ef11254e14da4401$var$xlargeStyles = (0, $2ZUkg.css)((0, $i7Odp.dimensions).xlarge);
var $ef11254e14da4401$export$ef0ad74202575b64 = {
    small: $ef11254e14da4401$var$smallStyles,
    medium: $ef11254e14da4401$var$mediumStyles,
    large: $ef11254e14da4401$var$largeStyles,
    xlarge: $ef11254e14da4401$var$xlargeStyles
};
var $ef11254e14da4401$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $i7Odp.dimensions)[size];
    return undefined;
};

});
parcelRegister("i7Odp", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $d31fd52b12861d4d$export$62ad7b0c781000e9; });
var $d31fd52b12861d4d$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $d31fd52b12861d4d$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $d31fd52b12861d4d$export$62ad7b0c781000e9 = {
    small: {
        width: $d31fd52b12861d4d$export$c647cb0ee6e282fe.small,
        height: $d31fd52b12861d4d$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $d31fd52b12861d4d$export$c647cb0ee6e282fe.medium,
        height: $d31fd52b12861d4d$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $d31fd52b12861d4d$export$c647cb0ee6e282fe.large,
        height: $d31fd52b12861d4d$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $d31fd52b12861d4d$export$c647cb0ee6e282fe.xlarge,
        height: $d31fd52b12861d4d$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("2okzL", function(module, exports) {

$parcel$export(module.exports, "IconButton", function () { return $1bddc893ff280b89$export$c25acd513dcc8062; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $7HgHi = parcelRequire("7HgHi");

var $iSjV6 = parcelRequire("iSjV6");

var $72HvB = parcelRequire("72HvB");

var $hOuDE = parcelRequire("hOuDE");
var $1bddc893ff280b89$var$_excluded = [
    "icon",
    "label",
    "testId",
    "tooltip"
];
var $1bddc893ff280b89$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var icon = props.icon, label = props.label, testId = props.testId, tooltip = props.tooltip, buttonProps = (0, $gmKOS.default)(props, $1bddc893ff280b89$var$_excluded);
    var theme = (0, $72HvB.useTheme)();
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7HgHi.default), (0, $djxp7.default)({
        appearance: "primary",
        "aria-label": label,
        testId: testId,
        iconBefore: icon,
        ref: ref,
        theme: (0, $hOuDE.getIconButtonTheme)(theme)
    }, buttonProps));
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSjV6.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("7HgHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59a980466fbf5f5c$export$2e2bcd8739ae039; });

var $djxp7 = parcelRequire("djxp7");

var $cGZ0i = parcelRequire("cGZ0i");

var $lrtwL = parcelRequire("lrtwL");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $3z5HQ = parcelRequire("3z5HQ");

var $iBdKh = parcelRequire("iBdKh");

var $7NyeB = parcelRequire("7NyeB");

var $eRMku = parcelRequire("eRMku");

var $hJlec = parcelRequire("hJlec");
var $59a980466fbf5f5c$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $59a980466fbf5f5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59a980466fbf5f5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59a980466fbf5f5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59a980466fbf5f5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $59a980466fbf5f5c$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $59a980466fbf5f5c$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $59a980466fbf5f5c$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $hJlec.defaultThemeFn) : _ref2$theme, rest = (0, $gmKOS.default)(_ref2, $59a980466fbf5f5c$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $59a980466fbf5f5c$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $iSvIT.useState)($59a980466fbf5f5c$var$initial), _useState2 = (0, $cGZ0i.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $59a980466fbf5f5c$var$_objectSpread($59a980466fbf5f5c$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $59a980466fbf5f5c$var$_objectSpread($59a980466fbf5f5c$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $59a980466fbf5f5c$var$_objectSpread($59a980466fbf5f5c$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $59a980466fbf5f5c$var$_objectSpread($59a980466fbf5f5c$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $59a980466fbf5f5c$var$_objectSpread($59a980466fbf5f5c$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $iSvIT.useCallback)(function(event) {
        setState(function(current) {
            return $59a980466fbf5f5c$var$_objectSpread($59a980466fbf5f5c$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hJlec.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3z5HQ.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hJlec.default).Consumer, (0, $djxp7.default)({
            mode: mode,
            state: $59a980466fbf5f5c$var$getInteractionState($59a980466fbf5f5c$var$_objectSpread($59a980466fbf5f5c$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $7NyeB.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iBdKh.default), (0, $djxp7.default)({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eRMku.default), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $hJlec.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$59a980466fbf5f5c$var$CustomThemeButton.displayName = "CustomThemeButton";
var $59a980466fbf5f5c$export$2e2bcd8739ae039 = $59a980466fbf5f5c$var$CustomThemeButton;

});
parcelRegister("cGZ0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93d8ba580e76e6f3$export$2e2bcd8739ae039; });

var $wgXzH = parcelRequire("wgXzH");

var $3UZ6W = parcelRequire("3UZ6W");

var $jqkne = parcelRequire("jqkne");

var $1hkMo = parcelRequire("1hkMo");
function $93d8ba580e76e6f3$export$2e2bcd8739ae039(r, e) {
    return (0, $wgXzH.default)(r) || (0, $3UZ6W.default)(r, e) || (0, $jqkne.default)(r, e) || (0, $1hkMo.default)();
}

});
parcelRegister("wgXzH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0610252734debc24$export$2e2bcd8739ae039; });
function $0610252734debc24$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("3UZ6W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2da6016f1189c250$export$2e2bcd8739ae039; });
function $2da6016f1189c250$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("jqkne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2403fd73172005f$export$2e2bcd8739ae039; });

var $fNDAM = parcelRequire("fNDAM");
function $e2403fd73172005f$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fNDAM.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fNDAM.default)(r, a) : void 0;
    }
}

});
parcelRegister("fNDAM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b80a24d40674fd4c$export$2e2bcd8739ae039; });
function $b80a24d40674fd4c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("1hkMo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee77f5911159f0f$export$2e2bcd8739ae039; });
function $0ee77f5911159f0f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3z5HQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298911166bc52732$export$2e2bcd8739ae039; });

var $3UGNL = parcelRequire("3UGNL");
// Create default global light theme
var $298911166bc52732$var$_createTheme = (0, $3UGNL.createTheme)(function() {
    return {
        mode: "light"
    };
}), $298911166bc52732$var$Provider = $298911166bc52732$var$_createTheme.Provider, $298911166bc52732$var$Consumer = $298911166bc52732$var$_createTheme.Consumer, $298911166bc52732$export$7692396083754928 = $298911166bc52732$var$_createTheme.useTheme;
var $298911166bc52732$export$2e2bcd8739ae039 = {
    Provider: $298911166bc52732$var$Provider,
    Consumer: $298911166bc52732$var$Consumer
};

});
parcelRegister("3UGNL", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $2d97cd9568c108cb$export$25d302a5b900a763; });

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");
var $2d97cd9568c108cb$var$_excluded = [
    "children"
];
function $2d97cd9568c108cb$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $gmKOS.default)(props, $2d97cd9568c108cb$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("iBdKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8a6583e7ed63779$export$2e2bcd8739ae039; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $3sT74 = parcelRequire("3sT74");

var $8QUK9 = parcelRequire("8QUK9");

var $gDvjJ = parcelRequire("gDvjJ");

var $ir17B = parcelRequire("ir17B");

var $etWbY = parcelRequire("etWbY");

var $k7Cfw = parcelRequire("k7Cfw");

var $ldNOS = parcelRequire("ldNOS");

var $d7ISO = parcelRequire("d7ISO");

var $5VcIE = parcelRequire("5VcIE");
var $d8a6583e7ed63779$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $d8a6583e7ed63779$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
var $d8a6583e7ed63779$var$iconBeforeSpacingFixStyle = (0, $2ZUkg.css)({
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $d8a6583e7ed63779$var$iconAfterSpacingFixStyle = (0, $2ZUkg.css)({
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $d8a6583e7ed63779$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $5VcIE.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $d8a6583e7ed63779$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $5VcIE.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $2ZUkg.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $d8a6583e7ed63779$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $8QUK9.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $8QUK9.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, $gmKOS.default)(props, $d8a6583e7ed63779$var$_excluded);
    var ourRef = (0, $iSvIT.useRef)();
    var setRef = (0, $iSvIT.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gDvjJ.default)(ourRef, autoFocus);
    var interactionContext = (0, $iSvIT.useContext)((0, $etWbY.default));
    var handleClick = (0, $iSvIT.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $3sT74.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "17.14.2",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $iSvIT.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $iSvIT.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $2ZUkg.css)((0, $d7ISO.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $k7Cfw.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $k7Cfw.N500), ")"), " !important")
        }
    };
    return (0, $2ZUkg.jsx)((0, $ir17B.default), null, (0, $2ZUkg.jsx)(Component, (0, $djxp7.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d8a6583e7ed63779$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $ldNOS.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $2ZUkg.jsx)("span", {
        css: [
            fadeStyles,
            (0, $d7ISO.getIconStyle)({
                spacing: spacing
            }),
            $d8a6583e7ed63779$var$getSpacingFix(children, $d8a6583e7ed63779$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $d8a6583e7ed63779$var$getChildren(children, [
        fadeStyles,
        (0, $d7ISO.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $2ZUkg.jsx)("span", {
        css: [
            fadeStyles,
            (0, $d7ISO.getIconStyle)({
                spacing: spacing
            }),
            $d8a6583e7ed63779$var$getSpacingFix(children, $d8a6583e7ed63779$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $2ZUkg.jsx)("span", {
        css: [
            (0, $d7ISO.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("3sT74", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $285ebcee1807c7fb$export$a4687b0234b40e28; });

var $lrtwL = parcelRequire("lrtwL");

var $iSvIT = parcelRequire("iSvIT");

var $beLc6 = parcelRequire("beLc6");

var $gyAPl = parcelRequire("gyAPl");
function $285ebcee1807c7fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $285ebcee1807c7fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $285ebcee1807c7fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $285ebcee1807c7fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $285ebcee1807c7fb$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $beLc6.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $gyAPl.useTrackedRef)(analyticsData);
    var fnRef = (0, $gyAPl.useTrackedRef)(fn);
    var handler = (0, $iSvIT.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $285ebcee1807c7fb$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("beLc6", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $82e59c4e05a52b29$export$5bf35293e545f20c; });

var $6LIwV = parcelRequire("6LIwV");

var $aClJE = parcelRequire("aClJE");

var $3rTUC = parcelRequire("3rTUC");
function $82e59c4e05a52b29$export$5bf35293e545f20c() {
    var analyticsContext = (0, $3rTUC.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $aClJE.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("aClJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bae502ce4807501$export$2e2bcd8739ae039; });

var $7i8I2 = parcelRequire("7i8I2");

var $fciT1 = parcelRequire("fciT1");

var $AYDNP = parcelRequire("AYDNP");

var $askTu = parcelRequire("askTu");

var $4BqL1 = parcelRequire("4BqL1");

var $vCHpe = parcelRequire("vCHpe");

var $bZhh8 = parcelRequire("bZhh8");

var $6NMkh = parcelRequire("6NMkh");

var $lrtwL = parcelRequire("lrtwL");

var $4sa65 = parcelRequire("4sa65");
function $7bae502ce4807501$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7bae502ce4807501$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $6NMkh.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6NMkh.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $bZhh8.default)(this, result);
    };
}
function $7bae502ce4807501$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7bae502ce4807501$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7bae502ce4807501$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7bae502ce4807501$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $7bae502ce4807501$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, $vCHpe.default)(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $7bae502ce4807501$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $fciT1.default)(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, $lrtwL.default)((0, $askTu.default)(_this), "_isUIAnalyticsEvent", true);
        (0, $lrtwL.default)((0, $askTu.default)(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $7i8I2.default)(_this.context);
            var handlers = (0, $7i8I2.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $lrtwL.default)((0, $askTu.default)(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, $askTu.default)(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $AYDNP.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, $4BqL1.default)((0, $6NMkh.default)(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $4sa65.default));

});
parcelRegister("7i8I2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54f0f85a80ac5e13$export$2e2bcd8739ae039; });

var $9Rq8k = parcelRequire("9Rq8k");

var $1IWaL = parcelRequire("1IWaL");

var $jqkne = parcelRequire("jqkne");

var $egl9X = parcelRequire("egl9X");
function $54f0f85a80ac5e13$export$2e2bcd8739ae039(r) {
    return (0, $9Rq8k.default)(r) || (0, $1IWaL.default)(r) || (0, $jqkne.default)(r) || (0, $egl9X.default)();
}

});
parcelRegister("9Rq8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72dd55d8f54388e1$export$2e2bcd8739ae039; });

var $fNDAM = parcelRequire("fNDAM");
function $72dd55d8f54388e1$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $fNDAM.default)(r);
}

});

parcelRegister("1IWaL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1417065aba114a1c$export$2e2bcd8739ae039; });
function $1417065aba114a1c$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("egl9X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a622f93016953120$export$2e2bcd8739ae039; });
function $a622f93016953120$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fciT1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b106a07537475d6f$export$2e2bcd8739ae039; });
function $b106a07537475d6f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("AYDNP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06f266f14eeb3efc$export$2e2bcd8739ae039; });

var $bevLx = parcelRequire("bevLx");
function $06f266f14eeb3efc$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $bevLx.default)(o.key), o);
    }
}
function $06f266f14eeb3efc$export$2e2bcd8739ae039(e, r, t) {
    return r && $06f266f14eeb3efc$var$_defineProperties(e.prototype, r), t && $06f266f14eeb3efc$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("askTu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79ccba0b1fb2871b$export$2e2bcd8739ae039; });
function $79ccba0b1fb2871b$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("4BqL1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359f5f9834661e43$export$2e2bcd8739ae039; });

var $35Lv7 = parcelRequire("35Lv7");
function $359f5f9834661e43$export$2e2bcd8739ae039() {
    return $359f5f9834661e43$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $35Lv7.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $359f5f9834661e43$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("35Lv7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2406af6906944794$export$2e2bcd8739ae039; });

var $6NMkh = parcelRequire("6NMkh");
function $2406af6906944794$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $6NMkh.default)(t)););
    return t;
}

});
parcelRegister("6NMkh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f3cce3f2d476417$export$2e2bcd8739ae039; });
function $4f3cce3f2d476417$export$2e2bcd8739ae039(t) {
    return $4f3cce3f2d476417$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4f3cce3f2d476417$export$2e2bcd8739ae039(t);
}

});



parcelRegister("vCHpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05f0ea332115f8e5$export$2e2bcd8739ae039; });

var $dXChM = parcelRequire("dXChM");
function $05f0ea332115f8e5$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $dXChM.default)(t, e);
}

});
parcelRegister("dXChM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a29e7bd08253784d$export$2e2bcd8739ae039; });
function $a29e7bd08253784d$export$2e2bcd8739ae039(t, e) {
    return $a29e7bd08253784d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a29e7bd08253784d$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("bZhh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba2cab7c09a02f6$export$2e2bcd8739ae039; });

var $1Ior6 = parcelRequire("1Ior6");

var $askTu = parcelRequire("askTu");
function $8ba2cab7c09a02f6$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $1Ior6.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $askTu.default)(t);
}

});

parcelRegister("4sa65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33e19c05dc0836a7$export$2e2bcd8739ae039; });

var $1Ior6 = parcelRequire("1Ior6");

var $fciT1 = parcelRequire("fciT1");

var $AYDNP = parcelRequire("AYDNP");

var $lrtwL = parcelRequire("lrtwL");
function $33e19c05dc0836a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $33e19c05dc0836a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $33e19c05dc0836a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $33e19c05dc0836a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $33e19c05dc0836a7$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $33e19c05dc0836a7$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $33e19c05dc0836a7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $fciT1.default)(this, AnalyticsEvent);
        (0, $lrtwL.default)(this, "_isAnalyticsEvent", true);
        (0, $lrtwL.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $33e19c05dc0836a7$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, $AYDNP.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $1Ior6.default)(updater) === "object") this.payload = $33e19c05dc0836a7$var$_objectSpread($33e19c05dc0836a7$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("3rTUC", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $282f43b82d08f5a4$export$d1f587f82ad51c4; });

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $282f43b82d08f5a4$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};

});


parcelRegister("gyAPl", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $c0dc636bb431be73$export$1d27a74659855e44; });

var $iSvIT = parcelRequire("iSvIT");
var $c0dc636bb431be73$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("8QUK9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $671f32160d3fbd06$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $671f32160d3fbd06$export$2e2bcd8739ae039() {}

});

parcelRegister("gDvjJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1c894cd1ef599cd$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $c1c894cd1ef599cd$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("ir17B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6bb9e5df507aa15$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");
var $d6bb9e5df507aa15$var$BORDER_WIDTH = 2;
var $d6bb9e5df507aa15$var$baseFocusOutsideStyles = (0, $2ZUkg.css)({
    outline: "".concat($d6bb9e5df507aa15$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $d6bb9e5df507aa15$var$BORDER_WIDTH
});
var $d6bb9e5df507aa15$var$baseInsetStyles = (0, $2ZUkg.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    outlineOffset: -$d6bb9e5df507aa15$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $d6bb9e5df507aa15$var$focusRingStyles = (0, $2ZUkg.css)({
    "&:focus-visible": $d6bb9e5df507aa15$var$baseFocusOutsideStyles,
    "@supports not selector(*:focus-visible)": {
        "&:focus": $d6bb9e5df507aa15$var$baseFocusOutsideStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $d6bb9e5df507aa15$var$insetFocusRingStyles = (0, $2ZUkg.css)({
    "&:focus-visible": $d6bb9e5df507aa15$var$baseInsetStyles,
    "@supports not selector(*:focus-visible)": {
        "&:focus": $d6bb9e5df507aa15$var$baseInsetStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $d6bb9e5df507aa15$var$FocusRing = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $d6bb9e5df507aa15$var$baseInsetStyles : $d6bb9e5df507aa15$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $d6bb9e5df507aa15$var$insetFocusRingStyles : $d6bb9e5df507aa15$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $2ZUkg.jsx)((0, $2ZUkg.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $iSvIT.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $iSvIT.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$d6bb9e5df507aa15$var$FocusRing.displayName = "FocusRing";
var $d6bb9e5df507aa15$export$2e2bcd8739ae039 = $d6bb9e5df507aa15$var$FocusRing;

});

parcelRegister("etWbY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8b0e9dae4403af2$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $a8b0e9dae4403af2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});

parcelRegister("k7Cfw", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $ea6221a12291376e$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $ea6221a12291376e$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $ea6221a12291376e$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $ea6221a12291376e$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $ea6221a12291376e$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $ea6221a12291376e$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $ea6221a12291376e$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $ea6221a12291376e$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $ea6221a12291376e$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $ea6221a12291376e$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $ea6221a12291376e$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $ea6221a12291376e$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $ea6221a12291376e$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $ea6221a12291376e$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $ea6221a12291376e$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $ea6221a12291376e$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $ea6221a12291376e$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $ea6221a12291376e$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $ea6221a12291376e$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $ea6221a12291376e$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $ea6221a12291376e$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $ea6221a12291376e$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $ea6221a12291376e$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $ea6221a12291376e$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $ea6221a12291376e$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $ea6221a12291376e$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $ea6221a12291376e$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $ea6221a12291376e$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $ea6221a12291376e$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "DN400", function () { return $ea6221a12291376e$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $ea6221a12291376e$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $ea6221a12291376e$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $ea6221a12291376e$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $ea6221a12291376e$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $ea6221a12291376e$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $ea6221a12291376e$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $ea6221a12291376e$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $dEbxj = parcelRequire("dEbxj");
var $ea6221a12291376e$export$4b84fd0e2c617bd = "#FFEBE6";
var $ea6221a12291376e$export$b34b069eff244586 = "#FFBDAD";
var $ea6221a12291376e$export$be802dd0d8b57f35 = "#FF8F73";
var $ea6221a12291376e$export$60847d42f9da92a6 = "#FF7452";
var $ea6221a12291376e$export$4a7404f376229999 = "#FF5630";
var $ea6221a12291376e$export$2010d0fb4295b346 = "#DE350B";
var $ea6221a12291376e$export$2837b5a1a71d5c02 = "#BF2600";
var $ea6221a12291376e$export$8d9596b529bbb9cf = "#FFFAE6";
var $ea6221a12291376e$export$41060a744ab0b7ae = "#FFF0B3";
var $ea6221a12291376e$export$1cc05bbbf340e559 = "#FFE380";
var $ea6221a12291376e$export$5aae31392d72caaa = "#FFC400";
var $ea6221a12291376e$export$c6930421db9fa514 = "#FFAB00";
var $ea6221a12291376e$export$59619663aa6500fb = "#FF991F";
var $ea6221a12291376e$export$874739ea9e379ab6 = "#FF8B00";
var $ea6221a12291376e$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $ea6221a12291376e$export$69a3bf21b9686c2b = "#ABF5D1";
var $ea6221a12291376e$export$afbce1382ec95f73 = "#79F2C0";
var $ea6221a12291376e$export$747d86715d4175de = "#57D9A3";
var $ea6221a12291376e$export$940e1f69e873f202 = "#36B37E";
var $ea6221a12291376e$export$a49394138f7b8e85 = "#00875A";
var $ea6221a12291376e$export$6fa04827ac68a4fb = "#006644";
var $ea6221a12291376e$export$226de0355ed012f8 = "#DEEBFF";
var $ea6221a12291376e$export$8c13c2ee36917869 = "#B3D4FF";
var $ea6221a12291376e$export$ecfc1dff386a3e7a = "#4C9AFF";
var $ea6221a12291376e$export$215b7063051591f1 = "#2684FF";
var $ea6221a12291376e$export$e62e8919cca44969 = "#0065FF";
var $ea6221a12291376e$export$b3de0ae08da2ce64 = "#0052CC";
var $ea6221a12291376e$export$a6ee3d71bc067634 = "#0747A6";
var $ea6221a12291376e$export$363e4475840015bb = "#EAE6FF";
var $ea6221a12291376e$export$4b0a4417ed59760f = "#C0B6F2";
var $ea6221a12291376e$export$6011520a64d9a187 = "#998DD9";
var $ea6221a12291376e$export$a7175d4e9206bc80 = "#8777D9";
var $ea6221a12291376e$export$b48405b95304b5a1 = "#6554C0";
var $ea6221a12291376e$export$c71e4279dd54a18d = "#5243AA";
var $ea6221a12291376e$export$147899de772240ec = "#403294";
var $ea6221a12291376e$export$2cf711fe14c66f06 = "#E6FCFF";
var $ea6221a12291376e$export$7a8f4d33f6f9772c = "#B3F5FF";
var $ea6221a12291376e$export$776c9c497ef08533 = "#79E2F2";
var $ea6221a12291376e$export$69cb3ca10c1e330e = "#00C7E6";
var $ea6221a12291376e$export$9dc1ef0f3f48059b = "#00B8D9";
var $ea6221a12291376e$export$7c835c78b6fcdef8 = "#00A3BF";
var $ea6221a12291376e$export$6036577f95c3877e = "#008DA6";
var $ea6221a12291376e$export$29a4f05edc054374 = "#FFFFFF";
var $ea6221a12291376e$export$e655ef011c4aa1a2 = "#FAFBFC";
var $ea6221a12291376e$export$9fdfb749e33cdf97 = "#F4F5F7";
var $ea6221a12291376e$export$3e51e8f1440314ba = "#EBECF0";
var $ea6221a12291376e$export$1ce2d1575d444ceb = "#DFE1E6";
var $ea6221a12291376e$export$8754fc7e6d8b3000 = "#C1C7D0";
var $ea6221a12291376e$export$c2e91cbeada39b8b = "#B3BAC5";
var $ea6221a12291376e$export$5f71e19f3a7ad9de = "#A5ADBA";
var $ea6221a12291376e$export$eaa8c8a70ac22806 = "#97A0AF";
var $ea6221a12291376e$export$7c87d337fb91a97d = "#8993A4";
var $ea6221a12291376e$export$d6447c357493214f = "#7A869A";
var $ea6221a12291376e$export$f563ee71e9ee74cd = "#6B778C";
var $ea6221a12291376e$export$e2ef2124cf4024b1 = "#5E6C84";
var $ea6221a12291376e$export$eece5f492e429f08 = "#505F79";
var $ea6221a12291376e$export$c39c0fe0f26207ae = "#42526E";
var $ea6221a12291376e$export$7090862dc3038a9f = "#344563";
var $ea6221a12291376e$export$ad0bacf983b7ddaa = "#253858";
var $ea6221a12291376e$export$7d61b15e0da132af = "#172B4D";
var $ea6221a12291376e$export$fbda843f0a27fe96 = "#091E42";
var $ea6221a12291376e$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $ea6221a12291376e$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $ea6221a12291376e$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $ea6221a12291376e$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $ea6221a12291376e$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $ea6221a12291376e$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $ea6221a12291376e$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $ea6221a12291376e$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $ea6221a12291376e$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $ea6221a12291376e$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $ea6221a12291376e$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $ea6221a12291376e$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $ea6221a12291376e$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $ea6221a12291376e$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $ea6221a12291376e$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $ea6221a12291376e$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $ea6221a12291376e$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $ea6221a12291376e$export$2f6319cf7d736c2a = "#E6EDFA";
var $ea6221a12291376e$export$95126bc8884d6634 = "#DCE5F5";
var $ea6221a12291376e$export$8338d8c35d44ff1 = "#CED9EB";
var $ea6221a12291376e$export$5368d76ae4fbbda7 = "#B8C7E0";
var $ea6221a12291376e$export$9f0a771d16ec8d36 = "#ABBBD6";
var $ea6221a12291376e$export$abcf8c38338b4aa5 = "#9FB0CC";
var $ea6221a12291376e$export$97e81faa16a182c7 = "#8C9CB8";
var $ea6221a12291376e$export$bfe21c59123ecf33 = "#7988A3";
var $ea6221a12291376e$export$ee82aa2ea6a1558 = "#67758F";
var $ea6221a12291376e$export$682927c6ed76be02 = "#56637A";
var $ea6221a12291376e$export$91fd9994c5be9757 = "#455166";
var $ea6221a12291376e$export$d281fbfe3cff2df6 = "#3B475C";
var $ea6221a12291376e$export$3902c91d8b98a753 = "#313D52";
var $ea6221a12291376e$export$8e8133c1ba5845b5 = "#283447";
var $ea6221a12291376e$export$33ff357f6620b39 = "#202B3D";
var $ea6221a12291376e$export$633847cf062b69e0 = "#1B2638";
var $ea6221a12291376e$export$9776a6e503bdbf76 = "#121A29";
var $ea6221a12291376e$export$6c813d5160dff5db = "#0E1624";
var $ea6221a12291376e$export$3d4f271a500072a = "#0D1424";
var $ea6221a12291376e$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $ea6221a12291376e$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $ea6221a12291376e$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $ea6221a12291376e$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $ea6221a12291376e$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $ea6221a12291376e$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $ea6221a12291376e$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $ea6221a12291376e$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $ea6221a12291376e$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $ea6221a12291376e$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $ea6221a12291376e$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $ea6221a12291376e$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $ea6221a12291376e$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $ea6221a12291376e$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $ea6221a12291376e$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $ea6221a12291376e$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $ea6221a12291376e$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $ea6221a12291376e$export$8ce1fd94bee2f412 = (0, $dEbxj.default)({
    light: "var(--ds-surface, ".concat($ea6221a12291376e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($ea6221a12291376e$export$633847cf062b69e0, ")")
});
var $ea6221a12291376e$export$b861914ea877b580 = (0, $dEbxj.default)({
    light: "var(--ds-background-selected, ".concat($ea6221a12291376e$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($ea6221a12291376e$export$8c13c2ee36917869, ")")
});
var $ea6221a12291376e$export$3f1b020df94387af = (0, $dEbxj.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($ea6221a12291376e$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($ea6221a12291376e$export$d281fbfe3cff2df6, ")")
});
var $ea6221a12291376e$export$c0183dbab98ca63e = (0, $dEbxj.default)({
    light: "var(--ds-surface-overlay, ".concat($ea6221a12291376e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($ea6221a12291376e$export$8e8133c1ba5845b5, ")")
});
var $ea6221a12291376e$export$6f093cfa640b7166 = (0, $dEbxj.default)({
    light: "var(--ds-text, ".concat($ea6221a12291376e$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($ea6221a12291376e$export$5368d76ae4fbbda7, ")")
});
var $ea6221a12291376e$export$42f8e9c698766e7a = (0, $dEbxj.default)({
    light: "var(--ds-text, ".concat($ea6221a12291376e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($ea6221a12291376e$export$5368d76ae4fbbda7, ")")
});
var $ea6221a12291376e$export$c2d157ca1c34b6e3 = (0, $dEbxj.default)({
    light: "var(--ds-text-selected, ".concat($ea6221a12291376e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($ea6221a12291376e$export$b3de0ae08da2ce64, ")")
});
var $ea6221a12291376e$export$1905ba28d7cf066f = (0, $dEbxj.default)({
    light: "var(--ds-text-subtlest, ".concat($ea6221a12291376e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($ea6221a12291376e$export$97e81faa16a182c7, ")")
});
var $ea6221a12291376e$export$bd9002130d306d39 = (0, $dEbxj.default)({
    light: "var(--ds-text-subtlest, ".concat($ea6221a12291376e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($ea6221a12291376e$export$bfe21c59123ecf33, ")")
});
var $ea6221a12291376e$export$46e4a324ac90507f = (0, $dEbxj.default)({
    light: "var(--ds-text, ".concat($ea6221a12291376e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($ea6221a12291376e$export$5368d76ae4fbbda7, ")")
});
var $ea6221a12291376e$export$79f3f2b82beb0d36 = (0, $dEbxj.default)({
    light: "var(--ds-text-subtlest, ".concat($ea6221a12291376e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($ea6221a12291376e$export$97e81faa16a182c7, ")")
});
var $ea6221a12291376e$export$7bb0d5c671655cc4 = (0, $dEbxj.default)({
    light: $ea6221a12291376e$export$9fdfb749e33cdf97,
    dark: $ea6221a12291376e$export$8e8133c1ba5845b5
});
var $ea6221a12291376e$export$9c30223ca0a664fb = (0, $dEbxj.default)({
    light: "var(--ds-link, ".concat($ea6221a12291376e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($ea6221a12291376e$export$ecfc1dff386a3e7a, ")")
});
var $ea6221a12291376e$export$7ed258b0728b004b = (0, $dEbxj.default)({
    light: "var(--ds-link-pressed, ".concat($ea6221a12291376e$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($ea6221a12291376e$export$215b7063051591f1, ")")
});
var $ea6221a12291376e$export$dfa920d8decc8a59 = (0, $dEbxj.default)({
    light: "var(--ds-link-pressed, ".concat($ea6221a12291376e$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($ea6221a12291376e$export$ecfc1dff386a3e7a, ")")
});
var $ea6221a12291376e$export$6069e6ad5c78f632 = (0, $dEbxj.default)({
    light: "var(--ds-border-focused, ".concat($ea6221a12291376e$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($ea6221a12291376e$export$215b7063051591f1, ")")
});
var $ea6221a12291376e$export$9ad721cf3b3debe0 = (0, $dEbxj.default)({
    light: "var(--ds-background-brand-bold, ".concat($ea6221a12291376e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($ea6221a12291376e$export$ecfc1dff386a3e7a, ")")
});
var $ea6221a12291376e$export$2aa0182783e7e9de = (0, $dEbxj.default)({
    light: $ea6221a12291376e$export$b3de0ae08da2ce64,
    dark: $ea6221a12291376e$export$ecfc1dff386a3e7a
});
var $ea6221a12291376e$export$8bf7dff220b82b4a = (0, $dEbxj.default)({
    light: $ea6221a12291376e$export$9dc1ef0f3f48059b,
    dark: $ea6221a12291376e$export$69cb3ca10c1e330e
});
var $ea6221a12291376e$export$e13cce2a2d16a9d4 = (0, $dEbxj.default)({
    light: $ea6221a12291376e$export$b48405b95304b5a1,
    dark: $ea6221a12291376e$export$6011520a64d9a187
});
var $ea6221a12291376e$export$a90204d1394caf30 = (0, $dEbxj.default)({
    light: $ea6221a12291376e$export$4a7404f376229999,
    dark: $ea6221a12291376e$export$4a7404f376229999
});
var $ea6221a12291376e$export$594c5a8758200c32 = (0, $dEbxj.default)({
    light: $ea6221a12291376e$export$c6930421db9fa514,
    dark: $ea6221a12291376e$export$c6930421db9fa514
});
var $ea6221a12291376e$export$955a2ebd2fb142ae = (0, $dEbxj.default)({
    light: $ea6221a12291376e$export$940e1f69e873f202,
    dark: $ea6221a12291376e$export$940e1f69e873f202
});
var $ea6221a12291376e$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($ea6221a12291376e$export$8d43898f60b96a82, ")");
};

});
parcelRegister("dEbxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ef7f5ab4c46c832$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $g2lTQ = parcelRequire("g2lTQ");
// Unpack custom variants, and get correct value for the current theme
function $9ef7f5ab4c46c832$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $g2lTQ.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $9ef7f5ab4c46c832$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $9ef7f5ab4c46c832$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $g2lTQ.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("g2lTQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bacdd216b59afb9a$export$2e2bcd8739ae039; });

var $dTCtZ = parcelRequire("dTCtZ");
function $bacdd216b59afb9a$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $dTCtZ.CHANNEL) in props.theme) return props.theme[0, $dTCtZ.CHANNEL];
        else if ("mode" in props.theme && (0, $dTCtZ.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $dTCtZ.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("dTCtZ", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $a1de434bc01c8bbd$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $a1de434bc01c8bbd$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $a1de434bc01c8bbd$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $a1de434bc01c8bbd$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $a1de434bc01c8bbd$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "layers", function () { return $a1de434bc01c8bbd$export$7be255094ccdc533; });

var $hjMbg = parcelRequire("hjMbg");

var $k7Cfw = parcelRequire("k7Cfw");
var $a1de434bc01c8bbd$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $a1de434bc01c8bbd$export$c93026a968943f95 = "light";
var $a1de434bc01c8bbd$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $a1de434bc01c8bbd$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $a1de434bc01c8bbd$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $a1de434bc01c8bbd$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $a1de434bc01c8bbd$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $a1de434bc01c8bbd$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $a1de434bc01c8bbd$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $a1de434bc01c8bbd$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $k7Cfw.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a1de434bc01c8bbd$export$6d8204c2cb2e06b8() / 4;
    (0, $hjMbg.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $a1de434bc01c8bbd$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $a1de434bc01c8bbd$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $a1de434bc01c8bbd$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $hjMbg.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $a1de434bc01c8bbd$export$ba1d834b86d72a09 = $a1de434bc01c8bbd$export$a1b3edb637fb4f35;
var $a1de434bc01c8bbd$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $k7Cfw.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $k7Cfw.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $k7Cfw.N30A), ")")
            }
        }
    };
};

});
parcelRegister("hjMbg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9b995afbc4f7f46$export$2e2bcd8739ae039; });

var $9B3Gg = parcelRequire("9B3Gg");

var $XAEGR = parcelRequire("XAEGR");
function $c9b995afbc4f7f46$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $9B3Gg.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $c9b995afbc4f7f46$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("9B3Gg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fca6cabb6b95f26$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $6fca6cabb6b95f26$var$printed = {};
function $6fca6cabb6b95f26$export$2e2bcd8739ae039(message) {
    if ($6fca6cabb6b95f26$var$printed[message]) return;
    $6fca6cabb6b95f26$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});






parcelRegister("ldNOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f73174fc55352d92$export$2e2bcd8739ae039; });
function $f73174fc55352d92$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $f73174fc55352d92$var$tabKeyCode = 9;
function $f73174fc55352d92$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $f73174fc55352d92$var$tabKeyCode) return;
    $f73174fc55352d92$var$abort(event);
}
var $f73174fc55352d92$var$block = {
    onMouseDownCapture: $f73174fc55352d92$var$abort,
    onMouseUpCapture: $f73174fc55352d92$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $f73174fc55352d92$var$onKey,
    onKeyUpCapture: $f73174fc55352d92$var$onKey,
    onTouchStartCapture: $f73174fc55352d92$var$abort,
    onTouchEndCapture: $f73174fc55352d92$var$abort,
    onPointerDownCapture: $f73174fc55352d92$var$abort,
    onPointerUpCapture: $f73174fc55352d92$var$abort,
    onClickCapture: $f73174fc55352d92$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $f73174fc55352d92$var$abort
};
var $f73174fc55352d92$var$doNotBlock = {};
function $f73174fc55352d92$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $f73174fc55352d92$var$doNotBlock : $f73174fc55352d92$var$block;
}

});

parcelRegister("d7ISO", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $98debea63dc53822$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $98debea63dc53822$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $98debea63dc53822$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $98debea63dc53822$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $98debea63dc53822$export$1a9fe1b84c876bb5; });

var $lrtwL = parcelRequire("lrtwL");

var $2ZUkg = parcelRequire("2ZUkg");

var $dTCtZ = parcelRequire("dTCtZ");

var $fuER6 = parcelRequire("fuER6");
function $98debea63dc53822$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98debea63dc53822$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98debea63dc53822$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98debea63dc53822$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $98debea63dc53822$var$gridSize = (0, $dTCtZ.gridSize)();
var $98debea63dc53822$var$fontSize = (0, $dTCtZ.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $98debea63dc53822$var$heights = {
    default: "".concat($98debea63dc53822$var$gridSize * 4 / $98debea63dc53822$var$fontSize, "em"),
    // 32px
    compact: "".concat($98debea63dc53822$var$gridSize * 3 / $98debea63dc53822$var$fontSize, "em"),
    none: "auto"
};
var $98debea63dc53822$var$lineHeights = {
    default: $98debea63dc53822$var$heights.default,
    compact: $98debea63dc53822$var$heights.compact,
    none: "inherit"
};
var $98debea63dc53822$var$padding = {
    // 10px gutter
    default: "0 ".concat($98debea63dc53822$var$gridSize + $98debea63dc53822$var$gridSize / 4, "px"),
    compact: "0 ".concat($98debea63dc53822$var$gridSize + $98debea63dc53822$var$gridSize / 4, "px"),
    none: "0"
};
var $98debea63dc53822$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($98debea63dc53822$var$gridSize / 4, "px"),
    default: "0 ".concat($98debea63dc53822$var$gridSize / 4, "px"),
    none: "0"
};
var $98debea63dc53822$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $98debea63dc53822$var$innerMargin = {
    content: "0 ".concat($98debea63dc53822$var$gridSize / 4, "px"),
    icon: "0 ".concat($98debea63dc53822$var$gridSize / 4, "px")
};
function $98debea63dc53822$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $98debea63dc53822$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $98debea63dc53822$var$getColor({
            group: (0, $fuER6.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($98debea63dc53822$var$getColor({
            group: (0, $fuER6.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $98debea63dc53822$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $98debea63dc53822$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $98debea63dc53822$var$_objectSpread($98debea63dc53822$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $98debea63dc53822$var$heights[spacing],
        lineHeight: $98debea63dc53822$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $98debea63dc53822$var$singleIconPadding[spacing] : $98debea63dc53822$var$padding[spacing],
        verticalAlign: $98debea63dc53822$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $98debea63dc53822$var$_objectSpread({}, baseColors),
        "&:hover": $98debea63dc53822$var$_objectSpread($98debea63dc53822$var$_objectSpread({}, $98debea63dc53822$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $98debea63dc53822$var$_objectSpread($98debea63dc53822$var$_objectSpread({}, $98debea63dc53822$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $98debea63dc53822$var$_objectSpread($98debea63dc53822$var$_objectSpread({}, $98debea63dc53822$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $98debea63dc53822$var$_objectSpread($98debea63dc53822$var$_objectSpread({}, $98debea63dc53822$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $98debea63dc53822$var$_objectSpread({}, $98debea63dc53822$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $98debea63dc53822$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $2ZUkg.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $98debea63dc53822$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $98debea63dc53822$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $2ZUkg.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $98debea63dc53822$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $98debea63dc53822$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $2ZUkg.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $98debea63dc53822$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("fuER6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b479596b807035df$export$2e2bcd8739ae039; });

var $k7Cfw = parcelRequire("k7Cfw");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $b479596b807035df$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $b479596b807035df$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($k7Cfw.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($k7Cfw.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($k7Cfw.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($k7Cfw.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($b479596b807035df$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($k7Cfw.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($k7Cfw.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($k7Cfw.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($k7Cfw.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($k7Cfw.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($k7Cfw.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($k7Cfw.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($k7Cfw.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($k7Cfw.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($k7Cfw.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($k7Cfw.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($k7Cfw.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($k7Cfw.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($k7Cfw.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($k7Cfw.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($k7Cfw.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($k7Cfw.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($k7Cfw.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($k7Cfw.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($k7Cfw.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($k7Cfw.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($k7Cfw.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($k7Cfw.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($k7Cfw.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($k7Cfw.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($k7Cfw.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($k7Cfw.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($k7Cfw.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($k7Cfw.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($b479596b807035df$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($k7Cfw.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($k7Cfw.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($k7Cfw.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($k7Cfw.N500, ")"),
                dark: "var(--ds-text, ".concat($k7Cfw.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($k7Cfw.B400, ")"),
                dark: "var(--ds-text, ".concat($k7Cfw.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($k7Cfw.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($k7Cfw.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($k7Cfw.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($k7Cfw.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($k7Cfw.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($k7Cfw.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($k7Cfw.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($k7Cfw.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($k7Cfw.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($k7Cfw.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($k7Cfw.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($k7Cfw.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($k7Cfw.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($k7Cfw.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($k7Cfw.B400, ")"),
                dark: "var(--ds-link, ".concat($k7Cfw.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($k7Cfw.B300, ")"),
                dark: "var(--ds-link, ".concat($k7Cfw.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($k7Cfw.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($k7Cfw.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($k7Cfw.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($k7Cfw.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($k7Cfw.N500, ")"),
                dark: "var(--ds-text, ".concat($k7Cfw.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($k7Cfw.B400, ")"),
                dark: "var(--ds-text, ".concat($k7Cfw.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($k7Cfw.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($k7Cfw.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($k7Cfw.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($k7Cfw.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($k7Cfw.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($k7Cfw.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($k7Cfw.N400, ")"),
                dark: "var(--ds-text, ".concat($k7Cfw.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($k7Cfw.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($k7Cfw.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($k7Cfw.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($k7Cfw.DN400, ")")
            }
        }
    }
};
var $b479596b807035df$export$2e2bcd8739ae039 = $b479596b807035df$var$values;

});


parcelRegister("5VcIE", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $011cd74bf59cc9aa$export$20bbd2efb0d734c4; });

var $iSvIT = parcelRequire("iSvIT");

var $cVOix = parcelRequire("cVOix");
var $011cd74bf59cc9aa$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $iSvIT.isValidElement)(children) && children.type === (0, $cVOix.default);
};

});
parcelRegister("cVOix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96a1d30eb5bd8f41$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $96a1d30eb5bd8f41$var$visuallyHiddenStyles = (0, $2ZUkg.css)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $96a1d30eb5bd8f41$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $2ZUkg.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $96a1d30eb5bd8f41$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $96a1d30eb5bd8f41$export$2e2bcd8739ae039 = $96a1d30eb5bd8f41$var$VisuallyHidden;

});



parcelRegister("7NyeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ad7aa49edf52a5a$export$2e2bcd8739ae039; });

var $5VcIE = parcelRequire("5VcIE");
function $5ad7aa49edf52a5a$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $5VcIE.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("eRMku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad2b812963848e04$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $9b6Aq = parcelRequire("9b6Aq");
function $ad2b812963848e04$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $ad2b812963848e04$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9b6Aq.default), {
        size: size,
        label: ", Loading",
        appearance: $ad2b812963848e04$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("9b6Aq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6aea400fa31d5c1c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $etWbY = parcelRequire("etWbY");

var $k7Cfw = parcelRequire("k7Cfw");

var $46x5t = parcelRequire("46x5t");
/**
 * Returns the appropriate circle stroke color.
 */ function $6aea400fa31d5c1c$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $k7Cfw.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $k7Cfw.N0), ")");
}
var $6aea400fa31d5c1c$var$rotate = (0, $2ZUkg.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $6aea400fa31d5c1c$var$rotateStyles = (0, $2ZUkg.css)({
    animation: "".concat($6aea400fa31d5c1c$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $6aea400fa31d5c1c$var$loadIn = (0, $2ZUkg.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $6aea400fa31d5c1c$var$loadInStyles = (0, $2ZUkg.css)({
    animation: "".concat($6aea400fa31d5c1c$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $6aea400fa31d5c1c$var$wrapperStyles = (0, $2ZUkg.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $6aea400fa31d5c1c$var$circleStyles = (0, $2ZUkg.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $6aea400fa31d5c1c$var$useLayoutEffect = typeof window === "undefined" ? (0, $iSvIT.useEffect) : (0, $iSvIT.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/{spinner}/examples)
 * - [Code](https://atlassian.design/components/{spinner}/code)
 * - [Usage](https://atlassian.design/components/{spinner}/usage)
 */ var $6aea400fa31d5c1c$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $46x5t.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $6aea400fa31d5c1c$var$getStrokeColor(appearance);
    var context = (0, $iSvIT.useContext)((0, $etWbY.default));
    $6aea400fa31d5c1c$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $2ZUkg.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $6aea400fa31d5c1c$var$wrapperStyles,
            $6aea400fa31d5c1c$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $2ZUkg.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $6aea400fa31d5c1c$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $2ZUkg.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $6aea400fa31d5c1c$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $6aea400fa31d5c1c$export$2e2bcd8739ae039 = $6aea400fa31d5c1c$var$Spinner;

});
parcelRegister("46x5t", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $2fd1636a323d23bc$export$4e9f1640bbe7a1a8; });
var $2fd1636a323d23bc$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("hJlec", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $ce871b11f4a2147f$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $ce871b11f4a2147f$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $ce871b11f4a2147f$export$2e2bcd8739ae039; });

var $lrtwL = parcelRequire("lrtwL");

var $3UGNL = parcelRequire("3UGNL");

var $d7ISO = parcelRequire("d7ISO");
function $ce871b11f4a2147f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce871b11f4a2147f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce871b11f4a2147f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce871b11f4a2147f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ce871b11f4a2147f$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $ce871b11f4a2147f$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $d7ISO.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $ce871b11f4a2147f$var$stateToSelectorMap[state];
    if (selector) result = $ce871b11f4a2147f$var$_objectSpread($ce871b11f4a2147f$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $ce871b11f4a2147f$var$_objectSpread($ce871b11f4a2147f$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $ce871b11f4a2147f$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $ce871b11f4a2147f$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $ce871b11f4a2147f$var$Theme = (0, $3UGNL.createTheme)(function(themeProps) {
    return {
        buttonStyles: $ce871b11f4a2147f$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ce871b11f4a2147f$export$2e2bcd8739ae039 = $ce871b11f4a2147f$var$Theme;

});


parcelRegister("72HvB", function(module, exports) {

$parcel$export(module.exports, "useTheme", function () { return $520a783e1cb435cc$export$93d4e7f90805808f; });

var $iSvIT = parcelRequire("iSvIT");

var $1DiDM = parcelRequire("1DiDM");
var $520a783e1cb435cc$export$93d4e7f90805808f = function useTheme() {
    return (0, $iSvIT.useContext)((0, $1DiDM.ThemeContext));
};

});
parcelRegister("1DiDM", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", function () { return $1307e4977668ddbe$export$2c657da244d00bd6; });
$parcel$export(module.exports, "ThemeProvider", function () { return $1307e4977668ddbe$export$d8964aec282183a3; });

var $iSvIT = parcelRequire("iSvIT");

var $hyWMc = parcelRequire("hyWMc");
var $1307e4977668ddbe$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $iSvIT.createContext)((0, $hyWMc.defaultTheme));
var $1307e4977668ddbe$export$d8964aec282183a3 = $1307e4977668ddbe$export$2c657da244d00bd6.Provider;

});
parcelRegister("hyWMc", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", function () { return $cc93346f910b6cdd$export$164de7ab8df77ef0; });

var $k7Cfw = parcelRequire("k7Cfw");

var $4rQpL = parcelRequire("4rQpL");

var $4jdgC = parcelRequire("4jdgC");
var $cc93346f910b6cdd$export$eeee8619e1b91cb0 = (0, $4jdgC.generateTheme)({
    name: (0, $4rQpL.DEFAULT_THEME_NAME),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $k7Cfw.N0),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $k7Cfw.B400)
});
var $cc93346f910b6cdd$export$164de7ab8df77ef0 = $cc93346f910b6cdd$export$eeee8619e1b91cb0;

});
parcelRegister("4rQpL", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_THEME_NAME", function () { return $33d2578097c14685$export$2491e13b198e597d; });
$parcel$export(module.exports, "default", function () { return $33d2578097c14685$export$2e2bcd8739ae039; });

var $8QF8A = parcelRequire("8QF8A");

var $k7Cfw = parcelRequire("k7Cfw");

var $38suQ = parcelRequire("38suQ");
var $33d2578097c14685$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, ".concat((0, $k7Cfw.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold-pressed, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B400), 0.8), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-inverse, ".concat((0, $k7Cfw.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold, ".concat((0, $k7Cfw.B400), ")"),
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-inverse, ".concat((0, $k7Cfw.N0), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-inverse, ".concat((0, $k7Cfw.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold-hovered, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B400), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "",
                backgroundColor: "",
                boxShadow: ""
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $k7Cfw.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B50), 0.6), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $k7Cfw.N600), ")"),
                backgroundColor: "transparent",
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $k7Cfw.N600), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $k7Cfw.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B50), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $k7Cfw.B400), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B50), 0.6), ")"),
                boxShadow: ""
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $k7Cfw.B400), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B50), 0.6), ")"),
                boxShadow: ""
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, ".concat((0, $k7Cfw.N0), ")"),
            color: "var(--ds-text-subtlest, ".concat((0, $k7Cfw.N200), ")")
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, ".concat((0, $k7Cfw.B400), ")"),
            color: "var(--ds-text, ".concat((0, $k7Cfw.N700), ")"),
            borderRight: "1px solid ".concat("var(--ds-border, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.N200), 0.3), ")")),
            // TODO: (DSP-1256) These colors should be moved into the Logo package
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconGradientStart: (0, $k7Cfw.B400),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconGradientStop: (0, $k7Cfw.B200),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: (0, $8QF8A.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo") ? "#357DE8" : (0, $k7Cfw.B200)
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $k7Cfw.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B50), 0.7), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $k7Cfw.N600), ")"),
                backgroundColor: "transparent",
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $k7Cfw.N600), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $k7Cfw.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B50), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $k7Cfw.B400), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B50), 0.7), ")"),
                boxShadow: "",
                borderColor: "var(--ds-border-selected, ".concat((0, $k7Cfw.B400), ")")
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $k7Cfw.B400), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $38suQ.hexToRGBA)((0, $k7Cfw.B50), 0.6), ")"),
                boxShadow: "",
                borderColor: "var(--ds-border-selected, ".concat((0, $k7Cfw.B400), ")")
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, ".concat((0, $k7Cfw.N0), ")"),
                color: "var(--ds-text-subtlest, ".concat((0, $k7Cfw.N200), ")"),
                borderColor: "var(--ds-border-input, ".concat((0, $k7Cfw.N100), ")")
            },
            focus: {
                borderColor: "var(--ds-border-focused, ".concat((0, $k7Cfw.B200), ")")
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, ".concat((0, $k7Cfw.N0), ")")
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, ".concat((0, $k7Cfw.N20), ")"),
            opacity: 1
        }
    }
};
var $33d2578097c14685$export$2491e13b198e597d = "atlassian";
var $33d2578097c14685$export$2e2bcd8739ae039 = $33d2578097c14685$var$defaultTheme;

});
parcelRegister("8QF8A", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $6713171a854b2059$export$470e5c2be1411c89; });

var $4Zvrw = parcelRequire("4Zvrw");
function $6713171a854b2059$export$ba05d765b8392e5e(flagResolver) {
    (0, $4Zvrw.setBooleanResolver)(flagResolver);
}
function $6713171a854b2059$export$470e5c2be1411c89(name) {
    return (0, $4Zvrw.resolveBooleanFlag)(name);
}

});
parcelRegister("4Zvrw", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $3a253fd6f368300d$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $3a253fd6f368300d$export$6333b6aff9fc6275; });

var $jqUAB = parcelRequire("jqUAB");

var $XAEGR = parcelRequire("XAEGR");
var $3a253fd6f368300d$var$pkgName = "@atlaskit/platform-feature-flags";
var $3a253fd6f368300d$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $3a253fd6f368300d$var$hasProcessEnv = typeof $XAEGR !== "undefined" && typeof $XAEGR.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $3a253fd6f368300d$var$ENV_ENABLE_PLATFORM_FF = $3a253fd6f368300d$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $3a253fd6f368300d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $3a253fd6f368300d$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $3a253fd6f368300d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $3a253fd6f368300d$var$ENV_ENABLE_PLATFORM_FF || $3a253fd6f368300d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $3a253fd6f368300d$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $3a253fd6f368300d$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$3a253fd6f368300d$var$globalVar[$3a253fd6f368300d$export$7e41b1b2bdee3f98] = $3a253fd6f368300d$var$globalVar[$3a253fd6f368300d$export$7e41b1b2bdee3f98] || $3a253fd6f368300d$var$DEFAULT_PFF_GLOBAL;
function $3a253fd6f368300d$export$f2b591175b3e424c(resolver) {
    $3a253fd6f368300d$var$globalVar[$3a253fd6f368300d$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $3a253fd6f368300d$export$6333b6aff9fc6275(flagKey) {
    if ($3a253fd6f368300d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $jqUAB.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $3a253fd6f368300d$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $3a253fd6f368300d$var$globalVar[$3a253fd6f368300d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("jqUAB", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $e25c578471434547$export$1c9f709888824e05; });
var $e25c578471434547$var$_ref, $e25c578471434547$var$_globalThis$process, $e25c578471434547$var$_globalThis$process$e, $e25c578471434547$var$_globalThis$process2, $e25c578471434547$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $e25c578471434547$var$TESTS_MODE = ($e25c578471434547$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($e25c578471434547$var$_globalThis$process = globalThis.process) === null || $e25c578471434547$var$_globalThis$process === void 0 ? void 0 : ($e25c578471434547$var$_globalThis$process$e = $e25c578471434547$var$_globalThis$process.env) === null || $e25c578471434547$var$_globalThis$process$e === void 0 ? void 0 : $e25c578471434547$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $e25c578471434547$var$_ref !== void 0) ? $e25c578471434547$var$_ref : false;
var $e25c578471434547$var$DEBUG_MODE = !$e25c578471434547$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($e25c578471434547$var$_globalThis$process2 = globalThis.process) === null || $e25c578471434547$var$_globalThis$process2 === void 0 ? void 0 : ($e25c578471434547$var$_globalThis$process2$ = $e25c578471434547$var$_globalThis$process2.env) === null || $e25c578471434547$var$_globalThis$process2$ === void 0 ? void 0 : $e25c578471434547$var$_globalThis$process2$.NODE_ENV) !== "production";
var $e25c578471434547$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$e25c578471434547$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("38suQ", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", function () { return $2488393d85602881$export$7229be6d7219ee6a; });
$parcel$export(module.exports, "getBoxShadow", function () { return $2488393d85602881$export$bba5a971afe05444; });
$parcel$export(module.exports, "generateTextColor", function () { return $2488393d85602881$export$10a10e7cd1193377; });
$parcel$export(module.exports, "getContrastColor", function () { return $2488393d85602881$export$77a1051494882576; });

var $7i8I2 = parcelRequire("7i8I2");

var $lrtwL = parcelRequire("lrtwL");

var $c3rRc = parcelRequire("c3rRc");
function $2488393d85602881$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2488393d85602881$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2488393d85602881$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2488393d85602881$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2488393d85602881$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $2488393d85602881$var$_objectSpread($2488393d85602881$var$_objectSpread({}, (0, $c3rRc.default).convert(hex).rgb), {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(", "), ")");
};
var $2488393d85602881$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};
var $2488393d85602881$var$hex = "[a-z0-9]";
var $2488393d85602881$var$shortHandHexColorPattern = new RegExp("#(".concat($2488393d85602881$var$hex, ")(").concat($2488393d85602881$var$hex, ")(").concat($2488393d85602881$var$hex, ")"), "i");
var $2488393d85602881$var$repeat = function repeat(str, times) {
    return (0, $7i8I2.default)(Array(times)).map(function() {
        return str;
    }).join("");
};
var $2488393d85602881$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $2488393d85602881$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $2488393d85602881$var$repeat(color, 2);
    }).join("");
    return "#".concat(hex);
};
var $2488393d85602881$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($2488393d85602881$var$repeat(colors[1], 6));
};
var $2488393d85602881$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $2488393d85602881$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($2488393d85602881$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($2488393d85602881$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($2488393d85602881$var$isTriplet(colors)) return $2488393d85602881$var$completeTriplet(colors);
            else return $2488393d85602881$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
var $2488393d85602881$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = $2488393d85602881$export$db8d2130677f868c(color);
    return (0, $c3rRc.default).contrastRatio(converted).hex;
};
var $2488393d85602881$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return $2488393d85602881$export$7229be6d7219ee6a((0, $c3rRc.default).contrast(contrastValue, color).hex, opacityValue);
};

});
parcelRegister("c3rRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c6b5fb4330acc21$export$2e2bcd8739ae039; });
function $8c6b5fb4330acc21$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $8c6b5fb4330acc21$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $8c6b5fb4330acc21$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $8c6b5fb4330acc21$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $8c6b5fb4330acc21$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $8c6b5fb4330acc21$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $8c6b5fb4330acc21$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $8c6b5fb4330acc21$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $8c6b5fb4330acc21$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $8c6b5fb4330acc21$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $8c6b5fb4330acc21$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $8c6b5fb4330acc21$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $8c6b5fb4330acc21$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $8c6b5fb4330acc21$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $8c6b5fb4330acc21$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $8c6b5fb4330acc21$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $8c6b5fb4330acc21$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $8c6b5fb4330acc21$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $8c6b5fb4330acc21$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $8c6b5fb4330acc21$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $8c6b5fb4330acc21$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $8c6b5fb4330acc21$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $8c6b5fb4330acc21$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $8c6b5fb4330acc21$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $8c6b5fb4330acc21$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $8c6b5fb4330acc21$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $8c6b5fb4330acc21$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $8c6b5fb4330acc21$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $8c6b5fb4330acc21$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $8c6b5fb4330acc21$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $8c6b5fb4330acc21$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $8c6b5fb4330acc21$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $8c6b5fb4330acc21$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $8c6b5fb4330acc21$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $8c6b5fb4330acc21$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $8c6b5fb4330acc21$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $8c6b5fb4330acc21$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $8c6b5fb4330acc21$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $8c6b5fb4330acc21$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $8c6b5fb4330acc21$var$fromHex_1 = $8c6b5fb4330acc21$var$fromHex, $8c6b5fb4330acc21$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $8c6b5fb4330acc21$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $8c6b5fb4330acc21$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $8c6b5fb4330acc21$var$fromRgb_1 = $8c6b5fb4330acc21$var$fromRgb, $8c6b5fb4330acc21$var$fromCssRgb_1 = $8c6b5fb4330acc21$var$fromCssRgb, $8c6b5fb4330acc21$var$fromHsl_1 = $8c6b5fb4330acc21$var$fromHsl, $8c6b5fb4330acc21$var$fromCssHsl_1 = $8c6b5fb4330acc21$var$fromCssHsl, $8c6b5fb4330acc21$var$fromHsv_1 = $8c6b5fb4330acc21$var$fromHsv, $8c6b5fb4330acc21$var$fromCmyk_1 = $8c6b5fb4330acc21$var$fromCmyk, $8c6b5fb4330acc21$var$fromYiq_1 = $8c6b5fb4330acc21$var$fromYiq, $8c6b5fb4330acc21$var$fromXYZ_1 = $8c6b5fb4330acc21$var$fromXYZ, $8c6b5fb4330acc21$var$fromxyY_1 = $8c6b5fb4330acc21$var$fromxyY, $8c6b5fb4330acc21$var$fromLms_1 = $8c6b5fb4330acc21$var$fromLms, $8c6b5fb4330acc21$var$fromCieLab_1 = $8c6b5fb4330acc21$var$fromCieLab, $8c6b5fb4330acc21$var$fromCieLuv_1 = $8c6b5fb4330acc21$var$fromCieLuv, $8c6b5fb4330acc21$var$fromCieLch_1 = $8c6b5fb4330acc21$var$fromCieLch, $8c6b5fb4330acc21$var$fromHsluv = $8c6b5fb4330acc21$var$fromCieLch$1, $8c6b5fb4330acc21$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $8c6b5fb4330acc21$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $8c6b5fb4330acc21$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $8c6b5fb4330acc21$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $8c6b5fb4330acc21$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $8c6b5fb4330acc21$var$fromHsluv
    }
}, $8c6b5fb4330acc21$var$adapt_1 = $8c6b5fb4330acc21$var$adapt, $8c6b5fb4330acc21$var$adjacent_1 = $8c6b5fb4330acc21$var$adjacent, $8c6b5fb4330acc21$var$brightness_1 = $8c6b5fb4330acc21$var$brightness, $8c6b5fb4330acc21$var$complementary_1 = $8c6b5fb4330acc21$var$complementary, $8c6b5fb4330acc21$var$contrast_1 = $8c6b5fb4330acc21$var$contrast, $8c6b5fb4330acc21$var$contrastRatio_1 = $8c6b5fb4330acc21$var$contrastRatio, $8c6b5fb4330acc21$var$convert_1 = $8c6b5fb4330acc21$var$convert, $8c6b5fb4330acc21$var$difference_1 = $8c6b5fb4330acc21$var$difference, $8c6b5fb4330acc21$var$fade_1 = $8c6b5fb4330acc21$var$fade, $8c6b5fb4330acc21$var$greyscale_1 = $8c6b5fb4330acc21$var$greyscale, $8c6b5fb4330acc21$var$hue_1 = $8c6b5fb4330acc21$var$hue, $8c6b5fb4330acc21$var$invert_1 = $8c6b5fb4330acc21$var$invert, $8c6b5fb4330acc21$var$invertLightness_1 = $8c6b5fb4330acc21$var$invertLightness, $8c6b5fb4330acc21$var$mid_1 = $8c6b5fb4330acc21$var$mid, $8c6b5fb4330acc21$var$multiply_1 = $8c6b5fb4330acc21$var$multiply, $8c6b5fb4330acc21$var$saturation_1 = $8c6b5fb4330acc21$var$saturation, $8c6b5fb4330acc21$var$sepia_1 = $8c6b5fb4330acc21$var$sepia, $8c6b5fb4330acc21$var$shade_1 = $8c6b5fb4330acc21$var$shade, $8c6b5fb4330acc21$var$temperature_1 = $8c6b5fb4330acc21$var$temperature, $8c6b5fb4330acc21$var$tetrad_1 = $8c6b5fb4330acc21$var$tetrad, $8c6b5fb4330acc21$var$triad_1 = $8c6b5fb4330acc21$var$triad, $8c6b5fb4330acc21$var$index$2 = {
    adapt: $8c6b5fb4330acc21$var$adapt_1,
    adjacent: $8c6b5fb4330acc21$var$adjacent_1,
    brightness: $8c6b5fb4330acc21$var$brightness_1,
    complementary: $8c6b5fb4330acc21$var$complementary_1,
    contrast: $8c6b5fb4330acc21$var$contrast_1,
    contrastRatio: $8c6b5fb4330acc21$var$contrastRatio_1,
    convert: $8c6b5fb4330acc21$var$convert_1,
    difference: $8c6b5fb4330acc21$var$difference_1,
    fade: $8c6b5fb4330acc21$var$fade_1,
    greyscale: $8c6b5fb4330acc21$var$greyscale_1,
    hue: $8c6b5fb4330acc21$var$hue_1,
    invert: $8c6b5fb4330acc21$var$invert_1,
    invertLightness: $8c6b5fb4330acc21$var$invertLightness_1,
    mid: $8c6b5fb4330acc21$var$mid_1,
    multiply: $8c6b5fb4330acc21$var$multiply_1,
    saturation: $8c6b5fb4330acc21$var$saturation_1,
    sepia: $8c6b5fb4330acc21$var$sepia_1,
    shade: $8c6b5fb4330acc21$var$shade_1,
    temperature: $8c6b5fb4330acc21$var$temperature_1,
    tetrad: $8c6b5fb4330acc21$var$tetrad_1,
    triad: $8c6b5fb4330acc21$var$triad_1
}, $8c6b5fb4330acc21$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $8c6b5fb4330acc21$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $8c6b5fb4330acc21$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($8c6b5fb4330acc21$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $8c6b5fb4330acc21$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($8c6b5fb4330acc21$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $8c6b5fb4330acc21$var$api_1 = $8c6b5fb4330acc21$var$api, $8c6b5fb4330acc21$var$helpers = {
    getIlluminant: function(r) {
        return $8c6b5fb4330acc21$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $8c6b5fb4330acc21$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $8c6b5fb4330acc21$var$index)if ($8c6b5fb4330acc21$var$index.hasOwnProperty(e) && $8c6b5fb4330acc21$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $8c6b5fb4330acc21$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $8c6b5fb4330acc21$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $8c6b5fb4330acc21$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $8c6b5fb4330acc21$var$constants, s));
            default:
                return null;
        }
    }
}, $8c6b5fb4330acc21$var$helpers_1 = $8c6b5fb4330acc21$var$helpers, $8c6b5fb4330acc21$var$dependencies = {
    conversions: $8c6b5fb4330acc21$var$index,
    operations: $8c6b5fb4330acc21$var$index$2,
    helpers: $8c6b5fb4330acc21$var$helpers_1
}, $8c6b5fb4330acc21$var$entry = $8c6b5fb4330acc21$var$api_1($8c6b5fb4330acc21$var$dependencies, $8c6b5fb4330acc21$var$constants);
var $8c6b5fb4330acc21$export$2e2bcd8739ae039 = $8c6b5fb4330acc21$var$entry;

});



parcelRegister("4jdgC", function(module, exports) {

$parcel$export(module.exports, "generateTheme", function () { return $32333a52b8d0f8ac$export$2e4ecffaca289a18; });

var $lrtwL = parcelRequire("lrtwL");

var $4rQpL = parcelRequire("4rQpL");

var $38suQ = parcelRequire("38suQ");
function $32333a52b8d0f8ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32333a52b8d0f8ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32333a52b8d0f8ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32333a52b8d0f8ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32333a52b8d0f8ac$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === "#000000" ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $32333a52b8d0f8ac$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $32333a52b8d0f8ac$var$generateOpacityValue(color);
    var isCreateButton = buttonType === "create";
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $38suQ.hexToRGBA)(backgroundColor, 0.65) : (0, $38suQ.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $38suQ.getBoxShadow)("transparent"),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $38suQ.getBoxShadow)("transparent"),
            color: color
        },
        focus: {
            boxShadow: "none",
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $38suQ.hexToRGBA)(backgroundColor, 0.8) : (0, $38suQ.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $38suQ.getBoxShadow)("transparent"),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $38suQ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $38suQ.getBoxShadow)("transparent")
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $38suQ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $38suQ.getBoxShadow)("transparent")
        }
    };
};
var $32333a52b8d0f8ac$var$generateCreateButtonColors = function generateCreateButtonColors(themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $38suQ.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $32333a52b8d0f8ac$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $38suQ.generateTextColor)(backgroundColor);
    var colors = $32333a52b8d0f8ac$var$_objectSpread($32333a52b8d0f8ac$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $4rQpL.DEFAULT_THEME_NAME)) return 0, $4rQpL.default;
    return {
        mode: {
            create: $32333a52b8d0f8ac$var$generateButtonCSSStates($32333a52b8d0f8ac$var$generateCreateButtonColors(backgroundColor, highlightColor), "create"),
            iconButton: $32333a52b8d0f8ac$var$generateButtonCSSStates(colors, "iconButton"),
            primaryButton: $32333a52b8d0f8ac$var$generateButtonCSSStates(colors, "primaryButton"),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: "1px solid ".concat((0, $38suQ.hexToRGBA)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $38suQ.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $38suQ.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $38suQ.getBoxShadow)((0, $38suQ.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $38suQ.getContrastColor)(0.1, $32333a52b8d0f8ac$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $32333a52b8d0f8ac$export$2e2bcd8739ae039 = $32333a52b8d0f8ac$export$2e4ecffaca289a18;

});




parcelRegister("hOuDE", function(module, exports) {

$parcel$export(module.exports, "getIconButtonTheme", function () { return $cf7edf59e2c31824$export$f32bddcb857301f3; });

var $lrtwL = parcelRequire("lrtwL");
function $cf7edf59e2c31824$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf7edf59e2c31824$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf7edf59e2c31824$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf7edf59e2c31824$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cf7edf59e2c31824$export$f32bddcb857301f3 = function getIconButtonTheme(_ref) {
    var iconButton = _ref.mode.iconButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $cf7edf59e2c31824$var$_objectSpread($cf7edf59e2c31824$var$_objectSpread($cf7edf59e2c31824$var$_objectSpread($cf7edf59e2c31824$var$_objectSpread({}, buttonStyles), {}, {
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: "flex",
                margin: "0 ".concat("var(--ds-space-025, 2px)"),
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: "auto",
                fontWeight: "var(--ds-font-weight-medium, 500)"
            }, iconButton.default), {}, {
                ":hover": iconButton.hover,
                ":focus": iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                "&&": $cf7edf59e2c31824$var$_objectSpread({}, props.state === "active" && iconButton.active)
            }, props.state === "selected" && iconButton.selected), {}, {
                "> span": {
                    margin: 0
                }
            }),
            spinnerStyles: spinnerStyles
        };
    };
};

});



parcelRegister("cvaTj", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", function () { return $91a0d4108005c7a6$export$f66ccb39f60980e5; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");
parcelRequire("fkiPL");
var $hXq7a = parcelRequire("hXq7a");

var $8QF8A = parcelRequire("8QF8A");

var $k7Cfw = parcelRequire("k7Cfw");

var $9sI6P = parcelRequire("9sI6P");

var $hyWMc = parcelRequire("hyWMc");
var $1DiDM = parcelRequire("1DiDM");

var $8VtUu = parcelRequire("8VtUu");

var $kDh2w = parcelRequire("kDh2w");
var $91a0d4108005c7a6$var$containerStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box",
    height: (0, $9sI6P.HORIZONTAL_GLOBAL_NAV_HEIGHT),
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    borderBlockEnd: "1px solid ".concat("var(--ds-border, ".concat((0, $k7Cfw.N30), ")")),
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
var $91a0d4108005c7a6$var$leftStyles = (0, $2ZUkg.css)({
    display: "flex",
    minWidth: 0,
    height: "inherit",
    alignItems: "center",
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        flexShrink: 0
    }
});
var $91a0d4108005c7a6$var$rightStyles = (0, $2ZUkg.css)({
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        flexShrink: 0,
        marginInlineEnd: "var(--ds-space-050, 4px)"
    }
});
var $91a0d4108005c7a6$var$noRightMarginStyles = (0, $2ZUkg.css)({
    marginInlineEnd: 0
});
var $91a0d4108005c7a6$var$analyticsData = {
    attributes: {
        navigationLayer: "global"
    },
    componentName: "atlassianNavigation"
};
var $91a0d4108005c7a6$export$f66ccb39f60980e5 = function AtlassianNavigation(props) {
    var label = props.label, _props$primaryItems = props.primaryItems, primaryItems = _props$primaryItems === void 0 ? [] : _props$primaryItems, AppSwitcher = props.renderAppSwitcher, create = props.renderCreate, Help = props.renderHelp, Notifications = props.renderNotifications, ProductHome = props.renderProductHome, Profile = props.renderProfile, Search = props.renderSearch, SignIn = props.renderSignIn, Settings = props.renderSettings, _props$moreLabel = props.moreLabel, moreLabel = _props$moreLabel === void 0 ? "\u2026" : _props$moreLabel, _props$theme = props.theme, theme = _props$theme === void 0 ? (0, $hyWMc.defaultTheme) : _props$theme, testId = props.testId;
    return (0, $2ZUkg.jsx)((0, $1DiDM.ThemeProvider), {
        value: theme
    }, (0, $2ZUkg.jsx)((0, $hXq7a.NavigationAnalyticsContext), {
        data: $91a0d4108005c7a6$var$analyticsData
    }, (0, $2ZUkg.jsx)("header", {
        style: theme.mode.navigation,
        css: $91a0d4108005c7a6$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-header"),
        role: "banner"
    }, (0, $2ZUkg.jsx)("nav", {
        css: $91a0d4108005c7a6$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && (0, $2ZUkg.jsx)(AppSwitcher, null), ProductHome && (0, $2ZUkg.jsx)(ProductHome, null), (0, $8QF8A.getBooleanFF)("platform.design-system-team.navigation-v2-no-jank_5yhbd") ? (0, $2ZUkg.jsx)((0, $kDh2w.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    }) : (0, $2ZUkg.jsx)((0, $8VtUu.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    })), (0, $2ZUkg.jsx)("div", {
        css: $91a0d4108005c7a6$var$rightStyles,
        "data-testid": testId && "".concat(testId, "-secondary-actions")
    }, Search && (0, $2ZUkg.jsx)(Search, null), (0, $2ZUkg.jsx)("div", {
        role: "list",
        css: [
            $91a0d4108005c7a6$var$rightStyles,
            $91a0d4108005c7a6$var$noRightMarginStyles
        ]
    }, Notifications && (0, $2ZUkg.jsx)(Notifications, null), Help && (0, $2ZUkg.jsx)(Help, null), Settings && (0, $2ZUkg.jsx)(Settings, null), SignIn && (0, $2ZUkg.jsx)(SignIn, null), Profile && (0, $2ZUkg.jsx)(Profile, null))))));
};
var $91a0d4108005c7a6$export$2e2bcd8739ae039 = $91a0d4108005c7a6$export$f66ccb39f60980e5;

});
parcelRegister("fkiPL", function(module, exports) {

$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return (parcelRequire("hXq7a")).NavigationAnalyticsContext; });

var $1sgOR = parcelRequire("1sgOR");

var $hXq7a = parcelRequire("hXq7a");

var $kzOKn = parcelRequire("kzOKn");

var $2U692 = parcelRequire("2U692");

var $lbdMr = parcelRequire("lbdMr");

var $cnxe3 = parcelRequire("cnxe3");

var $l2Rfz = parcelRequire("l2Rfz");

var $huOeg = parcelRequire("huOeg");

var $k6bTL = parcelRequire("k6bTL");

var $49pqh = parcelRequire("49pqh");

var $ibl4N = parcelRequire("ibl4N");

});
parcelRegister("1sgOR", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $10f573f5e5f0661e$export$80450e0a84a5ede9 = "fabricElementsCtx";
var $10f573f5e5f0661e$export$3fe25500478a635c = (0, $WWqEc.default)($10f573f5e5f0661e$export$80450e0a84a5ede9, "FabricElementsAnalyticsContext");

});
parcelRegister("WWqEc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b12bda2f4cdcb27$export$2e2bcd8739ae039; });

var $lrtwL = parcelRequire("lrtwL");

var $iSvIT = parcelRequire("iSvIT");

var $jXTzN = parcelRequire("jXTzN");
var $0b12bda2f4cdcb27$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "NamespacedContext";
    var Component = function Component(props) {
        var newData = (0, $lrtwL.default)({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jXTzN.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $0b12bda2f4cdcb27$export$2e2bcd8739ae039 = $0b12bda2f4cdcb27$var$createNamespaceContext;

});


parcelRegister("hXq7a", function(module, exports) {

$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return $d12c342e52c37e56$export$d0a82da1a0b94929; });

var $WWqEc = parcelRequire("WWqEc");
var $d12c342e52c37e56$export$1fd3aad76a7c6788 = "navigationCtx";
var $d12c342e52c37e56$export$d0a82da1a0b94929 = (0, $WWqEc.default)($d12c342e52c37e56$export$1fd3aad76a7c6788, "NavigationAnalyticsContext");

});

parcelRegister("kzOKn", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $efae70d7ff8aa4a3$export$8c8f6d8f1fa796f0 = "fabricEditorCtx";
var $efae70d7ff8aa4a3$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $efae70d7ff8aa4a3$export$629cada6c5e621e1 = (0, $WWqEc.default)($efae70d7ff8aa4a3$export$8c8f6d8f1fa796f0, "FabricEditorAnalyticsContext");

});

parcelRegister("2U692", function(module, exports) {
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $21d593f0a9a710c9$export$70df29c238ba7306 = "mediaCtx"; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("lbdMr", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $f6b5508451df07fb$export$b326383bee6cb993 = "peopleTeamsCtx";
var $f6b5508451df07fb$export$4119ddb38ccbfb87 = (0, $WWqEc.default)($f6b5508451df07fb$export$b326383bee6cb993, "PeopleTeamsAnalyticsContext");

});

parcelRegister("cnxe3", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $903167f148b1ace4$export$da1befb791e93c7e = "NotificationsCtx";
var $903167f148b1ace4$export$6f8e7ff1e3feafd7 = (0, $WWqEc.default)($903167f148b1ace4$export$da1befb791e93c7e, "NotificationsAnalyticsContext");

});

parcelRegister("l2Rfz", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $f5231739ce1011c1$export$fc7a65795610cb71 = "RecentWorkCtx";
var $f5231739ce1011c1$export$745926731087ebe2 = (0, $WWqEc.default)($f5231739ce1011c1$export$fc7a65795610cb71, "RecentWorkAnalyticsContext");

});

parcelRegister("huOeg", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $cbcc336ecbe2cd4a$export$4906017439f33fc0 = "atlasCtx";
var $cbcc336ecbe2cd4a$export$43ebbe41370d4543 = (0, $WWqEc.default)($cbcc336ecbe2cd4a$export$4906017439f33fc0, "AtlasAnalyticsContext");

});

parcelRegister("k6bTL", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $ea1d98f3d7842537$export$3240443bf2b83834 = "linkingPlatformCtx";
var $ea1d98f3d7842537$export$6d568da622ce0a08 = (0, $WWqEc.default)($ea1d98f3d7842537$export$3240443bf2b83834, "LinkingPlatformAnalyticsContext");

});

parcelRegister("49pqh", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $305bb9287982d709$export$ef0c05448f0f8f9 = "postOfficeCtx";
var $305bb9287982d709$export$dcd232f3be312f94 = (0, $WWqEc.default)($305bb9287982d709$export$ef0c05448f0f8f9, "PostOfficeAnalyticsContext");

});

parcelRegister("ibl4N", function(module, exports) {

var $WWqEc = parcelRequire("WWqEc");
var $d3c99a69d2ae4dee$export$5c3a6fd8b96e8b66 = "aiMateCtx";
var $d3c99a69d2ae4dee$export$de3826c30468da26 = (0, $WWqEc.default)($d3c99a69d2ae4dee$export$5c3a6fd8b96e8b66, "AIMateAnalyticsContext");

});


parcelRegister("9sI6P", function(module, exports) {

$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", function () { return $6e38f1bb43f15d3e$export$30fa7cc5f2690a43; });
$parcel$export(module.exports, "PRODUCT_HOME_BREAKPOINT", function () { return $6e38f1bb43f15d3e$export$4033a111ca79977d; });
$parcel$export(module.exports, "CREATE_BREAKPOINT", function () { return $6e38f1bb43f15d3e$export$24ec62cee78b7042; });
$parcel$export(module.exports, "varSearchFocusBorderColor", function () { return $6e38f1bb43f15d3e$export$d8bde68ac946124f; });
$parcel$export(module.exports, "varSearchHoverBackgroundColor", function () { return $6e38f1bb43f15d3e$export$73e44f54603a0964; });
$parcel$export(module.exports, "varSearchBackgroundColor", function () { return $6e38f1bb43f15d3e$export$13f8aa8f663f4c99; });
$parcel$export(module.exports, "varSearchColor", function () { return $6e38f1bb43f15d3e$export$d81606c1fc5119bc; });
$parcel$export(module.exports, "varSearchBorderColor", function () { return $6e38f1bb43f15d3e$export$65f656ad520ea71; });
var $6e38f1bb43f15d3e$export$30fa7cc5f2690a43 = 56;
var $6e38f1bb43f15d3e$export$4033a111ca79977d = 1280;
var $6e38f1bb43f15d3e$export$24ec62cee78b7042 = 1130;
var $6e38f1bb43f15d3e$export$d8bde68ac946124f = "--ds--ans--fbc";
var $6e38f1bb43f15d3e$export$73e44f54603a0964 = "--ds--ans--hbgc";
var $6e38f1bb43f15d3e$export$13f8aa8f663f4c99 = "--ds--ans--bgc";
var $6e38f1bb43f15d3e$export$d81606c1fc5119bc = "--ds--ans--c";
var $6e38f1bb43f15d3e$export$65f656ad520ea71 = "--ds--ans--bc";

});

parcelRegister("8VtUu", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", function () { return $67fad91ea8675f91$export$43e704064d596a9e; });

var $djxp7 = parcelRequire("djxp7");

var $cGZ0i = parcelRequire("cGZ0i");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $eMtdo = parcelRequire("eMtdo");

var $k7Cfw = parcelRequire("k7Cfw");

var $81fYe = parcelRequire("81fYe");

var $8Pugw = parcelRequire("8Pugw");

var $5SzAI = parcelRequire("5SzAI");
var $67fad91ea8675f91$var$containerStyles = (0, $2ZUkg.css)({
    display: "flex",
    height: "100%",
    position: "relative",
    alignItems: "stretch",
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        margin: "0 ".concat("var(--ds-space-050, 4px)"),
        flexShrink: 0
    }
});
var $67fad91ea8675f91$var$widthObserverContainerStyles = (0, $2ZUkg.css)({
    width: "100%",
    minWidth: "1px",
    margin: "0px",
    position: "relative",
    flexShrink: 1
});
var $67fad91ea8675f91$var$overflowItemsStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text, ".concat((0, $k7Cfw.N700), ")")
});
var $67fad91ea8675f91$export$43e704064d596a9e = function PrimaryItemsContainer(_ref) {
    var moreLabel = _ref.moreLabel, items = _ref.items, Create = _ref.create, theme = _ref.theme, testId = _ref.testId;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $cGZ0i.default)(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var _useOverflowControlle = (0, $8Pugw.useOverflowController)(items), updateWidth = _useOverflowControlle.updateWidth, visibleItems = _useOverflowControlle.visibleItems, overflowItems = _useOverflowControlle.overflowItems;
    var onMoreClick = (0, $iSvIT.useCallback)(function() {
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    var onMoreClose = (0, $iSvIT.useCallback)(function() {
        setIsMoreOpen(false);
    }, []);
    var openOverflowMenu = (0, $iSvIT.useCallback)(function() {
        setIsMoreOpen(true);
    }, []);
    var trigger = (0, $iSvIT.useCallback)(function(triggerProps) {
        return (0, $2ZUkg.jsx)((0, $5SzAI.PrimaryDropdownButton), (0, $djxp7.default)({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : "overflow-menu-trigger"
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $iSvIT.useCallback)(function() {
        return (0, $2ZUkg.jsx)((0, $8Pugw.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, (0, $2ZUkg.jsx)("div", {
            css: $67fad91ea8675f91$var$overflowItemsStyles
        }, overflowItems));
    }, // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return (0, $2ZUkg.jsx)("div", {
        css: $67fad91ea8675f91$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-primary-actions"),
        role: "list"
    }, (0, $2ZUkg.jsx)((0, $8Pugw.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && (0, $2ZUkg.jsx)((0, $eMtdo.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : "overflow-menu-popup"
    }), Create && (0, $2ZUkg.jsx)(Create, null), (0, $2ZUkg.jsx)("div", {
        css: $67fad91ea8675f91$var$widthObserverContainerStyles
    }, (0, $2ZUkg.jsx)((0, $81fYe.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("eMtdo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac2c35e549c8617f$export$2e2bcd8739ae039; });

var $aHaVV = parcelRequire("aHaVV");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ac2c35e549c8617f$export$2e2bcd8739ae039 = (0, $aHaVV.Popup);

});
parcelRegister("aHaVV", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $7c9666a1e673b38e$export$129a32eedafa97c5; });

var $cGZ0i = parcelRequire("cGZ0i");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $awRUe = parcelRequire("awRUe");

var $kj81I = parcelRequire("kj81I");
var $7I59s = parcelRequire("7I59s");

var $kub8V = parcelRequire("kub8V");

var $dTCtZ = parcelRequire("dTCtZ");

var $cnyqX = parcelRequire("cnyqX");

var $jBreO = parcelRequire("jBreO");
var $7c9666a1e673b38e$var$defaultLayer = (0, $dTCtZ.layers).layer();
var $7c9666a1e673b38e$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $7c9666a1e673b38e$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $cGZ0i.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $jBreO.useGetMemoizedMergedTriggerRef)();
    var renderPopperWrapper = (0, $2ZUkg.jsx)((0, $awRUe.UNSAFE_LAYERING), {
        isDisabled: false
    }, (0, $2ZUkg.jsx)((0, $cnyqX.default), {
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: strategy,
        role: role,
        label: label,
        titleId: titleId
    }));
    return (0, $2ZUkg.jsx)((0, $kj81I.Manager), null, (0, $2ZUkg.jsx)((0, $7I59s.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
            "aria-controls": id,
            "aria-expanded": isOpen,
            "aria-haspopup": true
        });
    }), isOpen && (shouldRenderToParent ? renderPopperWrapper : (0, $2ZUkg.jsx)((0, $kub8V.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
});
var $7c9666a1e673b38e$export$2e2bcd8739ae039 = $7c9666a1e673b38e$export$129a32eedafa97c5;

});
parcelRegister("awRUe", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $7aa6b5298f9ebf0a$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $7aa6b5298f9ebf0a$export$48b383b280e20440; });
$parcel$export(module.exports, "UNSAFE_LAYERING", function () { return $7aa6b5298f9ebf0a$export$a183686c3f6f4ea8; });

var $iSvIT = parcelRequire("iSvIT");

var $8QUK9 = parcelRequire("8QUK9");
var $7aa6b5298f9ebf0a$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $iSvIT.createContext)(0);
var $7aa6b5298f9ebf0a$export$48b383b280e20440 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $8QUK9.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $7aa6b5298f9ebf0a$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $iSvIT.useContext)($7aa6b5298f9ebf0a$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $iSvIT.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($7aa6b5298f9ebf0a$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $7aa6b5298f9ebf0a$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $iSvIT.useRef)(0);
    var value = (0, $iSvIT.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($7aa6b5298f9ebf0a$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $7aa6b5298f9ebf0a$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $iSvIT.useContext)($7aa6b5298f9ebf0a$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($7aa6b5298f9ebf0a$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($7aa6b5298f9ebf0a$var$LayeringProvider, null, content);
};

});

parcelRegister("kj81I", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $ec8bceeb46d13321$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $ec8bceeb46d13321$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $ec8bceeb46d13321$export$d0d38e7dec7a1a61; });

var $iSvIT = parcelRequire("iSvIT");
var $ec8bceeb46d13321$export$3dbd3405086fec7b = $iSvIT.createContext();
var $ec8bceeb46d13321$export$cbabb21c2529b130 = $iSvIT.createContext();
function $ec8bceeb46d13321$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $iSvIT.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $iSvIT.useRef(false);
    $iSvIT.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $iSvIT.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $iSvIT.createElement($ec8bceeb46d13321$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $iSvIT.createElement($ec8bceeb46d13321$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("7I59s", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $59d0a374d5e9ada4$export$e0be378c32fb70a7; });

var $iSvIT = parcelRequire("iSvIT");

var $cAgz7 = parcelRequire("cAgz7");

var $kj81I = parcelRequire("kj81I");

var $9oXzE = parcelRequire("9oXzE");
function $59d0a374d5e9ada4$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $iSvIT.useContext((0, $kj81I.ManagerReferenceNodeSetterContext));
    var refHandler = $iSvIT.useCallback(function(node) {
        (0, $9oXzE.setRef)(innerRef, node);
        (0, $9oXzE.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $iSvIT.useEffect(function() {
        return function() {
            return (0, $9oXzE.setRef)(innerRef, null);
        };
    }, []);
    $iSvIT.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($cAgz7)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $9oXzE.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("9oXzE", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $6d84911c0022907e$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $6d84911c0022907e$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $6d84911c0022907e$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $6d84911c0022907e$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $6d84911c0022907e$export$700979bc83e7db82; });

var $iSvIT = parcelRequire("iSvIT");
var $6d84911c0022907e$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $6d84911c0022907e$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $6d84911c0022907e$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $6d84911c0022907e$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $6d84911c0022907e$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $6d84911c0022907e$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $iSvIT.useLayoutEffect : $iSvIT.useEffect;

});


parcelRegister("kub8V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee9f40ba334ee3f0$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $7Rv9u = parcelRequire("7Rv9u");

var $ci159 = parcelRequire("ci159");

var $lVueS = parcelRequire("lVueS");
function $ee9f40ba334ee3f0$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $ci159.default)(mountStrategy);
    (0, $lVueS.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7Rv9u.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("7Rv9u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b95a5d050e19eb1$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $4muoO = parcelRequire("4muoO");
function $5b95a5d050e19eb1$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $iSvIT.useMemo)(function() {
        return (0, $4muoO.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $4muoO.appendPortalContainerIfNotAppended)(container);
    (0, $iSvIT.useEffect)(function() {
        return function() {
            (0, $4muoO.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $i5UxU.createPortal)(children, container);
}

});
parcelRegister("4muoO", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $32d0cc20f3ded848$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $32d0cc20f3ded848$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $32d0cc20f3ded848$export$c582005add11e141; });

var $i7lMR = parcelRequire("i7lMR");
var $32d0cc20f3ded848$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $i7lMR.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $32d0cc20f3ded848$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $32d0cc20f3ded848$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $i7lMR.portalParentSelector));
    if (!parentElement) {
        var parent = document.createElement("div");
        parent.className = (0, $i7lMR.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        $32d0cc20f3ded848$var$getBody().appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $32d0cc20f3ded848$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $32d0cc20f3ded848$var$getPortalParent().removeChild(container);
};
var $32d0cc20f3ded848$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $32d0cc20f3ded848$var$getPortalParent().appendChild(container);
};

});
parcelRegister("i7lMR", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $d309c7e2a1ea632b$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $d309c7e2a1ea632b$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $d309c7e2a1ea632b$export$13f57c02915787b3; });
var $d309c7e2a1ea632b$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $d309c7e2a1ea632b$export$72f415121273627e = "body > .atlaskit-portal-container";
var $d309c7e2a1ea632b$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("ci159", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f28015970a53845$export$2e2bcd8739ae039; });

var $cGZ0i = parcelRequire("cGZ0i");

var $iSvIT = parcelRequire("iSvIT");

var $1lmRP = parcelRequire("1lmRP");
var $8f28015970a53845$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $cGZ0i.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $1lmRP.useIsomorphicLayoutEffect) : (0, $iSvIT.useEffect);
    }), _useState4 = (0, $cGZ0i.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $8f28015970a53845$export$2e2bcd8739ae039 = $8f28015970a53845$var$useIsSubsequentRender;

});
parcelRegister("1lmRP", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $0fa97d95ffbdb93d$export$700979bc83e7db82; });

var $iSvIT = parcelRequire("iSvIT");
var $0fa97d95ffbdb93d$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $iSvIT.useLayoutEffect) : (0, $iSvIT.useEffect);

});


parcelRegister("lVueS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff6660a61fd3c691$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $cxFwz = parcelRequire("cxFwz");

var $7m2aX = parcelRequire("7m2aX");
var $ff6660a61fd3c691$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $iSvIT.useEffect)(function() {
        (0, $7m2aX.default)((0, $cxFwz.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $7m2aX.default)((0, $cxFwz.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $ff6660a61fd3c691$export$2e2bcd8739ae039 = $ff6660a61fd3c691$var$useFirePortalEvent;

});
parcelRegister("cxFwz", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $9218c6f34224d708$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $9218c6f34224d708$export$80816bd900e5bd00; });
var $9218c6f34224d708$export$ed5835cc67e87f72 = "akPortalMount";
var $9218c6f34224d708$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("7m2aX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55ac468d0e9c16de$export$2e2bcd8739ae039; });
var $55ac468d0e9c16de$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $55ac468d0e9c16de$var$getLayerName = function getLayerName(zIndex) {
    return $55ac468d0e9c16de$var$zIndexToName.hasOwnProperty(zIndex) ? $55ac468d0e9c16de$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $55ac468d0e9c16de$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $55ac468d0e9c16de$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $55ac468d0e9c16de$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $55ac468d0e9c16de$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("cnyqX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $903257d3e53321f8$export$2e2bcd8739ae039; });

var $cGZ0i = parcelRequire("cGZ0i");

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $lrtwL = parcelRequire("lrtwL");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $hxnU6 = parcelRequire("hxnU6");

var $8QF8A = parcelRequire("8QF8A");

var $a2QII = parcelRequire("a2QII");

var $k7Cfw = parcelRequire("k7Cfw");

var $dTCtZ = parcelRequire("dTCtZ");

var $iGLnR = parcelRequire("iGLnR");

var $8GBzc = parcelRequire("8GBzc");

var $47y4t = parcelRequire("47y4t");

var $7xyIW = parcelRequire("7xyIW");
var $903257d3e53321f8$var$_excluded = [
    "shouldRenderToParent",
    "children"
];
var $903257d3e53321f8$var$_css;
var $903257d3e53321f8$var$popupStyles = (0, $2ZUkg.css)(($903257d3e53321f8$var$_css = {
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $dTCtZ.layers).layer(),
    flex: "1 1 auto",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $k7Cfw.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $k7Cfw.N50A), ", 0 0 1px ").concat((0, $k7Cfw.N60A)), ")")
}, (0, $lrtwL.default)($903257d3e53321f8$var$_css, (0, $iGLnR.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $k7Cfw.N0), ")")), (0, $lrtwL.default)($903257d3e53321f8$var$_css, ":focus", {
    outline: "none"
}), $903257d3e53321f8$var$_css));
var $903257d3e53321f8$var$popupOverflowStyles = (0, $2ZUkg.css)({
    overflow: "auto"
});
// disables iframe pointer events while popup is open, except if iframe is nested inside popup
// solves an issue of popup not being closed on iframe click
var $903257d3e53321f8$var$blockPointerEventsOnExternalIframeStyles = (0, $2ZUkg.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "iframe:not([data-ds--level] iframe)": {
        pointerEvents: "none"
    }
});
var $903257d3e53321f8$var$DefaultPopupComponent = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, children = props.children, htmlAttributes = (0, $gmKOS.default)(props, $903257d3e53321f8$var$_excluded);
    return (0, $2ZUkg.jsx)("div", (0, $djxp7.default)({
        css: [
            $903257d3e53321f8$var$popupStyles,
            !shouldRenderToParent && $903257d3e53321f8$var$popupOverflowStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $903257d3e53321f8$var$PopperWrapper(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $903257d3e53321f8$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldDisableFocusLock = _ref.shouldDisableFocusLock, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    var _useState = (0, $iSvIT.useState)(null), _useState2 = (0, $cGZ0i.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(null), _useState4 = (0, $cGZ0i.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases when we need to prohibit focus locking
    // e.g. in DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    (0, $7xyIW.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab
    });
    (0, $47y4t.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab
    });
    var _UNSAFE_useLayering = (0, $hxnU6.UNSAFE_useLayering)(), currentLevel = _UNSAFE_useLayering.currentLevel;
    var modifiers = (0, $iSvIT.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ];
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements
    ]);
    return (0, $2ZUkg.jsx)((0, $a2QII.Popper), {
        placement: placement,
        offset: offset,
        modifiers: modifiers,
        strategy: strategy
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        return (0, $2ZUkg.jsx)(PopupContainer, {
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent
        }, (0, $8QF8A.getBooleanFF)("platform.design-system-team.iframe_gojiv") && (0, $2ZUkg.jsx)((0, $2ZUkg.Global), {
            styles: $903257d3e53321f8$var$blockPointerEventsOnExternalIframeStyles
        }), (0, $2ZUkg.jsx)((0, $8GBzc.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$903257d3e53321f8$export$2e2bcd8739ae039 = $903257d3e53321f8$var$PopperWrapper;

});
parcelRegister("hxnU6", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $cc480f90d81499b3$export$cec37b93989366d4; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $awRUe = parcelRequire("awRUe");
var $cc480f90d81499b3$var$ESCAPE = "Escape";
function $cc480f90d81499b3$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $iSvIT.useRef)(false);
    var _UNSAFE_useLayering = $cc480f90d81499b3$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $iSvIT.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $cc480f90d81499b3$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $iSvIT.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $iSvIT.useEffect)(function() {
        return (0, $2e1kT.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $cc480f90d81499b3$export$cec37b93989366d4() {
    var currentLevel = (0, $iSvIT.useContext)((0, $awRUe.LevelContext));
    var _useContext = (0, $iSvIT.useContext)((0, $awRUe.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $iSvIT.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("a2QII", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $7502fc6fdaa101d0$export$badac9ada3a0bdf9; });

var $7i8I2 = parcelRequire("7i8I2");

var $cGZ0i = parcelRequire("cGZ0i");

var $iSvIT = parcelRequire("iSvIT");

var $3sDVf = parcelRequire("3sDVf");

// Export types from PopperJS / React Popper
var $7502fc6fdaa101d0$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $7502fc6fdaa101d0$var$defaultChildrenFn() {
    return null;
}
var $7502fc6fdaa101d0$var$defaultOffset = [
    0,
    8
];
function $7502fc6fdaa101d0$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $7502fc6fdaa101d0$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $7502fc6fdaa101d0$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, $cGZ0i.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $iSvIT.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($7502fc6fdaa101d0$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $iSvIT.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $7i8I2.default)(internalModifiers), (0, $7i8I2.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3sDVf.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("3sDVf", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $2852f45d1e39a7ea$export$badac9ada3a0bdf9; });

var $iSvIT = parcelRequire("iSvIT");

var $kj81I = parcelRequire("kj81I");

var $9oXzE = parcelRequire("9oXzE");

var $f0QwF = parcelRequire("f0QwF");
var $2852f45d1e39a7ea$var$NOOP = function NOOP() {
    return void 0;
};
var $2852f45d1e39a7ea$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $2852f45d1e39a7ea$var$EMPTY_MODIFIERS = [];
function $2852f45d1e39a7ea$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $2852f45d1e39a7ea$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $iSvIT.useContext((0, $kj81I.ManagerReferenceNodeContext));
    var _React$useState = $iSvIT.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $iSvIT.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $iSvIT.useEffect(function() {
        (0, $9oXzE.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $iSvIT.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $f0QwF.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $iSvIT.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $2852f45d1e39a7ea$var$NOOP,
            update: update || $2852f45d1e39a7ea$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $9oXzE.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("f0QwF", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $aedf99a592ecf360$export$f4d5bf230a36dd6e; });

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $eqbvm = parcelRequire("eqbvm");

var $bfGvY = parcelRequire("bfGvY");

var $9oXzE = parcelRequire("9oXzE");
var $aedf99a592ecf360$var$EMPTY_MODIFIERS = [];
var $aedf99a592ecf360$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $iSvIT.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $aedf99a592ecf360$var$EMPTY_MODIFIERS
    };
    var _React$useState = $iSvIT.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $iSvIT.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $i5UxU.flushSync(function() {
                    setState({
                        styles: (0, $9oXzE.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $9oXzE.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $iSvIT.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($bfGvY)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $iSvIT.useRef();
    (0, $9oXzE.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $9oXzE.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $eqbvm.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("eqbvm", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $a7fc6b099d822046$export$8f7491d57c8f97a9; });

var $baz2w = parcelRequire("baz2w");

var $kjEyn = parcelRequire("kjEyn");

var $l9EIm = parcelRequire("l9EIm");

var $5bCWg = parcelRequire("5bCWg");

var $8fRFu = parcelRequire("8fRFu");

var $l7uO8 = parcelRequire("l7uO8");

var $9tAb3 = parcelRequire("9tAb3");

var $cf45v = parcelRequire("cf45v");

var $aJbRO = parcelRequire("aJbRO");

var $dIWx1 = parcelRequire("dIWx1");


var $a7fc6b099d822046$export$d34966752335dd47 = [
    (0, $kjEyn.default),
    (0, $l9EIm.default),
    (0, $5bCWg.default),
    (0, $8fRFu.default),
    (0, $l7uO8.default),
    (0, $9tAb3.default),
    (0, $cf45v.default),
    (0, $aJbRO.default),
    (0, $dIWx1.default)
];
var $a7fc6b099d822046$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $baz2w.popperGenerator)({
    defaultModifiers: $a7fc6b099d822046$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("baz2w", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $821bcf06a527f72a$export$ed5e13716264f202; });

var $esrb7 = parcelRequire("esrb7");

var $bhdAL = parcelRequire("bhdAL");

var $i04WI = parcelRequire("i04WI");

var $cWbDk = parcelRequire("cWbDk");

var $a0Vjp = parcelRequire("a0Vjp");

var $2sQec = parcelRequire("2sQec");

var $7EfqT = parcelRequire("7EfqT");


var $9eh8e = parcelRequire("9eh8e");
var $821bcf06a527f72a$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $821bcf06a527f72a$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $821bcf06a527f72a$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $821bcf06a527f72a$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $821bcf06a527f72a$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $9eh8e.isElement)(reference) ? (0, $i04WI.default)(reference) : reference.contextElement ? (0, $i04WI.default)(reference.contextElement) : [],
                    popper: (0, $i04WI.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $a0Vjp.default)((0, $7EfqT.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$821bcf06a527f72a$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $esrb7.default)(reference, (0, $cWbDk.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $bhdAL.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $2sQec.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$821bcf06a527f72a$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $821bcf06a527f72a$export$8f7491d57c8f97a9 = /*#__PURE__*/ $821bcf06a527f72a$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("esrb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a868c33e159f5ac9$export$2e2bcd8739ae039; });

var $hHRAJ = parcelRequire("hHRAJ");

var $1I1tL = parcelRequire("1I1tL");

var $hDOwH = parcelRequire("hDOwH");

var $9eh8e = parcelRequire("9eh8e");

var $3w8Sw = parcelRequire("3w8Sw");

var $dUX6G = parcelRequire("dUX6G");

var $hx13s = parcelRequire("hx13s");

var $iDilC = parcelRequire("iDilC");
function $a868c33e159f5ac9$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $iDilC.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $iDilC.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $a868c33e159f5ac9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $9eh8e.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $9eh8e.isHTMLElement)(offsetParent) && $a868c33e159f5ac9$var$isElementScaled(offsetParent);
    var documentElement = (0, $dUX6G.default)(offsetParent);
    var rect = (0, $hHRAJ.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $hDOwH.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $hx13s.default)(documentElement)) scroll = (0, $1I1tL.default)(offsetParent);
        if ((0, $9eh8e.isHTMLElement)(offsetParent)) {
            offsets = (0, $hHRAJ.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $3w8Sw.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("hHRAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce4005f5acb4e459$export$2e2bcd8739ae039; });

var $9eh8e = parcelRequire("9eh8e");

var $iDilC = parcelRequire("iDilC");

var $kHrfa = parcelRequire("kHrfa");

var $6UBtt = parcelRequire("6UBtt");
function $ce4005f5acb4e459$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $9eh8e.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $iDilC.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $iDilC.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $9eh8e.isElement)(element) ? (0, $kHrfa.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $6UBtt.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("9eh8e", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $6b82b5dfa10b06ed$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $6b82b5dfa10b06ed$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $6b82b5dfa10b06ed$export$af51f0f06c0f328a; });

var $kHrfa = parcelRequire("kHrfa");
function $6b82b5dfa10b06ed$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $kHrfa.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6b82b5dfa10b06ed$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $kHrfa.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6b82b5dfa10b06ed$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $kHrfa.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("kHrfa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f11cf4cd63845139$export$2e2bcd8739ae039; });
function $f11cf4cd63845139$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("iDilC", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $d90a19f80167b9bd$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $d90a19f80167b9bd$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $d90a19f80167b9bd$export$2077e0241d6afd3c; });
var $d90a19f80167b9bd$export$8960430cfd85939f = Math.max;
var $d90a19f80167b9bd$export$96ec731ed4dcb222 = Math.min;
var $d90a19f80167b9bd$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("6UBtt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50850aa5b9eaee9e$export$2e2bcd8739ae039; });

var $1EcYf = parcelRequire("1EcYf");
function $50850aa5b9eaee9e$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $1EcYf.default)());
}

});
parcelRegister("1EcYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13339691a4b9ac4b$export$2e2bcd8739ae039; });
function $13339691a4b9ac4b$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("1I1tL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13eb0c3263448f93$export$2e2bcd8739ae039; });

var $ZFXOY = parcelRequire("ZFXOY");

var $kHrfa = parcelRequire("kHrfa");

var $9eh8e = parcelRequire("9eh8e");

var $7Ploi = parcelRequire("7Ploi");
function $13eb0c3263448f93$export$2e2bcd8739ae039(node) {
    if (node === (0, $kHrfa.default)(node) || !(0, $9eh8e.isHTMLElement)(node)) return (0, $ZFXOY.default)(node);
    else return (0, $7Ploi.default)(node);
}

});
parcelRegister("ZFXOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b963fc49a03c672$export$2e2bcd8739ae039; });

var $kHrfa = parcelRequire("kHrfa");
function $0b963fc49a03c672$export$2e2bcd8739ae039(node) {
    var win = (0, $kHrfa.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("7Ploi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b2de39bed8ecab4$export$2e2bcd8739ae039; });
function $5b2de39bed8ecab4$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("hDOwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd7d45af0f4e51a8$export$2e2bcd8739ae039; });
function $cd7d45af0f4e51a8$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("3w8Sw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28fb3f5826a63df1$export$2e2bcd8739ae039; });

var $hHRAJ = parcelRequire("hHRAJ");

var $dUX6G = parcelRequire("dUX6G");

var $ZFXOY = parcelRequire("ZFXOY");
function $28fb3f5826a63df1$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $hHRAJ.default)((0, $dUX6G.default)(element)).left + (0, $ZFXOY.default)(element).scrollLeft;
}

});
parcelRegister("dUX6G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a21e5ab48b6e651a$export$2e2bcd8739ae039; });

var $9eh8e = parcelRequire("9eh8e");
function $a21e5ab48b6e651a$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $9eh8e.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("hx13s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc36562b69cd7edf$export$2e2bcd8739ae039; });

var $7acR6 = parcelRequire("7acR6");
function $cc36562b69cd7edf$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $7acR6.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("7acR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5373706cf850ef05$export$2e2bcd8739ae039; });

var $kHrfa = parcelRequire("kHrfa");
function $5373706cf850ef05$export$2e2bcd8739ae039(element) {
    return (0, $kHrfa.default)(element).getComputedStyle(element);
}

});



parcelRegister("bhdAL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $835bd35231b918ac$export$2e2bcd8739ae039; });

var $hHRAJ = parcelRequire("hHRAJ");
function $835bd35231b918ac$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $hHRAJ.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("i04WI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1ac1044ec82e8a0$export$2e2bcd8739ae039; });

var $gGm8q = parcelRequire("gGm8q");

var $iDyJK = parcelRequire("iDyJK");

var $kHrfa = parcelRequire("kHrfa");

var $hx13s = parcelRequire("hx13s");
function $d1ac1044ec82e8a0$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $gGm8q.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $kHrfa.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $hx13s.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($d1ac1044ec82e8a0$export$2e2bcd8739ae039((0, $iDyJK.default)(target)));
}

});
parcelRegister("gGm8q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c251bd17b0d4595c$export$2e2bcd8739ae039; });

var $iDyJK = parcelRequire("iDyJK");

var $hx13s = parcelRequire("hx13s");

var $hDOwH = parcelRequire("hDOwH");

var $9eh8e = parcelRequire("9eh8e");
function $c251bd17b0d4595c$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $hDOwH.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $9eh8e.isHTMLElement)(node) && (0, $hx13s.default)(node)) return node;
    return $c251bd17b0d4595c$export$2e2bcd8739ae039((0, $iDyJK.default)(node));
}

});
parcelRegister("iDyJK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d916d08d8ece44dd$export$2e2bcd8739ae039; });

var $hDOwH = parcelRequire("hDOwH");

var $dUX6G = parcelRequire("dUX6G");

var $9eh8e = parcelRequire("9eh8e");
function $d916d08d8ece44dd$export$2e2bcd8739ae039(element) {
    if ((0, $hDOwH.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $9eh8e.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $dUX6G.default)(element) // fallback
    );
}

});



parcelRegister("cWbDk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96b3ecee027d2892$export$2e2bcd8739ae039; });

var $kHrfa = parcelRequire("kHrfa");

var $hDOwH = parcelRequire("hDOwH");

var $7acR6 = parcelRequire("7acR6");

var $9eh8e = parcelRequire("9eh8e");

var $ddUJ5 = parcelRequire("ddUJ5");

var $iDyJK = parcelRequire("iDyJK");

var $1EcYf = parcelRequire("1EcYf");
function $96b3ecee027d2892$var$getTrueOffsetParent(element) {
    if (!(0, $9eh8e.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $7acR6.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $96b3ecee027d2892$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $1EcYf.default)());
    var isIE = /Trident/i.test((0, $1EcYf.default)());
    if (isIE && (0, $9eh8e.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $7acR6.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $iDyJK.default)(element);
    if ((0, $9eh8e.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $9eh8e.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $hDOwH.default)(currentNode)) < 0){
        var css = (0, $7acR6.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $96b3ecee027d2892$export$2e2bcd8739ae039(element) {
    var window = (0, $kHrfa.default)(element);
    var offsetParent = $96b3ecee027d2892$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $ddUJ5.default)(offsetParent) && (0, $7acR6.default)(offsetParent).position === "static")offsetParent = $96b3ecee027d2892$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $hDOwH.default)(offsetParent) === "html" || (0, $hDOwH.default)(offsetParent) === "body" && (0, $7acR6.default)(offsetParent).position === "static")) return window;
    return offsetParent || $96b3ecee027d2892$var$getContainingBlock(element) || window;
}

});
parcelRegister("ddUJ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a087de444c1ae98$export$2e2bcd8739ae039; });

var $hDOwH = parcelRequire("hDOwH");
function $9a087de444c1ae98$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $hDOwH.default)(element)) >= 0;
}

});


parcelRegister("a0Vjp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74a65c6f301eb665$export$2e2bcd8739ae039; });

var $l2o7N = parcelRequire("l2o7N");
function $74a65c6f301eb665$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $74a65c6f301eb665$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $74a65c6f301eb665$var$order(modifiers); // order based on phase
    return (0, $l2o7N.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("l2o7N", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $f50c7f8ce0f8c86c$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $f50c7f8ce0f8c86c$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $f50c7f8ce0f8c86c$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $f50c7f8ce0f8c86c$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $f50c7f8ce0f8c86c$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $f50c7f8ce0f8c86c$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $f50c7f8ce0f8c86c$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $f50c7f8ce0f8c86c$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $f50c7f8ce0f8c86c$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $f50c7f8ce0f8c86c$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $f50c7f8ce0f8c86c$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $f50c7f8ce0f8c86c$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $f50c7f8ce0f8c86c$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $f50c7f8ce0f8c86c$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $f50c7f8ce0f8c86c$export$d087d3878fdf71d5; });
var $f50c7f8ce0f8c86c$export$1e95b668f3b82d = "top";
var $f50c7f8ce0f8c86c$export$40e543e69a8b3fbb = "bottom";
var $f50c7f8ce0f8c86c$export$79ffe56a765070d2 = "right";
var $f50c7f8ce0f8c86c$export$eabcd2c8791e7bf4 = "left";
var $f50c7f8ce0f8c86c$export$dfb5619354ba860 = "auto";
var $f50c7f8ce0f8c86c$export$aec2ce47c367b8c3 = [
    $f50c7f8ce0f8c86c$export$1e95b668f3b82d,
    $f50c7f8ce0f8c86c$export$40e543e69a8b3fbb,
    $f50c7f8ce0f8c86c$export$79ffe56a765070d2,
    $f50c7f8ce0f8c86c$export$eabcd2c8791e7bf4
];
var $f50c7f8ce0f8c86c$export$b3571188c770cc5a = "start";
var $f50c7f8ce0f8c86c$export$bd5df0f255a350f8 = "end";
var $f50c7f8ce0f8c86c$export$390fd549c5303b4d = "clippingParents";
var $f50c7f8ce0f8c86c$export$d7b7311ec04a3e8f = "viewport";
var $f50c7f8ce0f8c86c$export$ae5ab1c730825774 = "popper";
var $f50c7f8ce0f8c86c$export$ca50aac9f3ba507f = "reference";
var $f50c7f8ce0f8c86c$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f50c7f8ce0f8c86c$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f50c7f8ce0f8c86c$export$b3571188c770cc5a,
        placement + "-" + $f50c7f8ce0f8c86c$export$bd5df0f255a350f8
    ]);
}, []);
var $f50c7f8ce0f8c86c$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f50c7f8ce0f8c86c$export$aec2ce47c367b8c3, [
    $f50c7f8ce0f8c86c$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f50c7f8ce0f8c86c$export$b3571188c770cc5a,
        placement + "-" + $f50c7f8ce0f8c86c$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f50c7f8ce0f8c86c$export$421679a7c3d56e = "beforeRead";
var $f50c7f8ce0f8c86c$export$aafa59e2e03f2942 = "read";
var $f50c7f8ce0f8c86c$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $f50c7f8ce0f8c86c$export$c65e99957a05207c = "beforeMain";
var $f50c7f8ce0f8c86c$export$f22da7240b7add18 = "main";
var $f50c7f8ce0f8c86c$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f50c7f8ce0f8c86c$export$8d4d2d70e7d46032 = "beforeWrite";
var $f50c7f8ce0f8c86c$export$68d8715fc104d294 = "write";
var $f50c7f8ce0f8c86c$export$70a6e5159acce2e6 = "afterWrite";
var $f50c7f8ce0f8c86c$export$d087d3878fdf71d5 = [
    $f50c7f8ce0f8c86c$export$421679a7c3d56e,
    $f50c7f8ce0f8c86c$export$aafa59e2e03f2942,
    $f50c7f8ce0f8c86c$export$6964f6c886723980,
    $f50c7f8ce0f8c86c$export$c65e99957a05207c,
    $f50c7f8ce0f8c86c$export$f22da7240b7add18,
    $f50c7f8ce0f8c86c$export$bab79516f2d662fe,
    $f50c7f8ce0f8c86c$export$8d4d2d70e7d46032,
    $f50c7f8ce0f8c86c$export$68d8715fc104d294,
    $f50c7f8ce0f8c86c$export$70a6e5159acce2e6
];

});


parcelRegister("2sQec", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cb6b5af29835f80$export$2e2bcd8739ae039; });
function $1cb6b5af29835f80$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("7EfqT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59183d7af158f4e3$export$2e2bcd8739ae039; });
function $59183d7af158f4e3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("kjEyn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca50a0b68ac8793$export$2e2bcd8739ae039; });

var $kHrfa = parcelRequire("kHrfa");
var $eca50a0b68ac8793$var$passive = {
    passive: true
};
function $eca50a0b68ac8793$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $kHrfa.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $eca50a0b68ac8793$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $eca50a0b68ac8793$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $eca50a0b68ac8793$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $eca50a0b68ac8793$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $eca50a0b68ac8793$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $eca50a0b68ac8793$var$effect,
    data: {}
};

});

parcelRegister("l9EIm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f66a054c431f7972$export$2e2bcd8739ae039; });

var $4pCRk = parcelRequire("4pCRk");
function $f66a054c431f7972$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4pCRk.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f66a054c431f7972$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $f66a054c431f7972$var$popperOffsets,
    data: {}
};

});
parcelRegister("4pCRk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3367a3d484a35d61$export$2e2bcd8739ae039; });

var $hZamf = parcelRequire("hZamf");

var $iiQFw = parcelRequire("iiQFw");

var $iAL9b = parcelRequire("iAL9b");

var $l2o7N = parcelRequire("l2o7N");
function $3367a3d484a35d61$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $hZamf.default)(placement) : null;
    var variation = placement ? (0, $iiQFw.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $l2o7N.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $l2o7N.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $l2o7N.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $l2o7N.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $iAL9b.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $l2o7N.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $l2o7N.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("hZamf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1802b073fd70c19$export$2e2bcd8739ae039; });

function $d1802b073fd70c19$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("iiQFw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d532c35345169521$export$2e2bcd8739ae039; });
function $d532c35345169521$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("iAL9b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d890293374283e33$export$2e2bcd8739ae039; });
function $d890293374283e33$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("5bCWg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c6c2f4446ee9910$export$2e2bcd8739ae039; });

var $l2o7N = parcelRequire("l2o7N");

var $cWbDk = parcelRequire("cWbDk");

var $kHrfa = parcelRequire("kHrfa");

var $dUX6G = parcelRequire("dUX6G");

var $7acR6 = parcelRequire("7acR6");

var $hZamf = parcelRequire("hZamf");

var $iiQFw = parcelRequire("iiQFw");

var $iDilC = parcelRequire("iDilC");
var $3c6c2f4446ee9910$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3c6c2f4446ee9910$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $iDilC.round)(x * dpr) / dpr || 0,
        y: (0, $iDilC.round)(y * dpr) / dpr || 0
    };
}
function $3c6c2f4446ee9910$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $l2o7N.left);
    var sideY = (0, $l2o7N.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $cWbDk.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $kHrfa.default)(popper)) {
            offsetParent = (0, $dUX6G.default)(popper);
            if ((0, $7acR6.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $l2o7N.top) || (placement === (0, $l2o7N.left) || placement === (0, $l2o7N.right)) && variation === (0, $l2o7N.end)) {
            sideY = (0, $l2o7N.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $l2o7N.left) || (placement === (0, $l2o7N.top) || placement === (0, $l2o7N.bottom)) && variation === (0, $l2o7N.end)) {
            sideX = (0, $l2o7N.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3c6c2f4446ee9910$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3c6c2f4446ee9910$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $kHrfa.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $3c6c2f4446ee9910$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $hZamf.default)(state.placement),
        variation: (0, $iiQFw.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3c6c2f4446ee9910$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3c6c2f4446ee9910$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3c6c2f4446ee9910$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $3c6c2f4446ee9910$var$computeStyles,
    data: {}
};

});

parcelRegister("8fRFu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60295ad890c7f85e$export$2e2bcd8739ae039; });

var $hDOwH = parcelRequire("hDOwH");

var $9eh8e = parcelRequire("9eh8e");
// and applies them to the HTMLElements such as popper and arrow
function $60295ad890c7f85e$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $9eh8e.isHTMLElement)(element) || !(0, $hDOwH.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $60295ad890c7f85e$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $9eh8e.isHTMLElement)(element) || !(0, $hDOwH.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $60295ad890c7f85e$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $60295ad890c7f85e$var$applyStyles,
    effect: $60295ad890c7f85e$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("l7uO8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6022632b97ac669$export$2e2bcd8739ae039; });

var $hZamf = parcelRequire("hZamf");

var $l2o7N = parcelRequire("l2o7N");
function $f6022632b97ac669$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $hZamf.default)(placement);
    var invertDistance = [
        (0, $l2o7N.left),
        (0, $l2o7N.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $l2o7N.left),
        (0, $l2o7N.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f6022632b97ac669$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $l2o7N.placements).reduce(function(acc, placement) {
        acc[placement] = $f6022632b97ac669$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f6022632b97ac669$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $f6022632b97ac669$var$offset
};

});

parcelRegister("9tAb3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e62e28b1d735770$export$2e2bcd8739ae039; });

var $2LTyh = parcelRequire("2LTyh");

var $hZamf = parcelRequire("hZamf");

var $4RoLm = parcelRequire("4RoLm");

var $27gYi = parcelRequire("27gYi");

var $8j3bA = parcelRequire("8j3bA");

var $l2o7N = parcelRequire("l2o7N");

var $iiQFw = parcelRequire("iiQFw");
function $6e62e28b1d735770$var$getExpandedFallbackPlacements(placement) {
    if ((0, $hZamf.default)(placement) === (0, $l2o7N.auto)) return [];
    var oppositePlacement = (0, $2LTyh.default)(placement);
    return [
        (0, $4RoLm.default)(placement),
        oppositePlacement,
        (0, $4RoLm.default)(oppositePlacement)
    ];
}
function $6e62e28b1d735770$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $hZamf.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $2LTyh.default)(preferredPlacement)
    ] : $6e62e28b1d735770$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $hZamf.default)(placement) === (0, $l2o7N.auto) ? (0, $8j3bA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $hZamf.default)(placement);
        var isStartVariation = (0, $iiQFw.default)(placement) === (0, $l2o7N.start);
        var isVertical = [
            (0, $l2o7N.top),
            (0, $l2o7N.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $27gYi.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $l2o7N.right) : (0, $l2o7N.left) : isStartVariation ? (0, $l2o7N.bottom) : (0, $l2o7N.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $2LTyh.default)(mainVariationSide);
        var altVariationSide = (0, $2LTyh.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6e62e28b1d735770$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $6e62e28b1d735770$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("2LTyh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $204b1005cfb2be5d$export$2e2bcd8739ae039; });
var $204b1005cfb2be5d$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $204b1005cfb2be5d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $204b1005cfb2be5d$var$hash[matched];
    });
}

});

parcelRegister("4RoLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $389f520aaed251b3$export$2e2bcd8739ae039; });
var $389f520aaed251b3$var$hash = {
    start: "end",
    end: "start"
};
function $389f520aaed251b3$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $389f520aaed251b3$var$hash[matched];
    });
}

});

parcelRegister("27gYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18a966692391545f$export$2e2bcd8739ae039; });

var $1MXjj = parcelRequire("1MXjj");

var $dUX6G = parcelRequire("dUX6G");

var $hHRAJ = parcelRequire("hHRAJ");

var $4pCRk = parcelRequire("4pCRk");

var $fIoBd = parcelRequire("fIoBd");

var $l2o7N = parcelRequire("l2o7N");

var $9eh8e = parcelRequire("9eh8e");

var $fmTSe = parcelRequire("fmTSe");

var $kXh7P = parcelRequire("kXh7P");
function $18a966692391545f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $l2o7N.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $l2o7N.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $l2o7N.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $fmTSe.default)(typeof padding !== "number" ? padding : (0, $kXh7P.default)(padding, (0, $l2o7N.basePlacements)));
    var altContext = elementContext === (0, $l2o7N.popper) ? (0, $l2o7N.reference) : (0, $l2o7N.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $1MXjj.default)((0, $9eh8e.isElement)(element) ? element : element.contextElement || (0, $dUX6G.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $hHRAJ.default)(state.elements.reference);
    var popperOffsets = (0, $4pCRk.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $fIoBd.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $l2o7N.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $l2o7N.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $l2o7N.right),
                (0, $l2o7N.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $l2o7N.top),
                (0, $l2o7N.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("1MXjj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14d847fd6fb15816$export$2e2bcd8739ae039; });

var $l2o7N = parcelRequire("l2o7N");

var $7eR3j = parcelRequire("7eR3j");

var $304fW = parcelRequire("304fW");

var $i04WI = parcelRequire("i04WI");

var $cWbDk = parcelRequire("cWbDk");

var $dUX6G = parcelRequire("dUX6G");

var $7acR6 = parcelRequire("7acR6");

var $9eh8e = parcelRequire("9eh8e");

var $hHRAJ = parcelRequire("hHRAJ");

var $iDyJK = parcelRequire("iDyJK");

var $jYd0b = parcelRequire("jYd0b");

var $hDOwH = parcelRequire("hDOwH");

var $fIoBd = parcelRequire("fIoBd");

var $iDilC = parcelRequire("iDilC");
function $14d847fd6fb15816$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $hHRAJ.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $14d847fd6fb15816$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $l2o7N.viewport) ? (0, $fIoBd.default)((0, $7eR3j.default)(element, strategy)) : (0, $9eh8e.isElement)(clippingParent) ? $14d847fd6fb15816$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $fIoBd.default)((0, $304fW.default)((0, $dUX6G.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $14d847fd6fb15816$var$getClippingParents(element) {
    var clippingParents = (0, $i04WI.default)((0, $iDyJK.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $7acR6.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $9eh8e.isHTMLElement)(element) ? (0, $cWbDk.default)(element) : element;
    if (!(0, $9eh8e.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $9eh8e.isElement)(clippingParent) && (0, $jYd0b.default)(clippingParent, clipperElement) && (0, $hDOwH.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $14d847fd6fb15816$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $14d847fd6fb15816$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $14d847fd6fb15816$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $iDilC.max)(rect.top, accRect.top);
        accRect.right = (0, $iDilC.min)(rect.right, accRect.right);
        accRect.bottom = (0, $iDilC.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $iDilC.max)(rect.left, accRect.left);
        return accRect;
    }, $14d847fd6fb15816$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("7eR3j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5452fe54392d694a$export$2e2bcd8739ae039; });

var $kHrfa = parcelRequire("kHrfa");

var $dUX6G = parcelRequire("dUX6G");

var $3w8Sw = parcelRequire("3w8Sw");

var $6UBtt = parcelRequire("6UBtt");
function $5452fe54392d694a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $kHrfa.default)(element);
    var html = (0, $dUX6G.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $6UBtt.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $3w8Sw.default)(element),
        y: y
    };
}

});

parcelRegister("304fW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22f4ac60b575e628$export$2e2bcd8739ae039; });

var $dUX6G = parcelRequire("dUX6G");

var $7acR6 = parcelRequire("7acR6");

var $3w8Sw = parcelRequire("3w8Sw");

var $ZFXOY = parcelRequire("ZFXOY");

var $iDilC = parcelRequire("iDilC");
function $22f4ac60b575e628$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $dUX6G.default)(element);
    var winScroll = (0, $ZFXOY.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $iDilC.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $iDilC.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $3w8Sw.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $7acR6.default)(body || html).direction === "rtl") x += (0, $iDilC.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("jYd0b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e89db4d320f99138$export$2e2bcd8739ae039; });

var $9eh8e = parcelRequire("9eh8e");
function $e89db4d320f99138$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $9eh8e.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("fIoBd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b70e0bfae3c80a1f$export$2e2bcd8739ae039; });
function $b70e0bfae3c80a1f$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("fmTSe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3044071b2f717df$export$2e2bcd8739ae039; });

var $cLlsl = parcelRequire("cLlsl");
function $b3044071b2f717df$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $cLlsl.default)(), paddingObject);
}

});
parcelRegister("cLlsl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94aa8491a8afdc57$export$2e2bcd8739ae039; });
function $94aa8491a8afdc57$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("kXh7P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4169a0f47fe87ef$export$2e2bcd8739ae039; });
function $f4169a0f47fe87ef$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("8j3bA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60c291be2c8fcc54$export$2e2bcd8739ae039; });

var $iiQFw = parcelRequire("iiQFw");

var $l2o7N = parcelRequire("l2o7N");

var $27gYi = parcelRequire("27gYi");

var $hZamf = parcelRequire("hZamf");
function $60c291be2c8fcc54$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $l2o7N.placements) : _options$allowedAutoP;
    var variation = (0, $iiQFw.default)(placement);
    var placements = variation ? flipVariations ? (0, $l2o7N.variationPlacements) : (0, $l2o7N.variationPlacements).filter(function(placement) {
        return (0, $iiQFw.default)(placement) === variation;
    }) : (0, $l2o7N.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $27gYi.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $hZamf.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("cf45v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e9a0e80ff9208a3$export$2e2bcd8739ae039; });

var $l2o7N = parcelRequire("l2o7N");

var $hZamf = parcelRequire("hZamf");

var $iAL9b = parcelRequire("iAL9b");

var $2tvLq = parcelRequire("2tvLq");

var $irPNW = parcelRequire("irPNW");

var $bhdAL = parcelRequire("bhdAL");

var $cWbDk = parcelRequire("cWbDk");

var $27gYi = parcelRequire("27gYi");

var $iiQFw = parcelRequire("iiQFw");

var $cLlsl = parcelRequire("cLlsl");

var $iDilC = parcelRequire("iDilC");
function $8e9a0e80ff9208a3$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $27gYi.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $hZamf.default)(state.placement);
    var variation = (0, $iiQFw.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $iAL9b.default)(basePlacement);
    var altAxis = (0, $2tvLq.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $l2o7N.top) : (0, $l2o7N.left);
        var altSide = mainAxis === "y" ? (0, $l2o7N.bottom) : (0, $l2o7N.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $l2o7N.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $l2o7N.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $bhdAL.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $cLlsl.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $irPNW.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $cWbDk.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $irPNW.within)(tether ? (0, $iDilC.min)(min, tetherMin) : min, offset, tether ? (0, $iDilC.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $l2o7N.top) : (0, $l2o7N.left);
        var _altSide = mainAxis === "x" ? (0, $l2o7N.bottom) : (0, $l2o7N.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $l2o7N.top),
            (0, $l2o7N.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $irPNW.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $irPNW.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8e9a0e80ff9208a3$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $8e9a0e80ff9208a3$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("2tvLq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cd6edd8576896c6$export$2e2bcd8739ae039; });
function $1cd6edd8576896c6$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("irPNW", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $d6e2eee7bd9576aa$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $d6e2eee7bd9576aa$export$86c8af6d3ef0b4a; });

var $iDilC = parcelRequire("iDilC");
function $d6e2eee7bd9576aa$export$f28d906d67a997f3(min, value, max) {
    return (0, $iDilC.max)(min, (0, $iDilC.min)(value, max));
}
function $d6e2eee7bd9576aa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d6e2eee7bd9576aa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("aJbRO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf74fde02c96944$export$2e2bcd8739ae039; });

var $hZamf = parcelRequire("hZamf");

var $bhdAL = parcelRequire("bhdAL");

var $jYd0b = parcelRequire("jYd0b");

var $cWbDk = parcelRequire("cWbDk");

var $iAL9b = parcelRequire("iAL9b");

var $irPNW = parcelRequire("irPNW");

var $fmTSe = parcelRequire("fmTSe");

var $kXh7P = parcelRequire("kXh7P");

var $l2o7N = parcelRequire("l2o7N");
var $7cf74fde02c96944$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $fmTSe.default)(typeof padding !== "number" ? padding : (0, $kXh7P.default)(padding, (0, $l2o7N.basePlacements)));
};
function $7cf74fde02c96944$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $hZamf.default)(state.placement);
    var axis = (0, $iAL9b.default)(basePlacement);
    var isVertical = [
        (0, $l2o7N.left),
        (0, $l2o7N.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $7cf74fde02c96944$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $bhdAL.default)(arrowElement);
    var minProp = axis === "y" ? (0, $l2o7N.top) : (0, $l2o7N.left);
    var maxProp = axis === "y" ? (0, $l2o7N.bottom) : (0, $l2o7N.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $cWbDk.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $irPNW.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $7cf74fde02c96944$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $jYd0b.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $7cf74fde02c96944$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $7cf74fde02c96944$var$arrow,
    effect: $7cf74fde02c96944$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("dIWx1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fdcc998592dd4fb$export$2e2bcd8739ae039; });

var $l2o7N = parcelRequire("l2o7N");

var $27gYi = parcelRequire("27gYi");
function $9fdcc998592dd4fb$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $9fdcc998592dd4fb$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $l2o7N.top),
        (0, $l2o7N.right),
        (0, $l2o7N.bottom),
        (0, $l2o7N.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $9fdcc998592dd4fb$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $27gYi.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $27gYi.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $9fdcc998592dd4fb$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $9fdcc998592dd4fb$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $9fdcc998592dd4fb$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $9fdcc998592dd4fb$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $9fdcc998592dd4fb$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $9fdcc998592dd4fb$var$hide
};

});





parcelRegister("iGLnR", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $d9b0e7b485dada1c$export$9d7b58831ae93caa; });
var $d9b0e7b485dada1c$export$4ef52930e33717cd = "data-theme";
var $d9b0e7b485dada1c$export$a00eac3f8684bcd0 = "data-color-mode";
var $d9b0e7b485dada1c$export$2112803007239c61 = "data-contrast-mode";
var $d9b0e7b485dada1c$export$352e418ed5b6193a = "data-custom-theme";
var $d9b0e7b485dada1c$export$2faeed762aac6741 = "light";
var $d9b0e7b485dada1c$export$6f0c6fb8c80fcc92 = "ds";
var $d9b0e7b485dada1c$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $d9b0e7b485dada1c$export$dddac1532e822863 = "--".concat($d9b0e7b485dada1c$export$6f0c6fb8c80fcc92, "-token-not-found");
var $d9b0e7b485dada1c$export$9d7b58831ae93caa = "--".concat($d9b0e7b485dada1c$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("8GBzc", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $01a1cbeb268f1bba$export$51eddd7655ca235a; });

var $iSvIT = parcelRequire("iSvIT");
var $01a1cbeb268f1bba$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $iSvIT.useRef)(true);
    (0, $iSvIT.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Fragment), null, children);
};

});

parcelRegister("47y4t", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $30023eb27e6bcfd7$export$92dae2778ae88f9d; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $8QUK9 = parcelRequire("8QUK9");

var $hxnU6 = parcelRequire("hxnU6");
var $30023eb27e6bcfd7$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab;
    var _UNSAFE_useLayering = (0, $hxnU6.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    (0, $iSvIT.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $8QUK9.default;
        var closePopup = function closePopup(event) {
            if (onClose) onClose(event);
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) closePopup(event);
        };
        var onKeyDown = function onKeyDown(event) {
            if (isLayerDisabled()) return;
            var key = event.key;
            if (key === "Escape" || key === "Esc" || shouldCloseOnTab && key === "Tab") closePopup(event);
        };
        var unbind = (0, $2e1kT.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        return unbind;
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        capture,
        isLayerDisabled,
        shouldCloseOnTab
    ]);
};

});

parcelRegister("7xyIW", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $57d68cea84b8b0d2$export$10c5169755ce7bd7; });

var $iSvIT = parcelRequire("iSvIT");

var $17K1G = parcelRequire("17K1G");

var $8QUK9 = parcelRequire("8QUK9");
var $57d68cea84b8b0d2$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, shouldCloseOnTab = _ref.shouldCloseOnTab;
    (0, $iSvIT.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $8QUK9.default;
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: true
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($17K1G)))(popupRef, trapConfig);
        var frameId = null;
        // wait for the popup to reposition itself before we focus
        frameId = requestAnimationFrame(function() {
            frameId = null;
            focusTrap.activate();
        });
        return function() {
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        initialFocusRef,
        shouldCloseOnTab
    ]);
};

});


parcelRegister("jBreO", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $e45699edc584e49d$export$7cc5c058dd769dff; });

var $cGZ0i = parcelRequire("cGZ0i");

var $iSvIT = parcelRequire("iSvIT");

var $fV0Sg = parcelRequire("fV0Sg");
var $e45699edc584e49d$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $iSvIT.useState)(function() {
        return (0, $fV0Sg.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $cGZ0i.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});



parcelRegister("81fYe", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", function () { return $5d6ace1fc13c5c97$export$b2ad68b9bc407b80; });

var $iSvIT = parcelRequire("iSvIT");

var $aVWO5 = parcelRequire("aVWO5");
var $5d6ace1fc13c5c97$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aVWO5.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $5d6ace1fc13c5c97$export$2e2bcd8739ae039 = $5d6ace1fc13c5c97$export$b2ad68b9bc407b80;

});
parcelRegister("aVWO5", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", function () { return $7f5cd81287e5e728$export$ff983d2a2b6112ea; });

var $cGZ0i = parcelRequire("cGZ0i");

var $iSvIT = parcelRequire("iSvIT");

var $c0jX5 = parcelRequire("c0jX5");
var $7f5cd81287e5e728$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $c0jX5.useInView)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, $cGZ0i.default)(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(function() {
        if (typeof window === "undefined") return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        style: {
            display: "block",
            width: "100%",
            position: "absolute"
        },
        ref: inViewRef
    });
});

});
parcelRegister("c0jX5", function(module, exports) {

$parcel$export(module.exports, "useInView", function () { return $8bd4f6289e22794e$export$2f62ee6831462844; });

var $cGZ0i = parcelRequire("cGZ0i");

var $iSvIT = parcelRequire("iSvIT");
function $8bd4f6289e22794e$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, $cGZ0i.default)(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    var inView = intersectionRatio >= (threshold || 0);
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("8Pugw", function(module, exports) {

$parcel$export(module.exports, "OverflowProvider", function () { return $66da90414fa70310$export$a3a2def3937905a0; });
$parcel$export(module.exports, "useOverflowController", function () { return $66da90414fa70310$export$705aa66a39c35bf7; });

var $cGZ0i = parcelRequire("cGZ0i");

var $iSvIT = parcelRequire("iSvIT");

var $gcm2L = parcelRequire("gcm2L");

var $8QUK9 = parcelRequire("8QUK9");
// Prevent width detector from triggering too many re-renders
var $66da90414fa70310$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
var $66da90414fa70310$var$ITEM_APPROX_MINWIDTH = 70;
var $66da90414fa70310$var$calculateHash = function calculateHash(w, n) {
    return w + "#" + n;
};
var $66da90414fa70310$var$updateHashRef = function updateHashRef(currentRef, value) {
    currentRef.unshift(value);
    currentRef.length = 3;
};
var $66da90414fa70310$var$OverflowContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $8QUK9.default),
    closeOverflowMenu: (0, $8QUK9.default)
});
var $66da90414fa70310$export$a3a2def3937905a0 = function OverflowProvider(_ref) {
    var children = _ref.children, isVisible = _ref.isVisible, openOverflowMenu = _ref.openOverflowMenu, closeOverflowMenu = _ref.closeOverflowMenu;
    var Provider = $66da90414fa70310$var$OverflowContext.Provider;
    var value = (0, $iSvIT.useMemo)(function() {
        return {
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        };
    }, [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Provider, {
        value: value
    }, children);
};
var $66da90414fa70310$export$3fcfc71fab3314f2 = function useOverflowStatus() {
    return (0, $iSvIT.useContext)($66da90414fa70310$var$OverflowContext);
};
var $66da90414fa70310$export$705aa66a39c35bf7 = function useOverflowController(nodes) {
    var items = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.toArray(nodes);
    var _useState = (0, $iSvIT.useState)(9999), _useState2 = (0, $cGZ0i.default)(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var _useState3 = (0, $iSvIT.useState)(items.length), _useState4 = (0, $cGZ0i.default)(_useState3, 2), itemsLimit = _useState4[0], setItemsLimit = _useState4[1];
    var _useState5 = (0, $iSvIT.useState)({}), _useState6 = (0, $cGZ0i.default)(_useState5, 2), forceEffectValue = _useState6[0], triggerForceEffect = _useState6[1];
    // Storing items approximate width so we can try expanding when there is enough room
    var itemsWidths = (0, $iSvIT.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    var hashRef = (0, $iSvIT.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttleSetWidth = (0, $iSvIT.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($gcm2L)))(setWidth, $66da90414fa70310$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $iSvIT.useEffect)(function() {
        var lastItemWidth = itemsWidths[itemsLimit] || 0;
        var wasJustLimited = lastItemWidth < 0;
        var currentHash = $66da90414fa70310$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            var t = setTimeout(function() {
                $66da90414fa70310$var$updateHashRef(hashRef.current, "");
                triggerForceEffect({});
            }, $66da90414fa70310$var$THROTTLE_INTERVAL * 1.5);
            return function() {
                return clearTimeout(t);
            };
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            var partialWidth = Math.max(Math.min(width + lastItemWidth, $66da90414fa70310$var$ITEM_APPROX_MINWIDTH * 2), $66da90414fa70310$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $66da90414fa70310$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            var nextHash = $66da90414fa70310$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $66da90414fa70310$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ var currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $66da90414fa70310$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            var _nextHash = $66da90414fa70310$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(_nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $66da90414fa70310$var$updateHashRef(hashRef.current, _nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line @repo/internal/react/use-noop
$66da90414fa70310$export$2e2bcd8739ae039 = function(props) {};

});

parcelRegister("5SzAI", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", function () { return $447d9a902387812f$export$bb3af89fb196520d; });

var $djxp7 = parcelRequire("djxp7");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $3eKXS = parcelRequire("3eKXS");

var $5FONX = parcelRequire("5FONX");
var $eHCkB = parcelRequire("eHCkB");

var $kVgtN = parcelRequire("kVgtN");
var $447d9a902387812f$var$chevronIconStylesWithSpacingFixStyles = (0, $eHCkB.xcss)({
    marginInlineEnd: "space.negative.050"
});
var $447d9a902387812f$export$bb3af89fb196520d = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    return (0, $2ZUkg.jsx)((0, $kVgtN.PrimaryButton), (0, $djxp7.default)({
        iconAfter: (0, $2ZUkg.jsx)((0, $5FONX.default), {
            xcss: $447d9a902387812f$var$chevronIconStylesWithSpacingFixStyles,
            inline: "space.100"
        }, (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3eKXS))), {
            label: ""
        })),
        ref: ref
    }, props));
});
var $447d9a902387812f$export$2e2bcd8739ae039 = $447d9a902387812f$export$bb3af89fb196520d;

});
parcelRegister("3eKXS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25b71c1cc8a249b6$var$_react = $25b71c1cc8a249b6$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $25b71c1cc8a249b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $25b71c1cc8a249b6$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $25b71c1cc8a249b6$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$25b71c1cc8a249b6$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $25b71c1cc8a249b6$var$_default = $25b71c1cc8a249b6$var$ChevronDownIcon;
module.exports.default = $25b71c1cc8a249b6$var$_default;

});

parcelRegister("5FONX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $421830d671a3fab9$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $eHCkB = parcelRequire("eHCkB");
var $421830d671a3fab9$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box"
});
var $421830d671a3fab9$var$blockBleedMap = {
    "space.025": (0, $2ZUkg.css)({
        marginBlock: "var(--ds-space-negative-025, -0.125rem)"
    }),
    "space.050": (0, $2ZUkg.css)({
        marginBlock: "var(--ds-space-negative-050, -0.25rem)"
    }),
    "space.100": (0, $2ZUkg.css)({
        marginBlock: "var(--ds-space-negative-100, -0.5rem)"
    }),
    "space.150": (0, $2ZUkg.css)({
        marginBlock: "var(--ds-space-negative-150, -0.75rem)"
    }),
    "space.200": (0, $2ZUkg.css)({
        marginBlock: "var(--ds-space-negative-200, -1rem)"
    })
};
var $421830d671a3fab9$var$inlineBleedMap = {
    "space.025": (0, $2ZUkg.css)({
        marginInline: "var(--ds-space-negative-025, -0.125rem)"
    }),
    "space.050": (0, $2ZUkg.css)({
        marginInline: "var(--ds-space-negative-050, -0.25rem)"
    }),
    "space.100": (0, $2ZUkg.css)({
        marginInline: "var(--ds-space-negative-100, -0.5rem)"
    }),
    "space.150": (0, $2ZUkg.css)({
        marginInline: "var(--ds-space-negative-150, -0.75rem)"
    }),
    "space.200": (0, $2ZUkg.css)({
        marginInline: "var(--ds-space-negative-200, -1rem)"
    })
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ var $421830d671a3fab9$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(function(_ref) {
    var children = _ref.children, testId = _ref.testId, inline = _ref.inline, block = _ref.block, all = _ref.all, xcss = _ref.xcss;
    var resolvedStyles = (0, $eHCkB.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)("div", {
        className: resolvedStyles.static,
        css: [
            $421830d671a3fab9$var$baseStyles,
            (inline || all) && $421830d671a3fab9$var$inlineBleedMap[inline || all],
            (block || all) && $421830d671a3fab9$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$421830d671a3fab9$var$Bleed.displayName = "Bleed";
var $421830d671a3fab9$export$2e2bcd8739ae039 = $421830d671a3fab9$var$Bleed;

});
parcelRegister("eHCkB", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $ab42d09dd3876178$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $ab42d09dd3876178$export$f6c783d06584602c; });

var $7i8I2 = parcelRequire("7i8I2");

var $lrtwL = parcelRequire("lrtwL");

var $cGZ0i = parcelRequire("cGZ0i");

var $1Ior6 = parcelRequire("1Ior6");

var $2ZUkg = parcelRequire("2ZUkg");

var $8Z1q3 = parcelRequire("8Z1q3");

var $XAEGR = parcelRequire("XAEGR");
function $ab42d09dd3876178$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $ab42d09dd3876178$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $ab42d09dd3876178$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ab42d09dd3876178$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ab42d09dd3876178$var$_arrayLikeToArray(o, minLen);
}
function $ab42d09dd3876178$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ab42d09dd3876178$export$9a199fbafee0014e = {
    backgroundColor: (0, $8Z1q3.backgroundColorMap),
    blockSize: (0, $8Z1q3.dimensionMap),
    borderBlockColor: (0, $8Z1q3.borderColorMap),
    borderBlockEndColor: (0, $8Z1q3.borderColorMap),
    borderBlockEndWidth: (0, $8Z1q3.borderWidthMap),
    borderBlockStartColor: (0, $8Z1q3.borderColorMap),
    borderBlockStartWidth: (0, $8Z1q3.borderWidthMap),
    borderBlockWidth: (0, $8Z1q3.borderWidthMap),
    borderBottomColor: (0, $8Z1q3.borderColorMap),
    borderBottomLeftRadius: (0, $8Z1q3.borderRadiusMap),
    borderBottomRightRadius: (0, $8Z1q3.borderRadiusMap),
    borderBottomWidth: (0, $8Z1q3.borderWidthMap),
    borderColor: (0, $8Z1q3.borderColorMap),
    borderEndEndRadius: (0, $8Z1q3.borderRadiusMap),
    borderEndStartRadius: (0, $8Z1q3.borderRadiusMap),
    borderInlineColor: (0, $8Z1q3.borderColorMap),
    borderInlineEndColor: (0, $8Z1q3.borderColorMap),
    borderInlineEndWidth: (0, $8Z1q3.borderWidthMap),
    borderInlineStartColor: (0, $8Z1q3.borderColorMap),
    borderInlineStartWidth: (0, $8Z1q3.borderWidthMap),
    borderInlineWidth: (0, $8Z1q3.borderWidthMap),
    borderLeftColor: (0, $8Z1q3.borderColorMap),
    borderLeftWidth: (0, $8Z1q3.borderWidthMap),
    borderRadius: (0, $8Z1q3.borderRadiusMap),
    borderRightColor: (0, $8Z1q3.borderColorMap),
    borderRightWidth: (0, $8Z1q3.borderWidthMap),
    borderStartEndRadius: (0, $8Z1q3.borderRadiusMap),
    borderStartStartRadius: (0, $8Z1q3.borderRadiusMap),
    borderTopColor: (0, $8Z1q3.borderColorMap),
    borderTopLeftRadius: (0, $8Z1q3.borderRadiusMap),
    borderTopRightRadius: (0, $8Z1q3.borderRadiusMap),
    borderTopWidth: (0, $8Z1q3.borderWidthMap),
    borderWidth: (0, $8Z1q3.borderWidthMap),
    bottom: (0, $8Z1q3.allSpaceMap),
    boxShadow: (0, $8Z1q3.shadowMap),
    color: (0, $8Z1q3.textColorMap),
    columnGap: (0, $8Z1q3.positiveSpaceMap),
    gap: (0, $8Z1q3.positiveSpaceMap),
    height: (0, $8Z1q3.dimensionMap),
    inlineSize: (0, $8Z1q3.dimensionMap),
    inset: (0, $8Z1q3.allSpaceMap),
    insetBlock: (0, $8Z1q3.allSpaceMap),
    insetBlockEnd: (0, $8Z1q3.allSpaceMap),
    insetBlockStart: (0, $8Z1q3.allSpaceMap),
    insetInline: (0, $8Z1q3.allSpaceMap),
    insetInlineEnd: (0, $8Z1q3.allSpaceMap),
    insetInlineStart: (0, $8Z1q3.allSpaceMap),
    left: (0, $8Z1q3.allSpaceMap),
    margin: (0, $8Z1q3.allSpaceMap),
    marginBlock: (0, $8Z1q3.allSpaceMap),
    marginBlockEnd: (0, $8Z1q3.allSpaceMap),
    marginBlockStart: (0, $8Z1q3.allSpaceMap),
    marginBottom: (0, $8Z1q3.allSpaceMap),
    marginInline: (0, $8Z1q3.allSpaceMap),
    marginInlineEnd: (0, $8Z1q3.allSpaceMap),
    marginInlineStart: (0, $8Z1q3.allSpaceMap),
    marginLeft: (0, $8Z1q3.allSpaceMap),
    marginRight: (0, $8Z1q3.allSpaceMap),
    marginTop: (0, $8Z1q3.allSpaceMap),
    maxBlockSize: (0, $8Z1q3.dimensionMap),
    maxHeight: (0, $8Z1q3.dimensionMap),
    maxInlineSize: (0, $8Z1q3.dimensionMap),
    maxWidth: (0, $8Z1q3.dimensionMap),
    minBlockSize: (0, $8Z1q3.dimensionMap),
    minHeight: (0, $8Z1q3.dimensionMap),
    minInlineSize: (0, $8Z1q3.dimensionMap),
    minWidth: (0, $8Z1q3.dimensionMap),
    opacity: (0, $8Z1q3.opacityMap),
    outlineColor: (0, $8Z1q3.borderColorMap),
    outlineOffset: (0, $8Z1q3.positiveSpaceMap),
    outlineWidth: (0, $8Z1q3.borderWidthMap),
    padding: (0, $8Z1q3.positiveSpaceMap),
    paddingBlock: (0, $8Z1q3.positiveSpaceMap),
    paddingBlockEnd: (0, $8Z1q3.positiveSpaceMap),
    paddingBlockStart: (0, $8Z1q3.positiveSpaceMap),
    paddingBottom: (0, $8Z1q3.positiveSpaceMap),
    paddingInline: (0, $8Z1q3.positiveSpaceMap),
    paddingInlineEnd: (0, $8Z1q3.positiveSpaceMap),
    paddingInlineStart: (0, $8Z1q3.positiveSpaceMap),
    paddingLeft: (0, $8Z1q3.positiveSpaceMap),
    paddingRight: (0, $8Z1q3.positiveSpaceMap),
    paddingTop: (0, $8Z1q3.positiveSpaceMap),
    right: (0, $8Z1q3.allSpaceMap),
    rowGap: (0, $8Z1q3.positiveSpaceMap),
    top: (0, $8Z1q3.allSpaceMap),
    width: (0, $8Z1q3.dimensionMap),
    zIndex: (0, $8Z1q3.layerMap)
};
var $ab42d09dd3876178$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $ab42d09dd3876178$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $XAEGR === "undefined" ? "undefined" : (0, $1Ior6.default)($XAEGR)) === "object" && (0, $1Ior6.default)($XAEGR.env) === "object" && false;
};
var $ab42d09dd3876178$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $ab42d09dd3876178$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $ab42d09dd3876178$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $1Ior6.default)(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $cGZ0i.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $1Ior6.default)(value) === "object" && $ab42d09dd3876178$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($ab42d09dd3876178$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($ab42d09dd3876178$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $ab42d09dd3876178$export$9a199fbafee0014e)) return;
        var tokenValue = $ab42d09dd3876178$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $ab42d09dd3876178$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $ab42d09dd3876178$var$transformStyles(style);
    return (0, $lrtwL.default)({}, $ab42d09dd3876178$var$uniqueSymbol, (0, $2ZUkg.css)(transformedStyles));
};
var $ab42d09dd3876178$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $ab42d09dd3876178$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $7i8I2.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$ab42d09dd3876178$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $ab42d09dd3876178$export$f6c783d06584602c(style) {
    return $ab42d09dd3876178$var$baseXcss(style);
}

});
parcelRegister("8Z1q3", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $68a51f0a442f3edf$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $68a51f0a442f3edf$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $68a51f0a442f3edf$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $68a51f0a442f3edf$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $68a51f0a442f3edf$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $68a51f0a442f3edf$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $68a51f0a442f3edf$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $68a51f0a442f3edf$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $68a51f0a442f3edf$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $68a51f0a442f3edf$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $68a51f0a442f3edf$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $68a51f0a442f3edf$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $68a51f0a442f3edf$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $68a51f0a442f3edf$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $68a51f0a442f3edf$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $68a51f0a442f3edf$export$5e65a44e5b6ecadb; });

var $lrtwL = parcelRequire("lrtwL");

var $2ZUkg = parcelRequire("2ZUkg");

var $iGLnR = parcelRequire("iGLnR");
function $68a51f0a442f3edf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68a51f0a442f3edf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68a51f0a442f3edf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68a51f0a442f3edf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68a51f0a442f3edf$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $68a51f0a442f3edf$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $68a51f0a442f3edf$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $68a51f0a442f3edf$export$632685d741f3dbbf = $68a51f0a442f3edf$var$_objectSpread($68a51f0a442f3edf$var$_objectSpread({}, $68a51f0a442f3edf$export$958d0ae7f2977ae4), $68a51f0a442f3edf$export$d2dc61f58390201c);
var $68a51f0a442f3edf$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $68a51f0a442f3edf$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $68a51f0a442f3edf$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $68a51f0a442f3edf$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $68a51f0a442f3edf$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $68a51f0a442f3edf$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $68a51f0a442f3edf$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $68a51f0a442f3edf$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $68a51f0a442f3edf$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $68a51f0a442f3edf$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $68a51f0a442f3edf$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $68a51f0a442f3edf$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $68a51f0a442f3edf$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $68a51f0a442f3edf$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $68a51f0a442f3edf$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $68a51f0a442f3edf$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $lrtwL.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $68a51f0a442f3edf$export$e615f061ca585a6c = $68a51f0a442f3edf$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $68a51f0a442f3edf$var$getSerializedStylesMap(spacingProperty, $68a51f0a442f3edf$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $68a51f0a442f3edf$export$bf46c3f9eeafc71f = $68a51f0a442f3edf$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $68a51f0a442f3edf$var$getSerializedStylesMap(spacingProperty, $68a51f0a442f3edf$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $68a51f0a442f3edf$export$e7af83bafe7f9e63 = $68a51f0a442f3edf$var$getSerializedStylesMap("backgroundColor", $68a51f0a442f3edf$export$d1d79bf68ac056bd);
var $68a51f0a442f3edf$export$3a1bcba60b23d7f0 = $68a51f0a442f3edf$var$getSerializedStylesMap("color", $68a51f0a442f3edf$export$8473307aa00d6ea1);
var $68a51f0a442f3edf$export$45f3f4fe16f9f7d5 = $68a51f0a442f3edf$var$getSerializedStylesMap("fontWeight", $68a51f0a442f3edf$export$303e322c6b1ed114);
var $68a51f0a442f3edf$export$68cc305da27dbaa4 = $68a51f0a442f3edf$var$getSerializedStylesMap("fontFamily", $68a51f0a442f3edf$export$3c7e9587132614b4);
var $68a51f0a442f3edf$export$128f10c238242f83 = $68a51f0a442f3edf$var$getSerializedStylesMap("font", $68a51f0a442f3edf$export$6cc560b4dedf3816);
var $68a51f0a442f3edf$export$ff257d957d48c421 = $68a51f0a442f3edf$var$getSerializedStylesMap((0, $iGLnR.CURRENT_SURFACE_CSS_VAR), $68a51f0a442f3edf$export$41a358c9c2356760);
var $68a51f0a442f3edf$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $68a51f0a442f3edf$export$41a358c9c2356760[color] !== undefined;
};

});



parcelRegister("kVgtN", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", function () { return $f3b5ea05d18564b9$export$ac16a6a04d9b7c84; });

var $djxp7 = parcelRequire("djxp7");

var $lrtwL = parcelRequire("lrtwL");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $7HgHi = parcelRequire("7HgHi");

var $iSjV6 = parcelRequire("iSjV6");

var $72HvB = parcelRequire("72HvB");

var $gNof7 = parcelRequire("gNof7");
var $f3b5ea05d18564b9$var$_excluded = [
    "children",
    "testId",
    "tooltip",
    "isSelected",
    "isHighlighted"
];
var $f3b5ea05d18564b9$var$VAR_BUTTON_SELECTED_COLOR = "--button-selected-color";
var $f3b5ea05d18564b9$var$VAR_BUTTON_SELECTED_BORDER_COLOR = "--button-selected-border-color";
var $f3b5ea05d18564b9$var$buttonBaseStyles = (0, $2ZUkg.css)({
    display: "flex",
    height: "100%",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});
var $f3b5ea05d18564b9$var$buttonHighlightedStyles = (0, $2ZUkg.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "&& > *": {
        color: "var(".concat($f3b5ea05d18564b9$var$VAR_BUTTON_SELECTED_COLOR, ")")
    },
    "&:after": {
        height: 3,
        position: "absolute",
        backgroundColor: "var(".concat($f3b5ea05d18564b9$var$VAR_BUTTON_SELECTED_BORDER_COLOR, ")"),
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
var $f3b5ea05d18564b9$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var _ref;
    var children = props.children, testId = props.testId, tooltip = props.tooltip, isSelected = props.isSelected, isHighlighted = props.isHighlighted, buttonProps = (0, $gmKOS.default)(props, $f3b5ea05d18564b9$var$_excluded);
    var theme = (0, $72HvB.useTheme)();
    var button = (0, $2ZUkg.jsx)("div", {
        style: (_ref = {}, (0, $lrtwL.default)(_ref, $f3b5ea05d18564b9$var$VAR_BUTTON_SELECTED_COLOR, theme.mode.primaryButton.selected.color), (0, $lrtwL.default)(_ref, $f3b5ea05d18564b9$var$VAR_BUTTON_SELECTED_BORDER_COLOR, theme.mode.primaryButton.selected.borderColor), _ref),
        css: [
            $f3b5ea05d18564b9$var$buttonBaseStyles,
            isHighlighted && $f3b5ea05d18564b9$var$buttonHighlightedStyles
        ],
        role: "listitem"
    }, (0, $2ZUkg.jsx)((0, $7HgHi.default), (0, $djxp7.default)({
        appearance: "primary",
        testId: testId,
        ref: ref,
        isSelected: isSelected,
        theme: (0, $gNof7.getPrimaryButtonTheme)(theme)
    }, buttonProps), children));
    if (tooltip) return (0, $2ZUkg.jsx)((0, $iSjV6.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});
var $f3b5ea05d18564b9$export$2e2bcd8739ae039 = $f3b5ea05d18564b9$export$ac16a6a04d9b7c84;

});
parcelRegister("gNof7", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", function () { return $c3a40718889c094a$export$14dd6915caf431fe; });

var $lrtwL = parcelRequire("lrtwL");
function $c3a40718889c094a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3a40718889c094a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3a40718889c094a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lrtwL.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3a40718889c094a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c3a40718889c094a$export$14dd6915caf431fe = function getPrimaryButtonTheme(_ref) {
    var primaryButton = _ref.mode.primaryButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $c3a40718889c094a$var$_objectSpread($c3a40718889c094a$var$_objectSpread($c3a40718889c094a$var$_objectSpread($c3a40718889c094a$var$_objectSpread({}, buttonStyles), primaryButton.default), props.isSelected && primaryButton.selected), {}, {
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: "0 ".concat("var(--ds-space-050, 4px)"),
                marginLeft: 0,
                marginRight: 0,
                ":hover": props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ":focus": primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                "&&": $c3a40718889c094a$var$_objectSpread({}, props.state === "active" && primaryButton.active)
            }),
            spinnerStyles: spinnerStyles
        };
    };
};

});




parcelRegister("kDh2w", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", function () { return $f054aadfa919460d$export$43e704064d596a9e; });

var $djxp7 = parcelRequire("djxp7");

var $cGZ0i = parcelRequire("cGZ0i");

var $lrtwL = parcelRequire("lrtwL");

var $iSvIT = parcelRequire("iSvIT");

var $eMtdo = parcelRequire("eMtdo");

var $ZUzSJ = parcelRequire("ZUzSJ");
var $6kYBN = parcelRequire("6kYBN");
var $eHCkB = parcelRequire("eHCkB");

var $id82p = parcelRequire("id82p");
var $cPf6V = parcelRequire("cPf6V");

var $8Pugw = parcelRequire("8Pugw");

var $5SzAI = parcelRequire("5SzAI");
var $f054aadfa919460d$var$_xcss2;
var $f054aadfa919460d$var$containerWrapperStyles = (0, $eHCkB.xcss)({
    height: "100%"
});
var $f054aadfa919460d$var$sharedContainerStyles = (0, $eHCkB.xcss)({
    height: "100%",
    alignItems: "stretch",
    paddingInlineEnd: "space.050",
    gap: "space.100"
});
var $f054aadfa919460d$var$smallContainerStyles = (0, $eHCkB.xcss)((0, $lrtwL.default)({}, (0, $id82p.media).above.sm, {
    display: "none"
}));
var $f054aadfa919460d$var$mediumContainerStyles = (0, $eHCkB.xcss)(($f054aadfa919460d$var$_xcss2 = {
    display: "none"
}, (0, $lrtwL.default)($f054aadfa919460d$var$_xcss2, (0, $id82p.media).above.sm, {
    display: "flex"
}), (0, $lrtwL.default)($f054aadfa919460d$var$_xcss2, (0, $id82p.media).above.lg, {
    display: "none"
}), $f054aadfa919460d$var$_xcss2));
var $f054aadfa919460d$var$largeContainerStyles = (0, $eHCkB.xcss)((0, $lrtwL.default)({
    display: "none"
}, (0, $id82p.media).above.lg, {
    display: "flex"
}));
var $f054aadfa919460d$var$overflowItemsStyles = (0, $eHCkB.xcss)({
    color: "color.text"
});
var $f054aadfa919460d$var$MoreItemsPopup = function MoreItemsPopup(_ref) {
    var moreLabel = _ref.moreLabel, testId = _ref.testId, items = _ref.items;
    var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $cGZ0i.default)(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var onMoreClose = (0, $iSvIT.useCallback)(function() {
        return setIsMoreOpen(false);
    }, []);
    var onMoreClick = (0, $iSvIT.useCallback)(function() {
        return setIsMoreOpen(function(current) {
            return !current;
        });
    }, []);
    var openOverflowMenu = (0, $iSvIT.useCallback)(function() {
        return setIsMoreOpen(true);
    }, []);
    var trigger = (0, $iSvIT.useCallback)(function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5SzAI.PrimaryDropdownButton), (0, $djxp7.default)({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : "overflow-menu-trigger"
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $iSvIT.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8Pugw.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ZUzSJ.default), {
            xcss: $f054aadfa919460d$var$overflowItemsStyles
        }, items));
    }, [
        items,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eMtdo.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        content: content,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : "overflow-menu-popup"
    });
};
var $f054aadfa919460d$export$43e704064d596a9e = /*#__PURE__*/ (0, $iSvIT.memo)(function(_ref2) {
    var moreLabel = _ref2.moreLabel, items = _ref2.items, Create = _ref2.create, theme = _ref2.theme, testId = _ref2.testId;
    // We render a CSS media query based nav at first to handle SSR, then use
    // our useMediaQuery hook once we are hydrated so there is only one set of nav items
    var _useState3 = (0, $iSvIT.useState)(false), _useState4 = (0, $cGZ0i.default)(_useState3, 2), isClient = _useState4[0], setIsClient = _useState4[1];
    (0, $iSvIT.useEffect)(function() {
        setIsClient(true);
    }, []);
    // Setting up our media queries to use once app is hydrated
    var mqSm = (0, $cPf6V.UNSAFE_useMediaQuery)("above.sm", function(event) {
        return setIsAboveSm(event.matches);
    });
    var _useState5 = (0, $iSvIT.useState)(mqSm === null || mqSm === void 0 ? void 0 : mqSm.matches), _useState6 = (0, $cGZ0i.default)(_useState5, 2), isAboveSm = _useState6[0], setIsAboveSm = _useState6[1];
    var mqLg = (0, $cPf6V.UNSAFE_useMediaQuery)("above.lg", function(event) {
        return setIsAboveLg(event.matches);
    });
    var _useState7 = (0, $iSvIT.useState)(mqLg === null || mqLg === void 0 ? void 0 : mqLg.matches), _useState8 = (0, $cGZ0i.default)(_useState7, 2), isAboveLg = _useState8[0], setIsAboveLg = _useState8[1];
    // Filter out any falsy items passed in
    var filteredItems = (0, $iSvIT.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.toArray(items).filter(function(item) {
            return !!item;
        });
    }, [
        items
    ]);
    // NOTE: we could make these max items configurable in the future. For now
    // we are using sensible defaults. Anything over the max gets put in the
    // overflow menu for that screen size.
    // While it may be tempting to use more than 3 items for the medium nav when
    // you see the available space, you need to consider internationalistion.
    // 3 is the safe, defensive choice across many languages and scripts.
    var smallMaxItems = 0;
    var mediumMaxItems = 3;
    var largeMaxItems = 8;
    // We re-use this in both the CSS media query nav that loads in for SSR,
    // and the JS/hook media query nav that is used once hydrated
    var navItems = (0, $iSvIT.useMemo)(function() {
        return {
            small: {
                navBarItems: [],
                overflowItems: filteredItems
            },
            medium: {
                navBarItems: filteredItems.slice(0, mediumMaxItems),
                overflowItems: filteredItems.slice(mediumMaxItems, filteredItems.length)
            },
            large: {
                navBarItems: filteredItems.slice(0, largeMaxItems),
                overflowItems: filteredItems.slice(largeMaxItems, filteredItems.length)
            }
        };
    }, [
        filteredItems
    ]);
    var hydratedNavItems = (0, $iSvIT.useMemo)(function() {
        if (isAboveLg) return navItems.large;
        if (isAboveSm && !isAboveLg) return navItems.medium;
        return navItems.small;
    }, [
        isAboveLg,
        isAboveSm,
        navItems.large,
        navItems.medium,
        navItems.small
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, isClient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ZUzSJ.default), {
        role: "list",
        xcss: $f054aadfa919460d$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6kYBN.default), {
        testId: testId && "".concat(testId, "-primary-actions"),
        xcss: $f054aadfa919460d$var$sharedContainerStyles
    }, hydratedNavItems.navBarItems, hydratedNavItems.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f054aadfa919460d$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        items: hydratedNavItems.overflowItems,
        testId: testId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $ZUzSJ.default), {
        role: "list",
        xcss: $f054aadfa919460d$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6kYBN.default), {
        xcss: [
            $f054aadfa919460d$var$sharedContainerStyles,
            $f054aadfa919460d$var$smallContainerStyles
        ]
    }, filteredItems.length > smallMaxItems && /*#__PURE__*/ // We don't need to pass items into popup, it won't be interactive (SSR only)
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f054aadfa919460d$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6kYBN.default), {
        xcss: [
            $f054aadfa919460d$var$sharedContainerStyles,
            $f054aadfa919460d$var$mediumContainerStyles
        ]
    }, navItems.medium.navBarItems, navItems.medium.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f054aadfa919460d$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $6kYBN.default), {
        xcss: [
            $f054aadfa919460d$var$sharedContainerStyles,
            $f054aadfa919460d$var$largeContainerStyles
        ]
    }, navItems.large.navBarItems, navItems.large.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($f054aadfa919460d$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    }))), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Create, null));
});

});
parcelRegister("ZUzSJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ba195c7b8877c04$export$2e2bcd8739ae039; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $8Z1q3 = parcelRequire("8Z1q3");

var $eHCkB = parcelRequire("eHCkB");

var $lp3dh = parcelRequire("lp3dh");
var $0ba195c7b8877c04$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $0ba195c7b8877c04$var$_excluded2 = [
    "className"
];
var $0ba195c7b8877c04$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $gmKOS.default)(_ref, $0ba195c7b8877c04$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $gmKOS.default)(htmlAttributes, $0ba195c7b8877c04$var$_excluded2);
    var resolvedStyles = (0, $eHCkB.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $2ZUkg.jsx)(Component, (0, $djxp7.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $0ba195c7b8877c04$var$baseStyles,
            backgroundColor && (0, $8Z1q3.backgroundColorStylesMap)[backgroundColor],
            (0, $8Z1q3.isSurfaceColorToken)(backgroundColor) && (0, $8Z1q3.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $8Z1q3.paddingStylesMap).padding[padding],
            paddingBlock && (0, $8Z1q3.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $8Z1q3.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $8Z1q3.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $8Z1q3.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $8Z1q3.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $8Z1q3.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $2ZUkg.jsx)((0, $lp3dh.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $0ba195c7b8877c04$export$2e2bcd8739ae039 = $0ba195c7b8877c04$export$e71c4d32a2263218;
var $0ba195c7b8877c04$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("lp3dh", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $f94e6cd411c5b539$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $f94e6cd411c5b539$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $f94e6cd411c5b539$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($f94e6cd411c5b539$export$1ca2a26fecb070ae);
};
$f94e6cd411c5b539$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("6kYBN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49d39feffbb5c40e$export$2e2bcd8739ae039; });

var $7i8I2 = parcelRequire("7i8I2");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $eHCkB = parcelRequire("eHCkB");

var $3sj1F = parcelRequire("3sj1F");
var $49d39feffbb5c40e$var$flexGrowMap = {
    hug: (0, $eHCkB.xcss)({
        flexGrow: 0
    }),
    fill: (0, $eHCkB.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $49d39feffbb5c40e$var$separatorStyles = (0, $2ZUkg.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $49d39feffbb5c40e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $49d39feffbb5c40e$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $49d39feffbb5c40e$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $2ZUkg.jsx)($49d39feffbb5c40e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $49d39feffbb5c40e$var$flexGrowMap[grow]
    ].concat((0, $7i8I2.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $2ZUkg.jsx)((0, $3sj1F.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$49d39feffbb5c40e$var$Inline.displayName = "Inline";
var $49d39feffbb5c40e$export$2e2bcd8739ae039 = $49d39feffbb5c40e$var$Inline;

});
parcelRegister("3sj1F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2842bebecc8c4c6b$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $8Z1q3 = parcelRequire("8Z1q3");

var $eHCkB = parcelRequire("eHCkB");
var $2842bebecc8c4c6b$var$justifyContentMap = {
    start: (0, $2ZUkg.css)({
        justifyContent: "start"
    }),
    center: (0, $2ZUkg.css)({
        justifyContent: "center"
    }),
    end: (0, $2ZUkg.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $2ZUkg.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $2ZUkg.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $2ZUkg.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $2ZUkg.css)({
        justifyContent: "stretch"
    })
};
var $2842bebecc8c4c6b$var$flexDirectionMap = {
    column: (0, $2ZUkg.css)({
        flexDirection: "column"
    }),
    row: (0, $2ZUkg.css)({
        flexDirection: "row"
    })
};
var $2842bebecc8c4c6b$var$flexWrapMap = {
    wrap: (0, $2ZUkg.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $2ZUkg.css)({
        flexWrap: "nowrap"
    })
};
var $2842bebecc8c4c6b$var$alignItemsMap = {
    start: (0, $2ZUkg.css)({
        alignItems: "start"
    }),
    center: (0, $2ZUkg.css)({
        alignItems: "center"
    }),
    baseline: (0, $2ZUkg.css)({
        alignItems: "baseline"
    }),
    end: (0, $2ZUkg.css)({
        alignItems: "end"
    }),
    stretch: (0, $2ZUkg.css)({
        alignItems: "stretch"
    })
};
var $2842bebecc8c4c6b$var$baseStyles = (0, $2ZUkg.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $2842bebecc8c4c6b$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $eHCkB.parseXcss)(xcss);
    return (0, $2ZUkg.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $2842bebecc8c4c6b$var$baseStyles,
            gap && (0, $8Z1q3.spaceStylesMap).gap[gap],
            columnGap && (0, $8Z1q3.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $8Z1q3.spaceStylesMap).rowGap[rowGap],
            alignItems && $2842bebecc8c4c6b$var$alignItemsMap[alignItems],
            direction && $2842bebecc8c4c6b$var$flexDirectionMap[direction],
            justifyContent && $2842bebecc8c4c6b$var$justifyContentMap[justifyContent],
            wrap && $2842bebecc8c4c6b$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$2842bebecc8c4c6b$var$Flex.displayName = "Flex";
var $2842bebecc8c4c6b$export$2e2bcd8739ae039 = $2842bebecc8c4c6b$var$Flex;

});


parcelRegister("id82p", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $d41fad0c544294c9$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "UNSAFE_media", function () { return $d41fad0c544294c9$export$c881183ca713c214; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $d41fad0c544294c9$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 109.99rem)",
        xl: "@media (min-width: 110rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110rem)"
    }
};
var $d41fad0c544294c9$export$c881183ca713c214 = $d41fad0c544294c9$export$987d49ffe1b0900f;

});

parcelRegister("cPf6V", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $9565f825b6cad33b$export$49e55ae2c03d6045; });

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $id82p = parcelRequire("id82p");
var $9565f825b6cad33b$var$_window, $9565f825b6cad33b$var$_window$matchMedia, $9565f825b6cad33b$var$_window2, $9565f825b6cad33b$var$_window2$matchMedia, $9565f825b6cad33b$var$_window3, $9565f825b6cad33b$var$_window3$matchMedia, $9565f825b6cad33b$var$_window4, $9565f825b6cad33b$var$_window4$matchMedia, $9565f825b6cad33b$var$_window5, $9565f825b6cad33b$var$_window5$matchMedia, $9565f825b6cad33b$var$_window6, $9565f825b6cad33b$var$_window6$matchMedia, $9565f825b6cad33b$var$_window7, $9565f825b6cad33b$var$_window7$matchMedia, $9565f825b6cad33b$var$_window8, $9565f825b6cad33b$var$_window8$matchMedia, $9565f825b6cad33b$var$_window9, $9565f825b6cad33b$var$_window9$matchMedia, $9565f825b6cad33b$var$_window10, $9565f825b6cad33b$var$_window10$matchMedia, $9565f825b6cad33b$var$_window11, $9565f825b6cad33b$var$_window11$matchMedia;
var $9565f825b6cad33b$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window = window) === null || $9565f825b6cad33b$var$_window === void 0 || ($9565f825b6cad33b$var$_window$matchMedia = $9565f825b6cad33b$var$_window.matchMedia) === null || $9565f825b6cad33b$var$_window$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window$matchMedia.call($9565f825b6cad33b$var$_window, (0, $id82p.UNSAFE_media).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window2 = window) === null || $9565f825b6cad33b$var$_window2 === void 0 || ($9565f825b6cad33b$var$_window2$matchMedia = $9565f825b6cad33b$var$_window2.matchMedia) === null || $9565f825b6cad33b$var$_window2$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window2$matchMedia.call($9565f825b6cad33b$var$_window2, (0, $id82p.UNSAFE_media).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window3 = window) === null || $9565f825b6cad33b$var$_window3 === void 0 || ($9565f825b6cad33b$var$_window3$matchMedia = $9565f825b6cad33b$var$_window3.matchMedia) === null || $9565f825b6cad33b$var$_window3$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window3$matchMedia.call($9565f825b6cad33b$var$_window3, (0, $id82p.UNSAFE_media).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window4 = window) === null || $9565f825b6cad33b$var$_window4 === void 0 || ($9565f825b6cad33b$var$_window4$matchMedia = $9565f825b6cad33b$var$_window4.matchMedia) === null || $9565f825b6cad33b$var$_window4$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window4$matchMedia.call($9565f825b6cad33b$var$_window4, (0, $id82p.UNSAFE_media).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window5 = window) === null || $9565f825b6cad33b$var$_window5 === void 0 || ($9565f825b6cad33b$var$_window5$matchMedia = $9565f825b6cad33b$var$_window5.matchMedia) === null || $9565f825b6cad33b$var$_window5$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window5$matchMedia.call($9565f825b6cad33b$var$_window5, (0, $id82p.UNSAFE_media).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window6 = window) === null || $9565f825b6cad33b$var$_window6 === void 0 || ($9565f825b6cad33b$var$_window6$matchMedia = $9565f825b6cad33b$var$_window6.matchMedia) === null || $9565f825b6cad33b$var$_window6$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window6$matchMedia.call($9565f825b6cad33b$var$_window6, (0, $id82p.UNSAFE_media).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window7 = window) === null || $9565f825b6cad33b$var$_window7 === void 0 || ($9565f825b6cad33b$var$_window7$matchMedia = $9565f825b6cad33b$var$_window7.matchMedia) === null || $9565f825b6cad33b$var$_window7$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window7$matchMedia.call($9565f825b6cad33b$var$_window7, (0, $id82p.UNSAFE_media).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window8 = window) === null || $9565f825b6cad33b$var$_window8 === void 0 || ($9565f825b6cad33b$var$_window8$matchMedia = $9565f825b6cad33b$var$_window8.matchMedia) === null || $9565f825b6cad33b$var$_window8$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window8$matchMedia.call($9565f825b6cad33b$var$_window8, (0, $id82p.UNSAFE_media).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window9 = window) === null || $9565f825b6cad33b$var$_window9 === void 0 || ($9565f825b6cad33b$var$_window9$matchMedia = $9565f825b6cad33b$var$_window9.matchMedia) === null || $9565f825b6cad33b$var$_window9$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window9$matchMedia.call($9565f825b6cad33b$var$_window9, (0, $id82p.UNSAFE_media).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window10 = window) === null || $9565f825b6cad33b$var$_window10 === void 0 || ($9565f825b6cad33b$var$_window10$matchMedia = $9565f825b6cad33b$var$_window10.matchMedia) === null || $9565f825b6cad33b$var$_window10$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window10$matchMedia.call($9565f825b6cad33b$var$_window10, (0, $id82p.UNSAFE_media).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($9565f825b6cad33b$var$_window11 = window) === null || $9565f825b6cad33b$var$_window11 === void 0 || ($9565f825b6cad33b$var$_window11$matchMedia = $9565f825b6cad33b$var$_window11.matchMedia) === null || $9565f825b6cad33b$var$_window11$matchMedia === void 0 ? void 0 : $9565f825b6cad33b$var$_window11$matchMedia.call($9565f825b6cad33b$var$_window11, (0, $id82p.UNSAFE_media).below.xl.replace("@media ", "").trim())
};
var $9565f825b6cad33b$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $iSvIT.useRef)(listener);
    (0, $iSvIT.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $9565f825b6cad33b$var$queries[queryString];
    (0, $iSvIT.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $2e1kT.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});



parcelRegister("3BXVF", function(module, exports) {

$parcel$export(module.exports, "Help", function () { return $2a13507b11193b1d$export$1be7516c0280bee8; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $6mQDG = parcelRequire("6mQDG");

var $72HvB = parcelRequire("72HvB");

var $8HxaM = parcelRequire("8HxaM");

var $2okzL = parcelRequire("2okzL");
var $2a13507b11193b1d$var$_excluded = [
    "badge",
    "tooltip"
];
var $2a13507b11193b1d$var$HELP_NOTIFICATION_BADGE_ID = "atlassian-navigation-help-notification-count";
var $2a13507b11193b1d$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var badge = props.badge, tooltip = props.tooltip, iconButtonProps = (0, $gmKOS.default)(props, $2a13507b11193b1d$var$_excluded);
    var _useTheme = (0, $72HvB.useTheme)(), navigation = _useTheme.mode.navigation;
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6mQDG))), {
            label: typeof tooltip === "string" ? tooltip : "Help Icon",
            secondaryColor: navigation.backgroundColor
        }),
        ref: ref,
        tooltip: tooltip
    }, iconButtonProps));
    return badge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8HxaM.BadgeContainer), {
        id: $2a13507b11193b1d$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        role: "listitem"
    }, button);
});
var $2a13507b11193b1d$export$2e2bcd8739ae039 = $2a13507b11193b1d$export$1be7516c0280bee8;

});
parcelRegister("6mQDG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a2da127aa66cbb3$var$_react = $4a2da127aa66cbb3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $4a2da127aa66cbb3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4a2da127aa66cbb3$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $4a2da127aa66cbb3$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="18" r="1"/><path d="M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05" fill="inherit"/></g></svg>`
    }, props));
$4a2da127aa66cbb3$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $4a2da127aa66cbb3$var$_default = $4a2da127aa66cbb3$var$QuestionCircleIcon;
module.exports.default = $4a2da127aa66cbb3$var$_default;

});

parcelRegister("8HxaM", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", function () { return $655c12581db550f9$export$f710265eb5a003da; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");
var $655c12581db550f9$var$badgeContainerStyles = (0, $2ZUkg.css)({
    position: "absolute",
    insetBlockStart: "var(--ds-space-negative-050, -4px)",
    insetInlineEnd: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none"
});
var $655c12581db550f9$var$containerStyles = (0, $2ZUkg.css)({
    position: "relative"
});
var $655c12581db550f9$export$f710265eb5a003da = function BadgeContainer(props) {
    var badgeId = props.id, Badge = props.badge, children = props.children, role = props.role;
    return (0, $2ZUkg.jsx)("div", {
        css: $655c12581db550f9$var$containerStyles,
        role: role
    }, children, (0, $2ZUkg.jsx)("div", {
        css: $655c12581db550f9$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, (0, $2ZUkg.jsx)(Badge, null)));
};

});


parcelRegister("8jNT4", function(module, exports) {

$parcel$export(module.exports, "Notifications", function () { return $60e6cb9ef3722a68$export$36ba2f559d49a8f6; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $elPvH = parcelRequire("elPvH");

var $8HxaM = parcelRequire("8HxaM");

var $2okzL = parcelRequire("2okzL");
var $60e6cb9ef3722a68$var$_excluded = [
    "badge",
    "tooltip"
];
var $60e6cb9ef3722a68$var$NOTIFICATIONS_BADGE_ID = "atlassian-navigation-notification-count";
var $60e6cb9ef3722a68$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var badge = props.badge, tooltip = props.tooltip, iconButtonProps = (0, $gmKOS.default)(props, $60e6cb9ef3722a68$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $8HxaM.BadgeContainer), {
        id: $60e6cb9ef3722a68$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($elPvH))), {
            label: typeof tooltip === "string" ? tooltip : "Notification Icon"
        }),
        tooltip: tooltip,
        ref: ref,
        "aria-describedby": $60e6cb9ef3722a68$var$NOTIFICATIONS_BADGE_ID
    }, iconButtonProps)));
});
var $60e6cb9ef3722a68$export$2e2bcd8739ae039 = $60e6cb9ef3722a68$export$36ba2f559d49a8f6;

});
parcelRegister("elPvH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a72afbbec612fc81$var$_react = $a72afbbec612fc81$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $a72afbbec612fc81$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a72afbbec612fc81$var$NotificationIcon = (props)=>/*#__PURE__*/ $a72afbbec612fc81$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.485 17.669a2 2 0 002.829 0l-2.829-2.83a2 2 0 000 2.83zm4.897-12.191l-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.048 5.048 0 00.64-6.356 1.01 1.01 0 10-1.354-1.494c-.023.025-.046.049-.066.075a5.043 5.043 0 00-2.788-.84 5.036 5.036 0 00-3.57 1.478z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$a72afbbec612fc81$var$NotificationIcon.displayName = "NotificationIcon";
var $a72afbbec612fc81$var$_default = $a72afbbec612fc81$var$NotificationIcon;
module.exports.default = $a72afbbec612fc81$var$_default;

});


parcelRegister("eLIbZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac07bc24ba35394b$export$2e2bcd8739ae039; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $lrtwL = parcelRequire("lrtwL");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $8QF8A = parcelRequire("8QF8A");

var $9sI6P = parcelRequire("9sI6P");

var $72HvB = parcelRequire("72HvB");

var $iXrU4 = parcelRequire("iXrU4");
var $ac07bc24ba35394b$var$_excluded = [
    "icon",
    "logo",
    "siteTitle",
    "onClick",
    "href",
    "onMouseDown",
    "testId",
    "logoMaxWidth"
];
var $ac07bc24ba35394b$var$_css;
var $ac07bc24ba35394b$var$VAR_LOGO_MAX_WIDTH = "--logo-max-width";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = "--product-home-color-active";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = "--product-home-bg-color-active";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = "--product-home-box-shadow-active";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_FOCUS = "--product-home-color-focus";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = "--product-home-bg-color-focus";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = "--product-home-box-shadow-focus";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_HOVER = "--product-home-color-hover";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = "--product-home-bg-color-hover";
var $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = "--product-home-box-shadow-hover";
var $ac07bc24ba35394b$var$productHomeButtonStyles = (0, $2ZUkg.css)(($ac07bc24ba35394b$var$_css = {
    display: "flex",
    padding: "var(--ds-space-050, 4px)",
    alignItems: "center",
    background: "none",
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: "inherit",
    cursor: "pointer",
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:first-of-type": {
        marginLeft: 0
    },
    "&:hover": {
        backgroundColor: "var(".concat($ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, ")"),
        boxShadow: "var(".concat($ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, ")"),
        color: "var(".concat($ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_HOVER, ")")
    },
    "&:active": {
        backgroundColor: "var(".concat($ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, ")"),
        boxShadow: "var(".concat($ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, ")"),
        color: "var(".concat($ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, ")")
    },
    "&:focus-visible": {
        backgroundColor: "var(".concat($ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, ")"),
        color: "var(".concat($ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_FOCUS, ")"),
        outline: "var(--ds-border-width-outline, 2px)".concat(" solid ", "var(--ds-border-focused, #4C9AFF)")
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "div&": {
        pointerEvents: "none"
    }
}, (0, $lrtwL.default)($ac07bc24ba35394b$var$_css, "@media (max-width: ".concat((0, $9sI6P.PRODUCT_HOME_BREAKPOINT) - 0.1, "px)"), {
    margin: "0 ".concat("var(--ds-space-100, 8px)")
}), (0, $lrtwL.default)($ac07bc24ba35394b$var$_css, "@media (min-width: ".concat((0, $9sI6P.PRODUCT_HOME_BREAKPOINT), "px)"), {
    margin: "0 ".concat("var(--ds-space-200, 16px)")
}), $ac07bc24ba35394b$var$_css));
var $ac07bc24ba35394b$var$productLogoStyles = (0, $2ZUkg.css)((0, $lrtwL.default)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: "flex",
    maxWidth: "var(".concat($ac07bc24ba35394b$var$VAR_LOGO_MAX_WIDTH, ")"),
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > span > svg": {
        maxWidth: "var(".concat($ac07bc24ba35394b$var$VAR_LOGO_MAX_WIDTH, ")")
    }
}, "@media (max-width: ".concat((0, $9sI6P.PRODUCT_HOME_BREAKPOINT) - 0.1, "px)"), {
    display: "none"
}));
var $ac07bc24ba35394b$var$customMaxHeightStyles = (0, $2ZUkg.css)({
    maxHeight: 28
});
var $ac07bc24ba35394b$var$productIconStyles = (0, $2ZUkg.css)((0, $lrtwL.default)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: "flex",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        maxHeight: 24
    }
}, "@media (min-width: ".concat((0, $9sI6P.PRODUCT_HOME_BREAKPOINT), "px)"), {
    display: "none"
}));
var $ac07bc24ba35394b$var$siteTitleStyles = (0, $2ZUkg.css)({
    display: "flex",
    // Overridden in PFF styles applied below; consolidate in FF cleanup
    marginRight: "var(--ds-space-050, 4px)",
    marginLeft: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-200, 16px)",
    alignItems: "center"
});
// When cleaning up feature flag, these styles can be moved into the above block
var $ac07bc24ba35394b$var$featureFlaggedSiteTitleStyles = (0, $2ZUkg.css)((0, $lrtwL.default)({
    // Under the FF, we've made the site title handle it's spacing, with the
    // PrimaryItemsContainer not needing to worry about its paddingInlineStart.
    // This makes it cleaner for the title styles to appear and disappear with mq's
    marginRight: "var(--ds-space-100, 8px)"
}, "@media (max-width: ".concat((0, $9sI6P.PRODUCT_HOME_BREAKPOINT) - 0.1, "px)"), {
    display: "none"
}));
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ var $ac07bc24ba35394b$var$ProductHome = function ProductHome(_ref) {
    var _productHomeButtonDyn;
    var Icon = _ref.icon, Logo = _ref.logo, siteTitle = _ref.siteTitle, onClick = _ref.onClick, href = _ref.href, onMouseDown = _ref.onMouseDown, testId = _ref.testId, _ref$logoMaxWidth = _ref.logoMaxWidth, logoMaxWidth = _ref$logoMaxWidth === void 0 ? 260 : _ref$logoMaxWidth, rest = (0, $gmKOS.default)(_ref, $ac07bc24ba35394b$var$_excluded);
    var theme = (0, $72HvB.useTheme)();
    var primaryButton = theme.mode.primaryButton;
    var _theme$mode$productHo = theme.mode.productHome, _theme$mode$productHo2 = _theme$mode$productHo.iconColor, iconColor = _theme$mode$productHo2 === void 0 ? "inherit" : _theme$mode$productHo2, _theme$mode$productHo3 = _theme$mode$productHo.iconGradientStart, iconGradientStart = _theme$mode$productHo3 === void 0 ? "inherit" : _theme$mode$productHo3, _theme$mode$productHo4 = _theme$mode$productHo.iconGradientStop, iconGradientStop = _theme$mode$productHo4 === void 0 ? "inherit" : _theme$mode$productHo4, _theme$mode$productHo5 = _theme$mode$productHo.textColor, textColor = _theme$mode$productHo5 === void 0 ? theme.mode.productHome.color : _theme$mode$productHo5;
    var Tag = (0, $iXrU4.getTag)(onClick, href);
    var preventFocusRing = function preventFocusRing(e) {
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    var productHomeButtonDynamicStyles = (_productHomeButtonDyn = {}, (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, primaryButton.active.color), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, primaryButton.active.backgroundColor), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, primaryButton.active.boxShadow), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_FOCUS, primaryButton.focus.color), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, primaryButton.focus.backgroundColor), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS, primaryButton.focus.boxShadow), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_COLOR_HOVER, primaryButton.hover.color), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, primaryButton.hover.backgroundColor), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, primaryButton.hover.boxShadow), (0, $lrtwL.default)(_productHomeButtonDyn, $ac07bc24ba35394b$var$VAR_LOGO_MAX_WIDTH, "".concat(logoMaxWidth, "px")), _productHomeButtonDyn);
    return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)(Tag, (0, $djxp7.default)({
        style: productHomeButtonDynamicStyles,
        css: $ac07bc24ba35394b$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && "".concat(testId, "-container")
    }, rest), (0, $2ZUkg.jsx)("div", {
        css: [
            $ac07bc24ba35394b$var$customMaxHeightStyles,
            $ac07bc24ba35394b$var$productLogoStyles
        ],
        "data-testid": testId && "".concat(testId, "-logo")
    }, (0, $2ZUkg.jsx)(Logo, {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    })), (0, $2ZUkg.jsx)("div", {
        css: [
            $ac07bc24ba35394b$var$customMaxHeightStyles,
            $ac07bc24ba35394b$var$productIconStyles
        ],
        "data-testid": testId && "".concat(testId, "-icon")
    }, (0, $2ZUkg.jsx)(Icon, {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    }))), siteTitle && (0, $2ZUkg.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $ac07bc24ba35394b$var$siteTitleStyles,
            (0, $8QF8A.getBooleanFF)("platform.design-system-team.navigation-v2-no-jank_5yhbd") && $ac07bc24ba35394b$var$featureFlaggedSiteTitleStyles
        ],
        "data-testid": testId && "".concat(testId, "-site-title")
    }, siteTitle));
};
var $ac07bc24ba35394b$export$2e2bcd8739ae039 = $ac07bc24ba35394b$var$ProductHome;

});
parcelRegister("iXrU4", function(module, exports) {

$parcel$export(module.exports, "getTag", function () { return $dcd361b1c98d132e$export$dad497fe1f6e27c0; });
var $dcd361b1c98d132e$export$dad497fe1f6e27c0 = function getTag(onClick, href) {
    if (href) return "a";
    if (onClick) return "button";
    return "div";
};

});


parcelRegister("7IMRw", function(module, exports) {

$parcel$export(module.exports, "Profile", function () { return $59f28b7fe63d0d8d$export$5120f2d0b8d4cab8; });

var $djxp7 = parcelRequire("djxp7");

var $iSvIT = parcelRequire("iSvIT");

var $2okzL = parcelRequire("2okzL");
var $59f28b7fe63d0d8d$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var labelProp = props.label, tooltip = props.tooltip;
    var label = labelProp || (typeof tooltip === "string" ? tooltip : "Your profile and settings");
    // All other implementations of IconButton within the components are using spread props, so
    // to use explicit props could cause regressions.
    // TODO: Remove these spread props for better static analysis
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        label: label,
        ref: ref
    }, props)));
});
var // This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop
$59f28b7fe63d0d8d$export$2e2bcd8739ae039 = function(props) {};

});

parcelRegister("60YlP", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $46118ea46a2e1af5$export$4b85d3515bd863a5; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $lrtwL = parcelRequire("lrtwL");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $g1gzF = parcelRequire("g1gzF");

var $9sI6P = parcelRequire("9sI6P");

var $72HvB = parcelRequire("72HvB");

var $2okzL = parcelRequire("2okzL");
var $46118ea46a2e1af5$var$_excluded = [
    "placeholder",
    "tooltip",
    "label",
    "value"
];
var $46118ea46a2e1af5$var$searchInputContainerStyles = (0, $2ZUkg.css)((0, $lrtwL.default)({
    position: "relative",
    marginInlineEnd: "var(--ds-space-100, 8px)",
    marginInlineStart: "var(--ds-space-250, 20px)"
}, "@media (max-width: ".concat((0, $9sI6P.CREATE_BREAKPOINT) - 1, "px)"), {
    display: "none !important"
}));
var $46118ea46a2e1af5$var$searchInputIconStyles = (0, $2ZUkg.css)({
    width: "20px",
    height: "20px",
    position: "absolute",
    insetBlockStart: "5px",
    insetInlineStart: "10px",
    pointerEvents: "none"
});
var $46118ea46a2e1af5$var$newSearchBorderStyles = (0, $2ZUkg.css)({
    border: "var(--ds-border-width, 1px)".concat(" solid"),
    "&:focus": {
        boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " var(", (0, $9sI6P.varSearchFocusBorderColor), ")")
    }
});
var $46118ea46a2e1af5$var$searchInputStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    width: "220px",
    height: "var(--ds-space-400, 32px)",
    padding: "0 ".concat("var(--ds-space-100, 8px)", " 0 ", "var(--ds-space-500, 40px)"),
    backgroundColor: "var(".concat((0, $9sI6P.varSearchBackgroundColor), ")"),
    border: "2px solid",
    borderColor: "var(".concat((0, $9sI6P.varSearchBorderColor), ")"),
    borderRadius: "var(--ds-border-radius-200, 6px)",
    color: "var(".concat((0, $9sI6P.varSearchColor), ")"),
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    outline: "none",
    "::placeholder": {
        color: "inherit"
    },
    "&:focus": {
        borderColor: "var(".concat((0, $9sI6P.varSearchFocusBorderColor), ")")
    },
    "&:hover": {
        backgroundColor: "var(".concat((0, $9sI6P.varSearchHoverBackgroundColor), ")")
    }
});
var $46118ea46a2e1af5$var$searchIconStyles = (0, $2ZUkg.css)((0, $lrtwL.default)({}, "@media (min-width: ".concat((0, $9sI6P.CREATE_BREAKPOINT), "px)"), {
    display: "none !important"
}));
var $46118ea46a2e1af5$var$SearchComponent = function SearchComponent(props) {
    var _searchInputDynamicSt;
    var onClick = props.onClick, placeholder = props.placeholder, label = props.label, value = props.value;
    var theme = (0, $72HvB.useTheme)();
    var search = theme.mode.search;
    var onChange = function onChange() {
        // @ts-expect-error
        onClick && onClick.apply(void 0, arguments);
    };
    var onInputClick = function onInputClick() {
        // @ts-expect-error
        onClick && onClick.apply(void 0, arguments);
    };
    var searchInputDynamicStyles = (_searchInputDynamicSt = {}, (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchBackgroundColor), search.default.backgroundColor), (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchColor), search.default.color), (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchBorderColor), search.default.borderColor), (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchFocusBorderColor), search.focus.borderColor), (0, $lrtwL.default)(_searchInputDynamicSt, (0, $9sI6P.varSearchHoverBackgroundColor), search.hover.backgroundColor), _searchInputDynamicSt);
    return (0, $2ZUkg.jsx)("div", {
        css: $46118ea46a2e1af5$var$searchInputContainerStyles,
        role: "search"
    }, (0, $2ZUkg.jsx)("div", {
        css: $46118ea46a2e1af5$var$searchInputIconStyles
    }, (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g1gzF))), {
        label: ""
    })), (0, $2ZUkg.jsx)("input", {
        style: searchInputDynamicStyles,
        css: [
            $46118ea46a2e1af5$var$searchInputStyles,
            $46118ea46a2e1af5$var$newSearchBorderStyles
        ],
        "aria-label": label,
        placeholder: placeholder,
        onChange: onChange,
        onClick: onInputClick,
        value: value
    }));
};
var $46118ea46a2e1af5$export$4b85d3515bd863a5 = function Search(props) {
    var placeholder = props.placeholder, tooltip = props.tooltip, label = props.label, value = props.value, iconButtonProps = (0, $gmKOS.default)(props, $46118ea46a2e1af5$var$_excluded);
    return (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, (0, $2ZUkg.jsx)($46118ea46a2e1af5$var$SearchComponent, {
        onClick: iconButtonProps.onClick,
        placeholder: placeholder,
        label: label,
        value: value || ""
    }), (0, $2ZUkg.jsx)((0, $2okzL.IconButton), (0, $djxp7.default)({
        css: $46118ea46a2e1af5$var$searchIconStyles,
        icon: (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g1gzF))), {
            label: label
        }),
        tooltip: tooltip
    }, iconButtonProps)));
};
var $46118ea46a2e1af5$export$2e2bcd8739ae039 = $46118ea46a2e1af5$export$4b85d3515bd863a5;

});
parcelRegister("g1gzF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba9998ab444a1668$var$_react = $ba9998ab444a1668$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $ba9998ab444a1668$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ba9998ab444a1668$var$SearchIcon = (props)=>/*#__PURE__*/ $ba9998ab444a1668$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.436 15.085l3.94 4.01a1 1 0 01-1.425 1.402l-3.938-4.006a7.5 7.5 0 111.423-1.406zM10.5 16a5.5 5.5 0 100-11 5.5 5.5 0 000 11z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ba9998ab444a1668$var$SearchIcon.displayName = "SearchIcon";
var $ba9998ab444a1668$var$_default = $ba9998ab444a1668$var$SearchIcon;
module.exports.default = $ba9998ab444a1668$var$_default;

});


parcelRegister("7sRIl", function(module, exports) {

$parcel$export(module.exports, "Settings", function () { return $56f4d0774543a202$export$c72f6eaae7b9adff; });

var $djxp7 = parcelRequire("djxp7");

var $gmKOS = parcelRequire("gmKOS");

var $iSvIT = parcelRequire("iSvIT");

var $hjM0l = parcelRequire("hjM0l");

var $2okzL = parcelRequire("2okzL");
var $56f4d0774543a202$var$_excluded = [
    "tooltip"
];
var $56f4d0774543a202$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(props, ref) {
    var tooltip = props.tooltip, iconButtonProps = (0, $gmKOS.default)(props, $56f4d0774543a202$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $2okzL.IconButton), (0, $djxp7.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hjM0l))), {
            label: typeof tooltip === "string" ? tooltip : "Settings Icon"
        }),
        ref: ref,
        tooltip: tooltip
    }, iconButtonProps)));
});
var $56f4d0774543a202$export$2e2bcd8739ae039 = $56f4d0774543a202$export$c72f6eaae7b9adff;

});
parcelRegister("hjM0l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0340ed3493689d0b$var$_react = $0340ed3493689d0b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fWDTK = parcelRequire("fWDTK");
function $0340ed3493689d0b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0340ed3493689d0b$var$SettingsIcon = (props)=>/*#__PURE__*/ $0340ed3493689d0b$var$_react.default.createElement($fWDTK.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.701 16.7a5.002 5.002 0 110-10.003 5.002 5.002 0 010 10.004m8.368-3.117a1.995 1.995 0 01-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 00.315-.574 8.947 8.947 0 00-.836-1.993.477.477 0 00-.598-.195 2.04 2.04 0 01-1.29.08 1.988 1.988 0 01-1.404-1.395 2.04 2.04 0 01.076-1.297.478.478 0 00-.196-.597 8.98 8.98 0 00-1.975-.826.479.479 0 00-.574.314 1.995 1.995 0 01-1.885 1.346 1.994 1.994 0 01-1.884-1.345.482.482 0 00-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 00-.198.582A2.002 2.002 0 014.445 7.06a.478.478 0 00-.595.196 8.946 8.946 0 00-.833 1.994.48.48 0 00.308.572 1.995 1.995 0 011.323 1.877c0 .867-.552 1.599-1.324 1.877a.479.479 0 00-.308.57 8.99 8.99 0 00.723 1.79.477.477 0 00.624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 00.168.628 8.946 8.946 0 002.11.897.474.474 0 00.57-.313 1.995 1.995 0 011.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 00.57.313 8.964 8.964 0 002.084-.883.473.473 0 00.167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 00.628-.19 8.925 8.925 0 00.728-1.793.478.478 0 00-.314-.573" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$0340ed3493689d0b$var$SettingsIcon.displayName = "SettingsIcon";
var $0340ed3493689d0b$var$_default = $0340ed3493689d0b$var$SettingsIcon;
module.exports.default = $0340ed3493689d0b$var$_default;

});





parcelRegister("f2a5L", function(module, exports) {

$parcel$export(module.exports, "PaidAccountCreation", function () { return $9ec365143654b648$export$8cfb1818275d36da; });
/* paid-account-creation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $3wnRY = parcelRequire("3wnRY");

var $2emKj = parcelRequire("2emKj");

var $axg8K = parcelRequire("axg8K");

var $9DfPf = parcelRequire("9DfPf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $gFK1O = parcelRequire("gFK1O");

var $lrVTP = parcelRequire("lrVTP");

var $8Ct52 = parcelRequire("8Ct52");

var $csseQ = parcelRequire("csseQ");
const $9ec365143654b648$export$8cfb1818275d36da = ({ darkSolidTheme: darkSolidTheme, showFourSocialButtons: showFourSocialButtons, auxiaResponse: auxiaResponse })=>{
    const { product: product } = (0, $iMdoL.useUserContext)();
    const i18n = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const isAuxiaPage = (0, $iMdoL.useJiraServiceManagementIntent)() && (0, $3wnRY.isAuxiaServedPage)(auxiaResponse);
    const logInLink = (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
            text: text,
            "aria-label": text,
            type: "inline",
            href: (0, $jgJpJ.getLoginUrl)(location),
            onClick: ()=>{
                if (isAuxiaPage) {
                    const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                    (0, $2emKj.sendAnalyticsToAuxia)({
                        anonymousId: anonymousId,
                        treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                        treatmentId: auxiaResponse.treatmentId,
                        interactionType: "CLICKED",
                        interactionTimeMicros: (0, $2emKj.convertDateTimeToInteractionTimeMicros)(Date.now()),
                        actionName: "login_button"
                    });
                }
            }
        });
    const loginText = i18n.formatMessage({
        id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
        defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
    }, {
        product: product === null || product === void 0 ? void 0 : product.description,
        logInLink: logInLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
        Input: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                darkSolidTheme && "_ie4m121t _frvh121t _q7r4cd5j",
                !darkSolidTheme && "_frvh1p0d _ie4m1cjc"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Input), {})
        }),
        Login: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_26vxviql",
                darkSolidTheme && "_43ds121t"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.AnimatedSocialProof), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Login), {
                    loginText: loginText
                })
            ]
        }),
        Social: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                showFourSocialButtons && "_jk741ezz _zs121ylp _1b94glyw"
            ]),
            children: [
                !isAuxiaPage && !showFourSocialButtons && /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Social), {
                    providers: {
                        google: "Google",
                        microsoft: "Microsoft"
                    }
                }),
                !isAuxiaPage && showFourSocialButtons && /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Social), {}),
                isAuxiaPage && !showFourSocialButtons && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Ct52.AuxiaSocial), {
                    providers: {
                        google: "Google",
                        microsoft: "Microsoft"
                    },
                    auxiaResponse: auxiaResponse
                }),
                isAuxiaPage && showFourSocialButtons && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Ct52.AuxiaSocial), {})
            ]
        }),
        Submit: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                darkSolidTheme && "_7dirhyuj _d32v16l4 _6pup1s4t _4pkp16l4"
            ]),
            style: {
                "--_1f8eaoq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow400"))
            },
            children: [
                !isAuxiaPage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.Submit), {}),
                isAuxiaPage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $csseQ.AuxiaSubmit), {
                    auxiaResponse: auxiaResponse
                })
            ]
        })
    });
};
const $9ec365143654b648$var$socialWrapperStyle = null;
const $9ec365143654b648$var$loginSocialProofCss = null;
const $9ec365143654b648$var$yellowButtonCss = null;
const $9ec365143654b648$var$whiteLinkCss = null;
const $9ec365143654b648$var$whiteTextCss = null;
const $9ec365143654b648$var$darkGrayTextCss = null;

});
parcelRegister("3wnRY", function(module, exports) {

$parcel$export(module.exports, "isAuxiaServedPage", function () { return $874fe77c2166f21b$export$d387d4c6b79063ea; });
$parcel$export(module.exports, "isAuxiaResponseMalformed", function () { return $874fe77c2166f21b$export$b9e49162afc62078; });

var $gAJUc = parcelRequire("gAJUc");
function $874fe77c2166f21b$var$isValidAuxiaResponse(auxiaResponse) {
    return auxiaResponse !== null && auxiaResponse !== undefined && typeof auxiaResponse.treatmentId === "string" && typeof auxiaResponse.treatmentTrackingId === "string" && auxiaResponse.treatmentId.length > 0 && auxiaResponse.treatmentTrackingId.length > 0 && Array.isArray(auxiaResponse.auxiaTreatment) && auxiaResponse.auxiaTreatment.length > 0;
}
const $874fe77c2166f21b$export$d387d4c6b79063ea = (auxiaResponse)=>{
    const usingAuxiaTreatment = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jsmPaidLpAuxiaIntegration);
    return usingAuxiaTreatment && $874fe77c2166f21b$var$isValidAuxiaResponse(auxiaResponse);
};
const $874fe77c2166f21b$export$b9e49162afc62078 = (auxiaResponse)=>{
    const usingAuxiaTreatment = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jsmPaidLpAuxiaIntegration);
    return usingAuxiaTreatment && !$874fe77c2166f21b$var$isValidAuxiaResponse(auxiaResponse);
};

});

parcelRegister("2emKj", function(module, exports) {

$parcel$export(module.exports, "convertDateTimeToInteractionTimeMicros", function () { return $500b74bf812140d1$export$1219d02973c84a52; });
$parcel$export(module.exports, "sendAnalyticsToAuxia", function () { return $500b74bf812140d1$export$3d1788c6d7ad0255; });
const $500b74bf812140d1$var$setWindowAnalyticsObject = ({ interactionType: interactionType, wasSent: wasSent })=>{
    if (interactionType === "VIEWED") // @ts-ignore
    window.sentViewedAuxiaAnalytics = wasSent.toString();
    else if (interactionType === "CLICKED") // @ts-ignore
    window.sentClickedAuxiaAnalytics = wasSent.toString();
};
const $500b74bf812140d1$export$1219d02973c84a52 = (dateTime)=>{
    const microSeconds = dateTime * 1000;
    return microSeconds.toString();
};
const $500b74bf812140d1$export$3d1788c6d7ad0255 = async ({ anonymousId: anonymousId, treatmentTrackingId: treatmentTrackingId, treatmentId: treatmentId, interactionType: interactionType, interactionTimeMicros: interactionTimeMicros, actionName: actionName })=>{
    const url = "https://apis.auxia.io/v1/LogTreatmentInteraction";
    const auxiaRequest = {
        projectId: "1921",
        userId: anonymousId,
        treatmentTrackingId: treatmentTrackingId,
        treatmentId: treatmentId,
        surface: "LANDING_PAGE_JSM",
        interactionType: interactionType,
        interactionTimeMicros: interactionTimeMicros,
        languageCode: "en",
        actionName: actionName || ""
    };
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "AIzaSyCUlO-ukAKTA1Khu87fez3UspN5PEtFOsY"
            },
            body: JSON.stringify(auxiaRequest)
        });
        const data = await response.json();
        const stringData = JSON.stringify(data);
        const responseContainsError = stringData !== "{}";
        if (responseContainsError) throw Error(`Auxia did not properly receive analytics: ${stringData}`);
        $500b74bf812140d1$var$setWindowAnalyticsObject({
            interactionType: interactionType,
            wasSent: true
        });
    } catch (e) {
        console.error(`sendAnalyticsToAuxia call error:
                        Request Body: ${JSON.stringify(auxiaRequest)}
                        Error: ${e}
                    `);
    }
};

});

parcelRegister("8Ct52", function(module, exports) {

$parcel$export(module.exports, "AuxiaSocial", function () { return $b83cbb7845080c0f$export$fe45cc996003fded; });
/* paid-jsm-account-creation-social-auxia.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $3wnRY = parcelRequire("3wnRY");

var $2emKj = parcelRequire("2emKj");

var $axg8K = parcelRequire("axg8K");

var $gFK1O = parcelRequire("gFK1O");
const $b83cbb7845080c0f$export$fe45cc996003fded = ({ providers: providers, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $f6qj2.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $axg8K.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers);
    const buttonGridCss = null;
    const buttonListCss = null; /* eslint-disable jsx-a11y/no-redundant-roles */ 
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        role: "list",
        className: (0, $esG4f.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $axg8K.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signup",
                        defaultMessage: "sign up with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>{
                        if ((0, $3wnRY.isAuxiaServedPage)(auxiaResponse)) {
                            const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                            (0, $2emKj.sendAnalyticsToAuxia)({
                                anonymousId: anonymousId,
                                treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                                treatmentId: auxiaResponse.treatmentId,
                                interactionType: "CLICKED",
                                interactionTimeMicros: (0, $2emKj.convertDateTimeToInteractionTimeMicros)(Date.now()),
                                actionName: `${provider}_login`
                            });
                        }
                        return onClickSocialButton(provider);
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};

});

parcelRegister("csseQ", function(module, exports) {

$parcel$export(module.exports, "AuxiaSubmit", function () { return $12eb4e2041cefa71$export$f9bc420969cdc1a3; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3wnRY = parcelRequire("3wnRY");

var $2emKj = parcelRequire("2emKj");

var $91nJf = parcelRequire("91nJf");

var $axg8K = parcelRequire("axg8K");

var $gFK1O = parcelRequire("gFK1O");
const $12eb4e2041cefa71$export$f9bc420969cdc1a3 = ({ buttonText: buttonText, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $f6qj2.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $axg8K.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: ()=>{
            if ((0, $3wnRY.isAuxiaServedPage)(auxiaResponse)) {
                const anonymousId = decodeURIComponent((0, $gFK1O.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                (0, $2emKj.sendAnalyticsToAuxia)({
                    anonymousId: anonymousId,
                    treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                    treatmentId: auxiaResponse.treatmentId,
                    interactionType: "CLICKED",
                    interactionTimeMicros: (0, $2emKj.convertDateTimeToInteractionTimeMicros)(Date.now()),
                    actionName: "sign_up"
                });
            }
            return onClickSubmitButton();
        },
        children: buttonText
    });
};

});



parcelRegister("ka2Mp", function(module, exports) {

$parcel$export(module.exports, "PaidHeroSectionTypes", function () { return $f0451b41d7e12a5e$export$f14a1c5ae1fdb785; });
/* paid-hero-section-types.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $f0451b41d7e12a5e$var$heroStyles = {
    "jira-software": "_bfhkuzct _1itk1mj5 _ouxlsfij _12vemgnk _1lrw16om _1rmv1nmc",
    "jira-software-anchor": "_syazr3uz _bfhkdoyu _1ndau67f _1twl8n31 _r8nt1nn1 _7gaj1h6o",
    "jira-software-rebranded-anchor": "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw",
    "jira-service-management": "_ct361wug _11q71yp8",
    "jira-service-management-anchor": "_syazr3uz _bfhkdoyu _1ndau67f _1twl8n31 _r8nt1nn1 _7gaj1h6o",
    "confluence-paid": "_16qs1qj0 _1itk1yrd _ouxlroey _12veeva1 _1lrw13e2",
    "confluence-anchor": "_16qs1qj0 _1itkr87c _ouxl1ssb _12vemgnk _1lrw1dfr _1rmvw151 _1f9f8d6s _r2cimgnk _u6yg1f51",
    "confluence-rebranded-anchor": "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw"
};
const $f0451b41d7e12a5e$var$JSMRebrandedAnchorBackground = null;
const $f0451b41d7e12a5e$var$darkThemeEmailForm = null;
const $f0451b41d7e12a5e$var$defaultHeroStyles = null;
const $f0451b41d7e12a5e$var$padding = null;
const $f0451b41d7e12a5e$export$f14a1c5ae1fdb785 = ({ darkSolidTheme: darkSolidTheme, landingType: landingType, heroComponent: heroComponent, showAnimatedHero: showAnimatedHero, showNewHero: showNewHero })=>{
    const customHero = !darkSolidTheme && showNewHero && $f0451b41d7e12a5e$var$heroStyles[landingType];
    const defaultHero = !darkSolidTheme && !showNewHero && $f0451b41d7e12a5e$var$defaultHeroStyles;
    const isRebrandedJSMHero = darkSolidTheme && showNewHero && landingType === "jira-service-management-anchor";
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "start-trial",
        className: (0, $esG4f.default)([
            showAnimatedHero && darkSolidTheme && "_bfhk17la _syazcd5j _n3c5cd5j _h4c66nkb _4pvyr2ho _1ajj1s4t _235jr2ho _dadmcd5j _128a121t _1ro31q34",
            showAnimatedHero && !darkSolidTheme && showNewHero && $f0451b41d7e12a5e$var$heroStyles[landingType],
            showAnimatedHero && !darkSolidTheme && !showNewHero && "_bfhkuzct _1itk1mj5 _ouxlsfij _12vemgnk _1lrw16om _ij141nmc",
            !showAnimatedHero && $f0451b41d7e12a5e$var$heroStyles[landingType],
            isRebrandedJSMHero && "_bfhk1ism",
            "_1q511wqb"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1oxqp4m": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.yellow300"))
        },
        children: heroComponent
    });
};
$f0451b41d7e12a5e$export$f14a1c5ae1fdb785.displayName = "PaidHero";

});

parcelRegister("l0hW2", function(module, exports) {

$parcel$export(module.exports, "PaidTabsSection", function () { return $14750b23f3088979$export$4db38360327330ee; });
/* paid-tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("5IQ8d");
var $8VcJD = parcelRequire("8VcJD");
const $14750b23f3088979$var$anchorStyles = null;
const $14750b23f3088979$var$jsmAndConfTabsStyles = null;
const $14750b23f3088979$export$4db38360327330ee = (tabsProps)=>{
    const { styles: tabsStyles, landingType: landingType } = tabsProps, otherTabsProps = (0, $akGnX._)(tabsProps, [
        "styles",
        "landingType"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            landingType === "jira-software-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "jira-service-management-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "jira-service-management-anchor" && "_kbzovh8j _1spxdgqm _balx1vrj _fptxvh8j",
            landingType === "confluence-rebranded-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "confluence-rebranded-anchor" && "_kbzovh8j _1spxdgqm _balx1vrj _fptxvh8j",
            "tabs-section"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8VcJD.PaidTabs), (0, $7Knp0._)({}, otherTabsProps))
    });
};
$14750b23f3088979$export$4db38360327330ee.displayName = "PaidTabs";

});
parcelRegister("5IQ8d", function(module, exports) {
$parcel$export(module.exports, "PaidTabs", function () { return (parcelRequire("8VcJD")).PaidTabs; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("8VcJD")).PaidTabs; });

var $8VcJD = parcelRequire("8VcJD");

});
parcelRegister("8VcJD", function(module, exports) {

$parcel$export(module.exports, "PaidTabs", function () { return $b5ac358d9c704444$export$699a6a05a32d157; });
/* paid-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("85QdM");
var $fILoL = parcelRequire("fILoL");

var $gXzhc = parcelRequire("gXzhc");

var $4XrxY = parcelRequire("4XrxY");
parcelRequire("D0EyQ");
var $g8Gdb = parcelRequire("g8Gdb");

var $37w71 = parcelRequire("37w71");
const $b5ac358d9c704444$var$tabCustomStyles = null;
const $b5ac358d9c704444$var$tabSectionTitleStyles = null;
const $b5ac358d9c704444$var$singleTabStyles = null;
const $b5ac358d9c704444$var$pullQuotesContainerStyles = null;
const $b5ac358d9c704444$var$renderChecklist = (tab)=>{
    var _tab_listItems;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g8Gdb.default), {
        title: tab.title,
        listItems: (_tab_listItems = tab.listItems) !== null && _tab_listItems !== void 0 ? _tab_listItems : [],
        imageSrc: tab.picture.image.src,
        imageAlt: tab.picture.image.alt
    });
};
const $b5ac358d9c704444$var$renderBodyText = (tab)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $37w71.default), {
        headerText: tab.title,
        headerType: "h3",
        bodyText: tab.body,
        imageLink: tab.picture.image.src,
        imageAltText: tab.picture.image.alt,
        alignItems: "top",
        rowProps: "4-8",
        className: "simple-image-text-side-tabs"
    });
};
const $b5ac358d9c704444$var$generateTabs = (tabsViaProps)=>{
    const transformedTabs = tabsViaProps.map((tab)=>{
        var _tab_listItems;
        var _tab_pullQuote_isShowBorder;
        return {
            textLabel: tab.textLabel,
            id: tab.id,
            component: /*#__PURE__*/ (0, $loA2J.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                children: [
                    ((_tab_listItems = tab.listItems) === null || _tab_listItems === void 0 ? void 0 : _tab_listItems.length) ? $b5ac358d9c704444$var$renderChecklist(tab) : $b5ac358d9c704444$var$renderBodyText(tab),
                    tab.pullQuote && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1q517vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fILoL.PullQuote), {
                            logoSrc: tab.pullQuote.logoSrc,
                            logoAltText: tab.pullQuote.logoAltText,
                            quoteBlurb: tab.pullQuote.quoteBlurb || "",
                            quoteCompany: tab.pullQuote.quoteCompany || "",
                            quoteName: tab.pullQuote.quoteName || "",
                            isShowBorder: (_tab_pullQuote_isShowBorder = tab.pullQuote.isShowBorder) !== null && _tab_pullQuote_isShowBorder !== void 0 ? _tab_pullQuote_isShowBorder : false,
                            isUsingTextQuotationMarks: tab.pullQuote.isUsingTextQuotationMarks
                        })
                    })
                ]
            })
        };
    });
    return transformedTabs;
};
const $b5ac358d9c704444$export$699a6a05a32d157 = ({ headerText: headerText, tabStyles: tabStyles, tabs: tabs, tabsConfig: tabsConfig, dataProductKey: dataProductKey, layout: layout = "8" })=>{
    var _tabs_;
    tabs = tabsConfig ? $b5ac358d9c704444$var$generateTabs(tabsConfig) : tabs !== null && tabs !== void 0 ? tabs : [];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_19pk1ylp _otyr1wqb _btm9gktf _hywlokh7 _rpgtoxwj _1dl31k92 _1o4gidpf _1g2bidpf _16rridpf _1x1cidpf _1j4q1oe7 _1w42mw4m _1i7w1bqd _1qf41k92 _11451k8s"
        ]),
        children: tabs.length === 1 ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb _1kmxidpf _1ggmzwfg _1ykzidpf _1maezwfg _11ebviql _1kll1k8s"
            ]),
            children: (_tabs_ = tabs[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.component
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: layout,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _1wyb1k8s _6rth1ylp _k48pbfng _syaz1bqd _1gw8ahaf"
                        ]),
                        children: headerText
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gXzhc.default), {
                    tabContentType: "custom",
                    tabs: tabs,
                    id: "tabs",
                    label: "tabs",
                    colors: tabStyles,
                    dataProductKey: dataProductKey
                })
            ]
        })
    });
};

});





//# sourceMappingURL=confluence-software-anchor-lp-automation.58a0b85a.js.map
